{
  "quota": {
    "titre": "Limit reached",
    "msg": "Your plan has reached its limit for this feature. Upgrade to a higher plan to add more.",
    "msgObjets": "This inventory has reached your plan's maximum number of items. Upgrade to a higher plan to add more.",
    "msgCategories": "You have reached your plan's maximum number of categories for this inventory.",
    "msgProprietes": "You have reached your plan's maximum number of properties for this inventory.",
    "msgPhotosObjet": "Your plan limits the number of photos per item. Upgrade to a higher plan to add more.",
    "msgPhotoCat": "Your plan limits the number of photos per category."
  },
  "tuto": {
    "precedent": "Back",
    "suivant": "Next",
    "terminer": "Done",
    "reduire": "Minimise tutorial",
    "pratique": "Try it yourself",
    "choisirPratique": "Choose a hands-on exercise"
  },
  "aide": {
    "aideFonction": "Help",
    "tutoriel": "Tutorial",
    "lancerTutoriel": "Start tutorial",
    "voirTutoriels": "See tutorials",
    "choisirTutoriel": "Choose a tutorial",
    "general": "overview",
    "pages": "pages",
    "tutoriels": "Tutorials",
    "pratiques": "Hands-on",
    "voir": "View",
    "faire": "Do",
    "manuel": "Help and manual",
    "titre": "Help"
  },
  "finances": {
    "titre": "Finances",
    "horizon": "Projection horizon",
    "cumul": "Cumulative",
    "recurrentesPrises": "recurring item(s)",
    "impactMensuel": "Average monthly impact",
    "totalMensuel": "Monthly total",
    "moisCourant": "Current month",
    "duree": "Duration",
    "dureeLibre": "Custom duration",
    "reinitPeriode": "Reset period",
    "modeGraphique": "Chart",
    "modeSuivi": "Tracking",
    "suiviPrevu": "Planned",
    "suiviReel": "Actual",
    "suiviEcart": "Diff.",
    "vueMois": "Tracking",
    "ongletProjection": "Projection",
    "tresorerieActuelle": "Current cash",
    "soldeProjete": "Projected balance",
    "aucunePrevision": "No planned line",
    "aucunePrevisionAide": "Create planned lines (Budget tab) to see where your cash will stand in the coming months.",
    "tousBudgets": "All",
    "moisVide": "Nothing planned or spent this month.\nAdd a planned line with ＋.",
    "aucuneLigne": "No planned line yet.",
    "etatDuMois": "This month's status",
    "filtrer": "Filter",
    "filtrerTrier": "Filter and sort",
    "tri": "Sort",
    "tri_statut": "Needs attention first",
    "tri_libelle": "Name (A → Z)",
    "tri_montant": "Planned amount (highest first)",
    "tri_ecart": "Largest difference",
    "rechercherPh": "Search a name or an amount",
    "comptes": "Accounts",
    "nouveauCompte": "New account",
    "modifierCompte": "Edit account",
    "comptePh": "E.g. Main current, Savings…",
    "typeCompte": "Account type",
    "cpt_courant": "Current",
    "cpt_epargne": "Savings",
    "cpt_credit": "Card / credit",
    "cpt_autre": "Other",
    "banque": "Bank",
    "fin4": "Last 4",
    "soldeDepart": "Opening balance",
    "soldeDepartAide": "The account balance at the date below. It is the reference point: if the computed balance no longer matches your bank's, some transactions are missing.",
    "dateSolde": "As of",
    "totalComptes": "All accounts",
    "aucunCompte": "No account",
    "aucunCompteAide": "Create one account per real bank account. Every imported transaction is linked to it: you know where the money comes from, and transfers between your accounts get detected.",
    "compteDuReleve": "Account for this statement",
    "compteInconnu": "This statement comes from an unknown account — pick one, the link will be remembered.",
    "transfertsDetectes": "Transfers between your accounts",
    "transfertsAide": "Same amount, opposite directions, different accounts, close dates. Confirm with ⊘ to exclude them from totals — nothing happens without you.",
    "confirmerCompte": "Is this statement really for “{compte}”?",
    "releveResume": "{n} transaction(s) · from {du} to {au} · {debits} out, {credits} in",
    "ouiCEstBien": "Yes, import",
    "vChoisirCompte": "Pick the destination account first.",
    "vAutreCompte": "This statement carries account number {acctid}, which belongs to ANOTHER account. Import blocked.",
    "vNomFichier": "The file name contains “{fin4}”, but this account ends with “{attendu}”. Please check before continuing.",
    "vDejaAilleurs": "{n} transaction(s) from this statement already exist on another account — it may have been imported there already.",
    "imprevus": "Unplanned",
    "nonPrevu": "unplanned",
    "horsCalcul": "Excluded",
    "interne": "internal transfer",
    "actInterne": "Internal transfer (excluded)",
    "actReintegrer": "Include in totals again",
    "interneAide": "A transfer between your own accounts is neither a real debit nor a credit: it stays visible, but counts in no total.",
    "reste": "left",
    "depasse": "over by",
    "st_realisee": "done",
    "st_partielle": "partial",
    "st_manquante": "no linked operation",
    "st_ignoree": "ignored",
    "st_absente": "did not happen",
    "st_avenir": "upcoming",
    "nouvelleLigne": "New planned line",
    "modifierLigne": "Edit planned line",
    "libellePlaceholder": "E.g. Rent, Salary, Groceries…",
    "montantPrevu": "Planned amount",
    "sansFinAide": "With no end date, the line repeats indefinitely.",
    "actQue": "What would you like to do?",
    "actModifierLigne": "Edit planned line",
    "actAbsente": "Mark as: did not happen",
    "actIgnorer": "Ignore this month",
    "actRetablir": "Reset (normal calculation)",
    "actSupprimerLigne": "Delete planned line",
    "actRattacher": "Link to a planned line",
    "actCreerLigne": "＋ Create a planned line",
    "suiviNonPointe": "unreconciled",
    "suiviHint": "Planned vs actual per column over {n} months. The difference (actual − planned, green = favourable) is on the name row; Planned and Actual below.",
    "suiviEcartSeul": "Gaps only",
    "suiviAucun": "No movement linked to a recurrence over the period. Confirm due dates to feed the tracking.",
    "suiviTout": "All",
    "echelleColonnes": "Scale:",
    "evolution": "Over time",
    "aRattacher": "to attach",
    "operationsRattachees": "Linked movements",
    "aucuneOpRattachee": "No linked movement yet.",
    "detacher": "Detach",
    "rattachables": "Attachable movements",
    "aucuneRattachable": "No movement to suggest (close amount).",
    "de": "from",
    "a": "to",
    "depuis": "Since",
    "budget": "Budget",
    "triDate": "By date",
    "sourceRec": "Recurring",
    "sourcePonct": "One-off",
    "sourceTout": "Both",
    "ponctuelle": "One-off (actual)",
    "compteDansTotaux": "Counted in totals",
    "sensRevenus": "credits",
    "sensDepenses": "debits",
    "vueSoldes": "Balances",
    "aucunSolde": "No shared budget where you have a share or have paid.",
    "onTeDoit": "You are owed",
    "tuDois": "You owe",
    "equilibre": "Settled",
    "maPosition": "My position",
    "jusqua": "until",
    "teDoit": "{nom} owes you",
    "tuDoisA": "You owe {nom}",
    "parCalendrier": "By calendar",
    "parCategorie": "By category",
    "parPersonne": "By person",
    "reelParPersonne": "Actuals · by person",
    "previsionParPersonne": "Forecast · by person",
    "coutBudget": "Budget cost",
    "jaiPaye": "I paid",
    "maPart": "My share",
    "rembRecu": "Reimbursement received",
    "rembVerse": "Reimbursement paid",
    "mesSoldesNote": "Per person: + green = you are owed · − red = you owe, detailed by budget (confirmed reimbursements included). Tap a budget to open it (and reimburse).",
    "operationsPonct": "Operations",
    "reference": "Reference",
    "plusAncienne": "Oldest",
    "plusRecente": "Latest",
    "calerDebut": "Set start",
    "calerFin": "Set end",
    "calerDebutAide": "“Oldest” sets the start to the oldest linked operation. When linking, the start moves back automatically if needed.",
    "echeancier": "Schedule (dates + amounts)",
    "echeancierAide": "Add each instalment by hand: date + amount + direction (− debit / + credit). Ideal for taxes. These instalments feed the projection.",
    "ajouterEcheance": "Add a due date",
    "echeancierVide": "Add at least one entry (date + amount).",
    "rendreRecurrente": "Make recurring",
    "rendreRecurrenteAide": "Creates a recurring item (monthly by default, adjustable) from these operations and links them. Start = oldest operation. Choose the end:",
    "rrAvecFin": "End = latest",
    "rrSansFin": "No end (ongoing)",
    "rendreRecurrenteOk": "Recurring item created and {n} operation(s) linked. Adjust frequency/amount in its editor if needed.",
    "refDepuisOp": "Reference amount from an operation",
    "refAide": "“Reference” uses the amount of a linked operation as the projection base. Otherwise, enter the amount manually (useful if the rise is one-off or operations aren't reliable yet).",
    "refPickAide": "Tap an operation (most recent to oldest) to make it the new reference amount.",
    "aucunePonct": "No one-off operation (not attached to a recurrence).",
    "aucuneOpPeriode": "No operation for {periode}.",
    "notePonct": "Actual operations not attached to a recurrence, grouped by category. Past only (no projection). “Cumulative” = actual balance of these operations.",
    "moisPayes": "Paid months (actual)",
    "moisProjetes": "Projected months",
    "graphNet": "Net",
    "graphNetPeriode": "Period net",
    "graphRevenus": "Credits",
    "graphDepenses": "Debits",
    "graphCumule": "Cumulative balance",
    "graphEmpile": "Stacked",
    "graphLignes": "Lines",
    "graphCategories": "Categories",
    "graphBientot": "Coming soon",
    "soldeFinal": "Final balance",
    "budgetsAffiches": "Displayed budgets",
    "sansCalendrier": "No calendar",
    "toutAfficher": "Show all",
    "toutMasquer": "Hide all",
    "mois": "Month",
    "annee": "Year",
    "noteGraphique": "Bars = net of each period · Curve = projected cumulative balance. Tap/hover for details. Same filters, groupings and period as the Planning.",
    "jour": "on day",
    "inactive": "inactive",
    "toutes": "All",
    "actives": "Active",
    "inactives": "Inactive",
    "triJour": "Day",
    "aucuneRecurFiltre": "No recurring item for this filter.",
    "modeListe": "List",
    "modePlanning": "Planner",
    "planMoisCourt": "Months",
    "planAnsCourt": "Yrs",
    "planDecCourt": "Dec.",
    "toutMois": "Expand all (months)",
    "replierAnnees": "Collapse to years",
    "replierDecennies": "Collapse to decades",
    "niveau": "Level",
    "niv_calendrier": "Calendar",
    "niv_budget": "Budget",
    "niv_categorie": "Category",
    "augmentation": "Increase",
    "avec": "With",
    "sans": "Without",
    "dateFin": "End date",
    "avecFin": "With end",
    "sansFin2": "No end",
    "dateFinFiltre": "End (date)",
    "avant": "Before",
    "leMois": "On month",
    "apres": "After",
    "planMois": "Months",
    "planAnnee": "Years",
    "ans": "yr",
    "moisCourt": "m",
    "recurrente": "Recurring item",
    "cumule": "Cumulative",
    "notePlanning": "Projected cost of each recurring item period by period (inflation included). \"Cumulative\" = projected balance. Tap a row to edit it.",
    "editerRecurrente": "Edit recurring item",
    "nouvelleRecurrente": "New recurring item",
    "calendrier": "Calendar",
    "choisirCalendrier": "Pick a calendar first.",
    "debut": "Start",
    "fin": "End",
    "optionnel": "optional",
    "sansFin": "No end",
    "inflation": "Inflation (long-term projection)",
    "tauxAnnuel": "Rate %/yr",
    "depuisMois": "From month",
    "inflationAide": "Annual compound rate: the amount rises by the rate from the given month, then on each anniversary. Leave empty or 0 = no inflation.",
    "inflationCourte": "+{taux}%/yr",
    "sansInflation": "no inflation",
    "moyCourte": "avg. {m}",
    "creditBascule": "Line type",
    "creditClassique": "Classic",
    "credit": "Loan",
    "creditMensualiteConnue": "Known monthly payment",
    "creditMode": "Entry mode",
    "creditModeMensualite": "Known monthly payment",
    "creditModeParams": "Loan parameters",
    "creditModeMensualiteAide": "The amount above IS the total monthly payment (insurance included). The remaining principal at the reference date is used to split interest and principal, month by month.",
    "creditModeParamsAide": "The monthly payment is CALCULATED from the borrowed principal, the rate, and the term — no need to know it in advance.",
    "creditCapital": "Principal",
    "creditTaux": "Annual rate (%)",
    "creditDateRef": "Reference date",
    "creditDateRefVide": "YYYY-MM",
    "creditDateRefAideMensualite": "The month the principal above was owed. Empty = the line's Start.",
    "creditDateRefAideParams": "The month the loan starts (first drawdown if any). Empty = the line's Start.",
    "creditDuree": "Term",
    "creditDiffere": "Grace period (months)",
    "creditAssurance": "Monthly insurance",
    "creditMensualiteEstimee": "Estimated monthly payment: {m}",
    "creditAvance": "Advanced — tiers, drawdowns",
    "creditPaliers": "Tiers",
    "creditPaliersAide": "Different monthly payments per period (e.g. a stepped rate). The last segment automatically pays off what remains.",
    "creditAjouterPalier": "Add a tier",
    "creditPalierMensualite": "Monthly payment",
    "creditPalierDuree": "Duration (months)",
    "creditDeblocages": "Progressive drawdowns",
    "creditDeblocagesAide": "For a construction loan: the principal is released in several installments, with interim interest on what's already drawn. Each row's % accumulates up to 100.",
    "creditAjouterDeblocage": "Add a drawdown",
    "creditRembCapitalDeblocage": "Repay principal as it's drawn down",
    "creditErreurParams": "Enter the borrowed principal AND the term (months) to calculate the payment — saving stays blocked until both are set.",
    "creditErreurMensualite": "Enter the known monthly payment above.",
    "recurrenteActive": "Recurring item active",
    "dateInvalide": "Invalid date (expected YYYY-MM-DD, or YYYY-MM for inflation).",
    "finAvantDebut": "The end date must be after the start date.",
    "totalGlobal": "This month's result",
    "resultatPaye": "This month's result (paid)",
    "restant": "Remaining to pay",
    "estimation": "Month estimate",
    "aucun": "No transactions this month.",
    "mouvements": "entries",
    "changerNature": "kind",
    "vueCalendriers": "Calendars",
    "vueCategories": "Categories",
    "vueSynthese": "Summary",
    "vueTableau": "Grid",
    "vueProjection": "Forecast",
    "total": "Total",
    "categorie": "Category",
    "totalProjection": "12-month total",
    "noteProjection": "All your recurring items (across calendars). Tap one to edit it. The forecast appears in the Synthesis (upcoming month/year).",
    "aucuneRecurProjection": "No recurring items. Add some in a budget (Family → Budget); they will feed the Synthesis estimate.",
    "note": "Tap a calendar (Calendars view) to change its kind. Coming soon: caps and forecast.",
    "triMontantOp": "Amount (descending)",
    "sensEntrees": "Credits only",
    "sensSorties": "Debits only",
    "masquerHorsCalcul": "Hide internal transfers",
    "masquerHorsCalculAide": "They are shown by default: that money did leave the account, and hiding it would make the list disagree with the balance.",
    "ongletBudget": "Budget",
    "partDe": "part of {total}",
    "honore": "What this transaction covers",
    "configBudget": "Configuration",
    "soldeBanqueLigne": "Bank-reported balance: {solde} on {date}",
    "rapprochementTitre": "Bank reconciliation",
    "rapprochementMsg": "The bank reports {banque} on {date}; the app computes {calcule} — a {ecart} gap. Reset the account to the bank balance?",
    "recalerSolde": "Reset the balance",
    "sansPrevision": "No planned line",
    "unSeulMois": "A single month",
    "etalerSur": "Spread over",
    "moisMot": "months",
    "etaleAide": "≈ {m} per month — each remaining month re-forecasts from what has already been recorded.",
    "basculerSynthese": "Show or hide the summary",
    "filtreEcheancesMois": "With a due date this month",
    "triDefaut": "Original order",
    "lignesDuMois": "Planned lines · {mois}",
    "resteAffecter": "Left to allocate",
    "selLignesAide": "Tick one or more lines — each share can be set in € or %.",
    "aucuneLigneMois": "No planned line is due this month.",
    "ficheLignesPrevues": "Planned lines",
    "ficheBudgetNominal": "Nominal line amounts, all frequencies combined.",
    "supprBudgetLignes": "\"{nom}\" contains {n} planned line(s): delete them or move them to another envelope first.",
    "nonApplicables": "Not applicable this month",
    "nonApplicablesAide": "These plans exist, but their settings do not make them due this month.",
    "nd_avantDebut": "starts in {mois}",
    "nd_apresFin": "ended in {mois}",
    "nd_frequence": "next due: {mois}",
    "nd_ponctuelle": "one-off · {mois}",
    "nd_horsEcheancier": "next due: {mois}",
    "nd_inactive": "disabled",
    "nd_sansDebut": "no start date",
    "nd_inexistante": "—",
    "nd_moisInvalide": "—",
    "nd_creditInvalide": "incomplete loan parameters",
    "periodeDepuis": "since {mois}",
    "periodeJusqua": "until {mois}",
    "prochainesEcheances": "Next due dates",
    "echeancesPassees": "Past due dates",
    "echeancesAnciennes": "{n} older",
    "st_soldee": "validated",
    "actSolder": "Fully used",
    "actSolderAide": "The remainder will not be spent: this due date no longer claims anything.",
    "resteADepenser": "Left to spend",
    "dejaRattacheAilleurs": "already used for this plan",
    "montantPartAide": "Change the amount to assign only part of the transaction: the remainder stays available for another plan.",
    "vueParEnveloppe": "By envelope",
    "rattacherOps": "Attach transactions",
    "selectionnees": "{n} selected",
    "abandonner": "Discard changes?",
    "reinitFiltres": "Reset filters",
    "fMontant": "Amount",
    "fPeriode": "Period",
    "fCompte": "Account",
    "fRattachement": "Attachment",
    "mExact": "Exact",
    "mTous": "All",
    "rNon": "Not attached",
    "rOui": "Attached",
    "rToutes": "All",
    "choisirMois": "Pick a month",
    "moisAffectation": "Assigned month",
    "reinitMoisOp": "Back to transaction month",
    "toutAffecter": "Assign all to…",
    "ceBudget": "this plan",
    "partPrise": "would take {pct}%",
    "aucuneApresFiltre": "No transaction matches the filters.",
    "toastRattache": "{n} transaction(s) attached{autres}",
    "toastAutres": " · {n} other plan(s) recalculated",
    "dejaRattacheMois": "Already linked to this month",
    "rienDePlusMois": "Validate this month",
    "rienDePlusAide": "Validating freezes this month: the remainder will not be spent, even if the forecast is not met.",
    "rouvrirMois": "Unvalidate this month",
    "moisSoldeAide": "This month is validated. Unvalidating restores the amount left to spend.",
    "st_couverte": "linked, to validate",
    "modeProposees": "Suggestions — search to see every operation",
    "modeToutes": "All operations, matching your search",
    "vueListe": "List view",
    "reelMoyen": "Actual average",
    "surNMois": "over {n} months",
    "horsMois": "out of month",
    "rattachees": "linked",
    "viaPrevision": "via the forecast",
    "toutDetacher": "Unlink everything from this month?",
    "fReste": "Left to allocate",
    "resteNonNul": "Non-zero",
    "inflationCourt": "inflation",
    "err_montantNul": "This operation is already fully allocated: nothing is left to link.",
    "err_depassement": "The parts would exceed the operation amount.",
    "err_doublon": "This operation is already linked to this instalment — edit the existing part.",
    "err_cible": "Pick a forecast and a month first.",
    "err_operation": "Operation not found.",
    "ligneBudget": "Budget line",
    "resteDebit": "Remaining forecast debit",
    "resteCredit": "Remaining forecast credit",
    "gestionCategories": "Category management",
    "catDefauts": "Default categories",
    "catDefautsAide": "Never modified: the eye hides them from entry, history is untouched.",
    "catNouvellePh": "New category…",
    "sousCatPh": "New subcategory…",
    "catMasquer": "Hide",
    "catAfficher": "Show",
    "catErr_nomVide": "Give the category a name.",
    "catErr_nomTropLong": "30 characters max.",
    "catErr_doublon": "A category already has this name.",
    "sousCategorie": "Subcategory",
    "sousCatOptionnelle": "Subcategory (optional)",
    "syntheseTotal": "Total"
  },
  "commun": {
    "retour": "Back",
    "baisserClavier": "Dismiss keyboard",
    "limitePiecesTitre": "Limit reached",
    "limitePiecesMsg": "Your plan allows {n} attachment(s) per item. Remove one or upgrade your plan to add more.",
    "annuler": "Cancel",
    "effacer": "Clear",
    "enregistrer": "Save",
    "nom": "Name",
    "emoji": "Emoji",
    "note": "Note",
    "erreur": "Error",
    "valider": "Confirm",
    "ajouter": "Add",
    "inviter": "Invite",
    "supprimer": "Delete",
    "dupliquer": "Duplicate",
    "modifier": "Edit",
    "fermer": "Close",
    "rechercher": "Search",
    "filtrer": "Filter",
    "trier": "Sort",
    "chargement": "Loading…",
    "oui": "Yes",
    "non": "No",
    "creer": "Create",
    "supprMultiTitre": "Delete selection?",
    "supprMultiMsg": "Delete {n} item(s)? This cannot be undone.",
    "editer": "Edit",
    "moisLongs": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "moisCourts": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "joursCourts": [
      "M",
      "T",
      "W",
      "T",
      "F",
      "S",
      "S"
    ],
    "joursLongs": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    "ok": "OK",
    "formulaireFerme": "Form closed.",
    "chargementEspaces": "Loading your spaces…",
    "choisirDate": "Choose date",
    "choisirHeure": "Choose time",
    "aucune": "None",
    "aucuneDate": "No date",
    "aucuneHeure": "No time",
    "choisirMoisAnnee": "Choose month and year",
    "choisisHeure": "Pick a time",
    "heures": "Hours",
    "minutes": "Minutes",
    "accesCameraRefuse": "Camera access denied.",
    "retirerPiece": "Remove attachment",
    "pieceSeraRetiree": "\"{nom}\" will be removed.",
    "bienvenueSuite": "Welcome to MoP Suite",
    "toucherMasquer": "Tap to hide.",
    "rienAAfficher": "Nothing to show.",
    "joursNoms": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ],
    "reinitialiser": "Reset",
    "termine": "Done",
    "mois": "Months",
    "annee": "Years",
    "tout": "All",
    "basculerAnnee": "Count in years",
    "basculerMois": "Count in months",
    "deplier": "Expand",
    "replier": "Collapse"
  },
  "recurrences": {
    "titre": "Recurring events",
    "erreur": "Error",
    "sansTitre": "(Untitled)",
    "aucun": "No recurring events",
    "aucunAide": "Tap \"+\" to create one",
    "depuis": "Since",
    "desactive": "disabled",
    "recQuotidien": "Every day",
    "recHebdo": "Every {jours}",
    "recBimensuel": "Every 2 weeks",
    "recMensuel": "Every month",
    "nSelectionnes": "{n} selected",
    "supprimerSerie": "Delete the series",
    "supprimerSerieMsg": "Delete all recurring \"{titre}\" events?",
    "supprSeriesTitre": "Delete series",
    "supprSeriesMsg": "Delete the {n} selected series?",
    "nouveau": "New recurring event",
    "modifier": "Edit recurring event",
    "phTitre": "Event title *",
    "phLieu": "Location (optional)",
    "lieu": "Location",
    "phChoisirLieu": "Pick a saved place…",
    "phNote": "Note (optional)",
    "heureDebut": "Start",
    "heureFin": "End",
    "frequence": "Frequency",
    "typeHebdo": "Every week",
    "typeBimensuel": "2 weeks",
    "typeMensuel": "Monthly",
    "categorie": "Category",
    "periode": "Period",
    "debut": "Start",
    "fin": "End",
    "sansFin": "No end",
    "dateFinAvant": "The end date must be after the start date.",
    "exceptionsTitre": "Exceptions ({n})",
    "exceptionsAide": "Occurrences removed from the series. Drop the ones that no longer match the configuration.",
    "exCompatible": "compatible",
    "exSansObjet": "no longer applies",
    "exHorsPeriode": "out of range",
    "exPurgeTitre": "Stale exceptions",
    "exPurgeMsg": "{n} exception(s) no longer match the new configuration. Remove them?",
    "exGarder": "Keep",
    "exRetirer": "Remove"
  },
  "nav": {
    "calendrier": "Calendar",
    "evenements": "Events",
    "famille": "Family",
    "profil": "Profile",
    "ivv": "IVV",
    "inventaires": "Inventories",
    "plans": "Plans"
  },
  "langue": {
    "titre": "Language",
    "sousTitre": "App language",
    "actuelle": "Current language"
  },
  "login": {
    "erreurPrenom": "Enter your first name",
    "erreurRole": "Choose your role",
    "erreurNonAutorise": "This email address is not allowed to register. Please contact the administrator.",
    "erreurInterdit": "This email address has been blocked. Please contact the administrator.",
    "attenteTitre": "Registration pending",
    "attenteDesc": "An administrator must then approve your registration before you can sign in.",
    "attenteVerifDesc": "A verification email was sent to {email}. Click the link to confirm your address.",
    "emailNonVerifie": "Please verify your email first: click the link you received, then sign in again.",
    "renvoyerVerif": "Resend verification email",
    "verifRenvoyeeTitre": "Email sent",
    "verifRenvoyeeMsg": "A verification link was resent to {email}.",
    "retourConnexion": "Back to sign in",
    "placeholderPrenom": "Your first name",
    "jeSuis": "I am:",
    "maman": "Mom",
    "papa": "Dad",
    "placeholderEmail": "Email",
    "placeholderMdp": "Password (6 characters min)",
    "mdpOublie": "Forgot password?",
    "resetSucces": "Email sent to {email}. Check your inbox.",
    "resetInfo": "Enter your email above and tap \"Send\".",
    "envoyerLienReset": "Send reset link",
    "sInscrire": "Sign up",
    "seConnecter": "Sign in",
    "dejaCompte": "Already have an account? Sign in",
    "pasDeCompte": "No account? Sign up",
    "ou": "or",
    "continuerGoogle": "Continue with Google",
    "googleLierMdp": "An account already exists with this email. Enter your password and sign in to link your Google account.",
    "sousTitreSuite": "Sign in with your MoPCal account.",
    "phEmail": "Email",
    "phMotDePasse": "Password",
    "masquerMdp": "Hide password",
    "afficherMdp": "Show password",
    "creerCompte": "Create an account",
    "ou": "or",
    "continuerGoogle": "Continue with Google",
    "continuerApple": "Continue with Apple"
  },
  "famille": {
    "titre": "Family",
    "trierTitre": "Sort by title (A→Z)",
    "rubTemps": "Organise your time",
    "rubMaison": "Everyday home",
    "rubEchanges": "Share as a family",
    "rubMemoire": "Memory & tracking",
    "indisponible": "Unavailable",
    "decDispo": "Available with the {palier} plan",
    "decOuCarte": " — or à la carte.",
    "decVoirTuto": "See how it works",
    "decVoirForfaits": "Explore the plans",
    "demandesLabel": "Requests",
    "demandesDesc": "Approve schedule changes",
    "listesLabel": "Lists & shopping",
    "listesDesc": "Shared tasks and shopping",
    "inventaireLabel": "Inventory / stock",
    "inventaireDesc": "Stock by category: cupboards, supplies…",
    "plansEmplacementsLabel": "Plans & locations",
    "plansEmplacementsDesc": "2D floor plan of rooms and storage, items per place",
    "budgetLabel": "Budget",
    "budgetDesc": "Shared transactions and balance",
    "messagerieLabel": "Messaging",
    "messagerieDesc": "Chat as a family",
    "journalLabel": "Logbook",
    "journalDesc": "Shared daily notes",
    "contactsLabel": "Contacts",
    "contactsDesc": "Doctor, school, emergencies…",
    "statistiquesLabel": "Statistics",
    "statistiquesDesc": "Custody time breakdown",
    "emploiDuTempsLabel": "Timetable",
    "emploiDuTempsDesc": "Child's school timetable",
    "exportLabel": "Export / Report",
    "exportDesc": "Calendar (.ics) and PDF report",
    "vacancesLabel": "Holidays & public days off",
    "vacancesDesc": "Load school holidays",
    "lieuxLabel": "Places",
    "lieuxDesc": "Reusable calendar addresses",
    "recurrencesLabel": "Recurring events",
    "recurrencesDesc": "Manage event series",
    "historiqueLabel": "History",
    "historiqueDesc": "Log of organisation changes",
    "repasLabel": "Meals",
    "repasDesc": "Meal compositions (recipes + extras)",
    "menuDesc": "Meal planning by day and slot",
    "rubApprendre": "Learn",
    "apprentissageLabel": "Tutorial & Practice",
    "apprentissageDesc": "Learn each feature, then practice it",
    "reorgAstuce": "Drag the tiles to rearrange them",
    "reorgPrendre": "Drag the ⠿ handle, or tap a tile to move",
    "reorgPoser": "Tap where to place it",
    "reorgTermine": "Done",
    "reorgReinit": "Reset",
    "reorganiser": "Reorganise",
    "plusADebloquer": "+{n} to unlock",
    "reduire": "Show less",
    "reorgAide": "Move a block with ▲▼. Tap a tile then ◀ ▶ to move it within its block.",
    "sec": {
      "collaboration": "Collaboration",
      "garde": "Custody",
      "organisation": "Organization",
      "carnets": "Address books",
      "finances": "Finances",
      "outils": "Tools"
    },
    "t": {
      "demandes": "Requests",
      "messagerie": "Messages",
      "journal": "Diary",
      "statistiques": "Statistics",
      "historique": "History",
      "listes": "Lists",
      "repas": "Meals",
      "menu": "Menu",
      "courses": "Groceries",
      "contacts": "Contacts",
      "lieux": "Places",
      "finances": "Budget & finances",
      "exports": "Exports",
      "edt": "School timetable"
    },
    "coursesDesc": "Shopping list built from menus"
  },
  "historique": {
    "titre": "History",
    "vide": "No change recorded",
    "videAide": "Creations, edits and deletions of events, timetables and custody days will appear here.",
    "filtre_tous": "All",
    "filtre_evenement": "Events",
    "filtre_recurrence": "Recurring",
    "filtre_edt": "Timetable",
    "filtre_garde": "Custody",
    "filtre_demande": "Requests",
    "type_evenement": "Event",
    "type_recurrence": "Recurring series",
    "type_edt": "Timetable",
    "type_garde": "Custody",
    "type_demande": "Request",
    "action_creation": "Created",
    "action_modification": "Edited",
    "action_suppression": "Deleted",
    "gardeItem": "Custody change",
    "par": "by {nom}",
    "pourLe": "for {date}",
    "deplaceDe": "moved from {de} to {vers}",
    "dDeplacement": "Move",
    "aujourdhui": "Today",
    "hier": "Yesterday",
    "sansTitre": "(untitled)",
    "act_activation": "Activated",
    "act_desactivation": "Deactivated",
    "act_exceptions": "Exceptions changed",
    "dAction": "Action",
    "dType": "Type",
    "dDateConcernee": "Date concerned",
    "dPar": "By",
    "dQuand": "When",
    "detailNote": "Field-level changes aren't stored; this card summarises the recorded action."
  },
  "garde": {
    "preVolTitre": "Apply the configuration?",
    "preVolMsg": "{total} manually forced day(s): {utiles} useful, {redondants} redundant (same custody as the new config). What about the forced days?",
    "conserverAppliquer": "Keep and apply",
    "toutReinitialiser": "Reset all",
    "joursForcesTitre": "Forced days ({n})",
    "joursForcesDesc": "Days whose custody was changed by hand. They are kept when the configuration changes; remove one to revert it to the computed custody.",
    "utile": "useful",
    "redondant": "redundant",
    "reinitJourTitre": "Reset this day?",
    "reinitJourMsg": "{date} will revert to the custody computed by the configuration.",
    "reinitialiser": "Reset",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "titre": "Custody",
    "horsVacancesRythme": "Outside holidays — schedule",
    "ajouterPeriode": "Add a period",
    "aucunRythme": "No schedule period. Tap ➕ to add one.",
    "enCours": "ongoing",
    "duAu": "from {debut} to {fin}",
    "duSansFin": "from {debut} · no end",
    "appliquer": "✓ Apply",
    "nePasAppliquer": "◯ Don't apply",
    "appliquerRythmeAcc": "Apply this schedule or not",
    "hintRythme": "Swipe right to edit, left to delete. The schedule's custody shows automatically when \"✓ Apply\" is on — without writing anything to the database; only your manual swaps and the holiday split are stored.",
    "semaineAlterneeAide": "\"Alternating week\" starts on the chosen day, with {nom}. The cycle isn't aligned to Monday.",
    "durantVacancesRepartition": "During holidays — split",
    "ajouterGardeVacances": "Add a holiday custody",
    "aucuneGardeVacances": "No holiday custody. Tap ➕ to add one.",
    "gardeVacancesLabel": "Holiday custody",
    "demiUnAnPair": "½1 even year · {nom}",
    "demiUnAnImpair": "½1 odd year · {nom}",
    "debuteVeille": "Starts the evening before",
    "debutePremierJour": "Starts on day 1",
    "appliquerGardeVacancesAcc": "Apply this holiday custody or not",
    "hintGardeVacances": "Swipe right to edit, left to delete. The split applies to holidays within the active period (\"✓ Apply\").",
    "repartitionParVacances": "Split by holiday",
    "aucunePeriodeVacances": "No holiday period. Add them in \"Holidays\".",
    "aucuneGardeVacancesCouvrant": "No holiday custody applied to this period. Add one covering {date}.",
    "appliquerGardeSurVacancesAcc": "Apply custody to this holiday or not",
    "supprimerPeriodeMsg": "This schedule will be removed from the timeline.",
    "supprimerGardeVacancesTitre": "Delete holiday custody",
    "supprimerGardeVacancesMsg": "This split period will be removed.",
    "retablirRythme": "Reset all to schedule",
    "retablirRythmeMsg": "The {n} selected swapped days will return to the calculated schedule (overrides removed).",
    "retablirTitre": "Reset all",
    "retablirRepartition": "Reset all to split",
    "retablirRepartitionMsg": "The {n} selected changed days will return to the split (overrides removed).",
    "repartitionCalculeeAide": "The split is computed on display: nothing is written to the database until you change a day manually.",
    "noteParents": "P1 = {p1} · P2 = {p2}. Daily custody is shared with MoPCal.",
    "excTitre": "{n} exception(s) (custody swapped)",
    "filtreTousMois": "All months",
    "aucuneExcFiltre": "No exceptions for this filter.",
    "hintExcSwipe": "Swipe right to switch parent, left to reset.",
    "nouvellePeriode": "New period",
    "modifierPeriode": "Edit period",
    "modeleGarde": "Custody template",
    "nouveauModelePersoAcc": "New custom template",
    "modifierModele": "Edit template",
    "aPartirDuJourDepart": "Starting from (start day)",
    "jourDepart": "Start day",
    "finCalculee": "Calculated end: {fin}",
    "sansFinMin": "no end (ongoing)",
    "laisseSansFinAide": "Leave \"no end\" for the ongoing period, or set an end date.",
    "cyclePersoDesc": "Custom cycle · {n} wk.",
    "caleS1Impaires": " · aligned (W1 = odd weeks)",
    "caleS1Paires": " · aligned (W1 = even weeks)",
    "nouvelleGardeVacances": "New holiday custody",
    "modifierGardeVacances": "Edit holiday custody",
    "aPartirDu": "From",
    "jusquAu": "Until",
    "premiereMoitiePaires": "1st half — even years (2024, 2026…)",
    "premiereMoitieImpaires": "1st half — odd years (2025, 2027…)",
    "pasAlternanceAide": "No alternation: {nom} always has the 1st half. The 2nd goes to the other.",
    "alternanceAide": "Yearly alternation: the 1st half switches parent each year. The 2nd goes to the other.",
    "gardeCommenceVeille": "Custody starts the evening before",
    "gardeCommenceVeilleSub": "The evening before day 1 goes to the 1st-half parent.",
    "choisisDateDebut": "Choose a start date.",
    "dateDebut": "Start date",
    "modelePerso": "Custom template",
    "phModelePerso": "e.g. 1 weekend out of 2",
    "dureeCycle": "Cycle length",
    "nSem": "{n} wk.",
    "calageCycle": "Cycle alignment",
    "semainesCalendrier": "Calendar weeks",
    "s1CorrespondAux": "The 1st week (W1) corresponds to",
    "semainesPaires": "Even weeks",
    "semainesImpaires": "Odd weeks",
    "repartitionToucheCase": "Split (tap a cell to switch)",
    "paritePaires": "even",
    "pariteImpaires": "odd",
    "aideCaleDeux": "Columns Mon→Sun (Monday→Sunday). W1 = {parite} calendar weeks, W2 = the others. The start date only triggers the pattern: the cycle stays aligned to the weeks.",
    "aideCaleMulti": "Columns Mon→Sun (Monday→Sunday). Rows W1…W{n} follow the calendar week number. The start date only triggers the pattern.",
    "aideNonCale": "D1 = start day chosen when applied (the cycle isn't aligned to Monday).",
    "mdlAlternee": "Alternating week",
    "mdlAlterneeDesc": "One week with one parent, one with the other.",
    "mdl223": "2-2-3 custody",
    "mdl223Desc": "2 d / 2 d / 3 d, alternating over 2 weeks.",
    "mdl2255": "2-2-5-5 custody",
    "mdl2255Desc": "2 d with each, then 5 d with each (14-day cycle).",
    "mdl3443": "3-4-4-3 custody",
    "mdl3443Desc": "3 d / 4 d alternating over 2 weeks.",
    "mdlPerso": "Custom",
    "errDejaDate": "A period already starts on this date.",
    "errRecouvre": "This period overlaps an existing one.",
    "errIntrouvable": "Period not found.",
    "errApresPrec": "The date must be after the previous schedule ({date}).",
    "errAvantSuiv": "The date must be before the next schedule ({date}).",
    "errFinApresDebut": "The end date must be after the start.",
    "errFinAvantSuiv": "The end must precede the next schedule ({date}).",
    "errSansFinImpossible": "\"No end\" isn't possible: a schedule follows this period.",
    "errGvApresPrec": "The date must be after the previous period ({date}).",
    "errGvAvantSuiv": "The date must be before the next period ({date}).",
    "errGvFinAvantSuiv": "The end must precede the next period ({date}).",
    "errGvSansFinImpossible": "\"No end\" isn't possible: a period follows this one."
  },
  "repas": {
    "titre": "Meals",
    "nouvelle": "New recipe",
    "modifier": "Edit recipe",
    "aucune": "No recipe yet",
    "aucuneAide": "Tap “+” to create your first recipe.",
    "sansNom": "(untitled)",
    "nIngredients": "{n} ingredient(s)",
    "nMin": "{n} min",
    "phNom": "Recipe name *",
    "portions": "People",
    "temps": "Time",
    "minutes": "min",
    "ingredients": "Ingredients",
    "phIngredient": "Ingredient",
    "qte": "Qty",
    "unite": "unit",
    "prix": "price",
    "ajouterIngredient": "Add an ingredient",
    "preparation": "Steps",
    "phEtape": "Describe the step…",
    "ajouterEtape": "Add a step",
    "supprimer": "Delete recipe",
    "supprTitre": "Delete recipe",
    "supprMsg": "Delete “{nom}”?",
    "photoCamera": "Camera",
    "photoGalerie": "Gallery",
    "permissionTitre": "Permission required",
    "permissionPhotos": "Allow access to photos / camera to add an image.",
    "planning": "Meal planning",
    "erreur": "Error",
    "choisirCategorie": "Choose a category",
    "exporter": "Export recipes",
    "importer": "Import",
    "importTitre": "Import recipes",
    "importConfirm": "{n} recipe(s) found in the file. Import them?",
    "importAucune": "No recipe recognized in this file (expected MoPCal or Schema.org/Recipe format).",
    "importOk": "{n} recipe(s) imported.",
    "aucunRepas": "No meal composed yet",
    "aucunRepasAide": "Tap “+” to compose your first meal from your recipes.",
    "editerRepas": "Edit meal",
    "nouveauRepas": "New meal",
    "supprimerRepas": "Delete meal",
    "supprimerRepasMsg": "Delete « {nom} »?",
    "phNomRepas": "Meal name (e.g. Light dinner)",
    "pour": "For",
    "personnes": "people",
    "recettes": "Recipes",
    "aucuneRecette": "No recipe. Add some from your library.",
    "ajouterRecette": "Add a recipe",
    "fermer": "Close",
    "toutesAjoutees": "All recipes are already added (or none created).",
    "extras": "Extras (off-recipe)",
    "phExtra": "Ingredient (e.g. Apples)",
    "ajouterExtra": "Add an extra",
    "perServ": "ppl"
  },
  "repasPlan": {
    "titre": "Meal planning",
    "menu": "Menu",
    "nouveauMenu": "New menu",
    "config": "Number of people",
    "aucun": "No menu yet",
    "aucunAide": "Create a weekly menu template and assign your recipes to the week's meals.",
    "nRepas": "{n} planned meal(s)",
    "phNomMenu": "Menu name",
    "ajouter": "Add…",
    "choisirRecette": "Choose a recipe",
    "viderCase": "Clear slot",
    "aucuneRecette": "No recipe — create some in the Recipes tab.",
    "ouLibre": "Or free text",
    "phLibre": "e.g. Restaurant, leftovers…",
    "recetteSupprimee": "(recipe deleted)",
    "supprMenuTitre": "Delete menu",
    "supprMenuMsg": "Delete “{nom}”?",
    "moments": "Meal slots for this menu",
    "phMoment": "Moment name",
    "phHeure": "12:00",
    "momentsAide": "Slots (lunch, dinner…) belong to THIS menu. Times are optional (start → end): applied to meals added to the calendar.",
    "de": "From",
    "a": "to",
    "ajouterMoment": "Add a moment",
    "nbPersonnes": "Number of people",
    "momentsRequis": "Add at least one meal moment.",
    "genererCourses": "Generate shopping list",
    "coursesApercu": "Shopping list",
    "coursesInfo": "For {n} people — quantities summed and scaled.",
    "coursesVide": "No ingredient — assign recipes to the menu.",
    "creerListe": "Create the list",
    "coursesTitre": "Groceries —",
    "coursesOkTitre": "✓ List created",
    "coursesOkMsg": "{n} ingredient(s) added in the Lists module.",
    "creerDepense": "Add a transaction to Budget (~ {c} €)",
    "aucunBudget": "First create a budget in the Family budget module.",
    "budget": "Budget",
    "ajouterDepense": "Create the transaction",
    "categorieAlim": "Food",
    "depenseOkTitre": "✓ Transaction created",
    "depenseOkMsg": "The transaction was added to the chosen budget.",
    "datePrecise": "Edit a specific date",
    "voirDate": "View this date",
    "exceptionDe": "Exception for {date}",
    "exceptionAide": "These meals replace the template menu for this date only. Moments left empty fall back to the template (shown in grey).",
    "reinit": "Reset",
    "reinitTitre": "Reset this day?",
    "reinitMsg": "{date} will revert to the template menu.",
    "exceptionsTitre": "Exceptions ({n})",
    "termine": "Done",
    "tab_semaines": "Weeks",
    "tab_menus": "Menus",
    "tab_recettes": "Recipes",
    "pourCourses": "Shopping list",
    "auCalendrier": "On calendar",
    "enCours": "Applying…",
    "masquerSansMenu": "Hide weeks without a menu",
    "afficherToutesSem": "Show all weeks",
    "masquerPassees": "Hide past weeks",
    "afficherPassees": "Show the {n} past week(s)",
    "menuSansRecette": "Add at least one recipe in the « Recipes » tab first.",
    "menuVide": "Add at least one recipe to the menu before saving.",
    "appuiLongAjouter": "Long-press 💾 to add this menu.",
    "aideGenererCourses": "Builds a shopping list from the menus of the selected weeks.",
    "aideConfig": "Configure meal moments (lunch, dinner…) and number of people.",
    "aideAjoutRecette": "Add a new recipe to the library.",
    "aideAjoutMenu": "Create a new menu template (a week of meals).",
    "aideAjoutSemaine": "Add a week to the planner to apply a menu to it.",
    "infoIconeAstuce": "Long-press an icon to show what it does.",
    "semaineDu": "Week of {date}",
    "aucunMenuSem": "No menu",
    "choisirMenu": "Choose a menu",
    "appliquee": "applied",
    "semActive": "Active (shopping list)",
    "semInactive": "Inactive",
    "appliquerCal": "Apply to calendar",
    "reappliquer": "Re-apply",
    "ajouterSemaine": "Add a week",
    "ajouterSemaineAide": "Pick an upcoming week to add to the list.",
    "aucuneSemaine": "No weeks. Tap « + » at the top right to add one.",
    "aucuneSemaineAjout": "All upcoming weeks are already in the list.",
    "choisirMenuSem": "Apply a menu to this week",
    "retirerMenuSem": "Remove the menu from this week",
    "semaineSansMenu": "First create a menu (Menus tab), then apply it to a week.",
    "remplacerTitre": "Replace meals?",
    "remplacerMsg": "The week of {date} already has meals. Replace them? Your edits for that week will be overwritten.",
    "remplacer": "Replace",
    "retirerTitre": "Remove menu?",
    "retirerMsg": "Remove the meals of the week of {date} from the calendar?",
    "retirer": "Remove",
    "semainesChoix": "Weeks to include",
    "nomListe": "List name",
    "coursesNomDefaut": "Meals week {n}",
    "momentsDansMenu": "Meal slots (lunch, dinner…) are set inside each menu, via the ⚙️ in the menu editor.",
    "categories": "Recipe categories",
    "categoriesAide": "Sort your recipes: breakfast, quick weeknight, dessert… A category can only be deleted when no recipe uses it.",
    "categorieNonVide": "This category still contains recipes.",
    "categoriesRequises": "Keep at least one category.",
    "ajouterCategorie": "Add a category",
    "phCategorie": "Category name",
    "exporterPdf": "Export menu as PDF",
    "pdfAucuneSemaine": "Select at least one week that has a menu.",
    "menuVideFermer": "This menu is empty: no meal has been placed in it. It will be deleted if you close now.",
    "aucunRepas": "No meal yet. Create one in the « Meals » tab: a meal may hold a single recipe.",
    "coursesInfoCases": "Quantities scaled to the number of people set on each menu slot",
    "menuAbandonner": "Some changes to this menu have not been saved. Discard them?",
    "abandonner": "Discard",
    "ioTitre": "Recipes",
    "ioImporter": "Import recipes",
    "ioImporterSous": "From a JSON file (MoPCal or Schema.org/Recipe)",
    "ioExporter": "Export recipes",
    "ioExporterSous": "Choose recipes and format",
    "ioExporterVide": "No recipe to export",
    "ioTitreCourt": "Import / export",
    "ioAide": "Back up or share your recipes (MoPCal or Schema.org/Recipe format), and import recipes from a file.",
    "ioLabel": "Import / export recipes",
    "repasAucun": "No meal",
    "repasAucunAide": "Build a meal with several recipes and extras (fruit, bread…) to fill the shopping basket.",
    "aideExporterPdf": "Generate a PDF of the weeks' menu (meal grid, recipes and shopping list).",
    "semainesTitre": "Weeks",
    "aucunMenuSemaine": "No menu for this week",
    "applique": "Applied to calendar",
    "detacher": "Detach this week",
    "detacherTitre": "Detach week",
    "detacherMsg": "Meals placed on this week will be removed from the calendar.",
    "inclureCourses": "Include in shopping list",
    "versCourses": "Add to shopping list",
    "coursesRien": "Nothing to buy for the selected weeks.",
    "coursesAjoutees": "{n} ingredient(s) added to the shopping list."
  },
  "ingredients": {
    "titre": "Ingredients",
    "nouveau": "New ingredient",
    "modifier": "Edit ingredient",
    "aucun": "Empty reference list",
    "aucunAide": "Tap “+” to add your first ingredient. Reusable across your recipes.",
    "phNom": "Ingredient name",
    "rayon": "Aisle",
    "unite": "Unit",
    "supprTitre": "Delete ingredient",
    "supprMsg": "Delete “{nom}”?",
    "perso": "Mine",
    "modifieBadge": "Edited",
    "gerer": "Manage my ingredients",
    "mesAjouts": "My additions ({n})",
    "aucunAjout": "No ingredient added by you.",
    "mesCorrections": "My corrections ({n})",
    "aucuneCorrection": "No base ingredient corrected.",
    "original": "Original",
    "mesMasques": "My hidden ({n})",
    "aucunMasque": "No hidden ingredient.",
    "reafficher": "Unhide",
    "nouvelleCategorie": "New category",
    "modifierCategorie": "Edit category",
    "phCategorie": "Category name",
    "supprCategorieTitre": "Delete category",
    "categorieNonVideTitre": "Category not empty",
    "categorieNonVideMsg": "This category still has {n} ingredient(s). Move or delete them first.",
    "categories": "Categories",
    "mesAjoutsCategorie": "My added categories ({n})",
    "aucunAjoutCategorie": "No category added by you.",
    "mesCorrectionsCategorie": "My category corrections ({n})",
    "aucuneCorrectionCategorie": "No base category corrected.",
    "mesMasquesCategorie": "My hidden categories ({n})",
    "aucunMasqueCategorie": "No hidden category."
  },
  "courses": {
    "titre": "Shopping list",
    "ajouterArticle": "Add an item",
    "viderCoches": "Clear checked items",
    "aucune": "Empty shopping list",
    "aucuneAide": "Add an item, or add a recipe's or meal's ingredients from their sheet (🛒).",
    "coches": "Checked ({n})",
    "ajouterALaListe": "Add to shopping list",
    "pourCombien": "For how many people?",
    "ajusterAide": "Adjust the quantities if needed: they will be merged with what is already on the list.",
    "pas": "Step",
    "pasAide": "Tap the step to switch from 1 to 10, then to 100.",
    "ajoutTitre": "Added to the list",
    "ajoutMsg": "{n} ingredient(s) added (or merged) into the shopping list."
  },
  "profil": {
    "erreur": "Error",
    "enregistreTitre": "✓ Saved",
    "appliqueTitre": "✓ Applied",
    "monProfil": "My profile",
    "monRole": "My role",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "parent1Createur": "Parent 1 (creator)",
    "createur": "Creator",
    "coOrganisateur": "Co-organizer",
    "utilisateur": "User",
    "utilisateurs": "Users",
    "visiteur": "Guest",
    "visiteurs": "Guests",
    "enfant": "Child",
    "enfantBadge": "Child",
    "general": "General",
    "profilEnfant": "Child profile",
    "profilCalendrier": "Calendar profile",
    "prenomLabel": "First name:",
    "nomLabel": "Name:",
    "changerNom": "Change name",
    "changerMdp": "Change password",
    "resetMdpConfirm": "An email to reset your password will be sent to {email}. Continue?",
    "resetMdpEnvoyer": "Send email",
    "resetMdpEnvoyeTitre": "Email sent",
    "resetMdpEnvoye": "A reset email was sent to {email}. Follow the link to set a new password.",
    "changerEmail": "Change login email",
    "emailSystemeTitre": "System email",
    "emailSysteme": "This is a system account email (admin / commerce) and cannot be changed here.",
    "emailInfoAuth": "For your security, enter your current password. A verification link will be sent to the new address: the change only takes effect after you click that link and sign in again.",
    "nouvelEmail": "New email",
    "motDePasseActuel": "Current password",
    "emailInvalide": "Invalid email address.",
    "emailIdentique": "That's already your current email.",
    "motDePasseRequis": "Enter your current password.",
    "emailVerifTitre": "Check your new inbox",
    "emailVerifEnvoye": "A verification link was sent to {email}. Click it, then sign in again to complete the change.",
    "envoyerLien": "Send link",
    "prenomEnfantPlaceholder": "Child's first name",
    "nomCalendrierPlaceholder": "Calendar name",
    "iconeLabel": "Icon:",
    "couleurLabel": "Color:",
    "icone": "Icon",
    "couleur": "Color",
    "dateNaissanceLabel": "Date of birth:",
    "dateNaissance": "Date of birth",
    "ans": "yrs",
    "villePrincipaleLabel": "Main city (for place search):",
    "villePlaceholder": "e.g. Gif-sur-Yvette, Paris…",
    "classeScolaire": "School grade",
    "classe": "Grade",
    "nonDefinie": "Not set",
    "pasEncoreConnecte": "Not connected yet",
    "nomParent2Label": "Display name (optional)",
    "nomParent2Placeholder": "E.g. Marie — avoids showing “Parent 2”",
    "compteEnfantTitre": "Child's account",
    "compteEnfantDesc": "Give the child access with their own login email. Their rights (view / add / edit / delete) are set like a visitor's.",
    "permissionsEvenements": "Event permissions",
    "permissions": "Permissions",
    "emailParent2Label": "Parent 2 email:",
    "emailCoOrganisateurLabel": "Co-organizer email:",
    "aucunEmailDefini": "No email set",
    "emailPlaceholder": "Email…",
    "plusAjouter": "+ Add",
    "aucunVisiteur": "No guests",
    "aucunUtilisateur": "No users",
    "configurationGarde": "Custody settings",
    "configurationGardeSub": "Custody mode, alternation, specific days…",
    "evenementsRecurrents": "Recurring events",
    "evenementsRecurrentsSub": "Manage event series",
    "permissionsModalTitre": "Permissions — {nom}",
    "permissionsModalSousTitre": "Choose what this person can do with events.",
    "permPeutProposer": "Can suggest events",
    "permPeutProposerDesc": "The event will require the custodial parent's approval",
    "permPeutAjouter": "Can add events",
    "permPeutModifier": "Can edit events",
    "permPeutSupprimer": "Can delete events",
    "ajouterAcces": "Add access",
    "emailEnfantPlaceholder": "Child's email",
    "emailVisiteurPlaceholder": "Guest's email",
    "enfantLectureSeule": "The child will have read-only access to their calendar. You can change their permissions afterwards.",
    "intituleLabel": "Title:",
    "precisezIntitule": "Specify the title…",
    "classeDe": "{nom}'s grade",
    "actuelleLabel": "Current:",
    "effacer": "Clear",
    "aucuneClasse": "No grade selected",
    "modeGarde": "Custody mode",
    "modeGardeDesc": "Shows custody colors, indicators and schedule settings.",
    "impossibleSauvegarderMode": "Could not save the mode.",
    "modeGardeDesactiveInfo": "Custody mode off: the schedule settings are hidden and not applied.",
    "modeGardeActivezPour": "Turn it on to set up custody.",
    "modeGardeSeulParent1": "Only Parent 1 can enable it.",
    "modeAlternance": "Alternating weeks",
    "modeAlternanceDesc": "One week with each parent",
    "modeJoursSpecifiques": "Specific days",
    "modeJoursSpecifiquesDesc": "Fixed days every week",
    "modePersonnalise": "Custom",
    "modePersonnaliseDesc": "Custom setup in the calendar",
    "modePersonnaliseInfo": "In custom mode, set up each day directly in the calendar.",
    "aucuneRegleAuto": "No automatic rule will be applied.",
    "aucunePeriodeConfiguree": "No period configured.",
    "indefini": "open-ended",
    "modifierConfigGarde": "Edit custody settings",
    "modelesPretsEmploi": "Ready-made templates",
    "modelesDesc": "Apply a preset schedule to {nom}, starting today.",
    "ceCalendrier": "this calendar",
    "appliquerModeleTitre": "Apply \"{modele}\"?",
    "appliquerModeleMsg": "{nom}'s custody schedule will be generated from today using this template. Days you edited manually may be recalculated.",
    "appliquer": "Apply",
    "modeleAppliqueMsg": "The custody schedule has been updated. Check the calendar to review it.",
    "modeDeGarde": "Custody mode",
    "attribution": "Assignment",
    "jourChangementGarde": "Custody changeover day:",
    "semaineAppartientA": "Week {n} — belongs to:",
    "apercu": "Preview",
    "sem": "Wk",
    "pair": "even",
    "impair": "odd",
    "attributionJours": "Day assignment",
    "nbSemainesCycle": "Number of weeks in the cycle:",
    "schemaRepetePluriel": "This pattern repeats every {n} weeks.",
    "schemaRepeteSingulier": "This pattern repeats every {n} week.",
    "dateApplication": "Start date",
    "appliquerAPartirDu": "Apply this mode from:",
    "utilisezBoutonEnregistrer": "Use the save button at the top.",
    "repartitionGardeVacances": "Custody split (holidays)",
    "repartitionVacancesDesc": "How custody is split over each holiday period (½ 1 / ½ 2). Periods load under Family → \"Holidays & public holidays\".",
    "moitie1": "½ 1 →",
    "moitie2": "½ 2 →",
    "alternerSelonAnnee": "Alternate by year",
    "alternerSelonAnneeDesc": "Pattern above for even years, reversed for odd years.",
    "recHebdo": "Weekly — {jours}",
    "recBimensuel": "Every 2 weeks",
    "recMensuel": "Every month",
    "recurrencesTitre": "Recurrences — {nom}",
    "aucunEvenementRecurrent": "No recurring events",
    "creezDepuisFormulaire": "Create one from the event form",
    "sansTitre": "(Untitled)",
    "depuis": "Since",
    "couleursTitre": "Colors — {nom}",
    "parent1Nom": "Parent 1 — {nom}",
    "parent2Nom": "Parent 2 — {nom}",
    "couleurDansCalendrier": "Color in the calendar:",
    "creerCalendrier": "Create a calendar",
    "typeCalendrier": "Calendar type",
    "typeEnfantSub": "Custody, requests, birthday…",
    "typeGeneralSub": "Free family organization",
    "prenomEnfantRequis": "Child's first name *",
    "nomCalendrierRequis": "Calendar name *",
    "prenomEnfantExemple": "e.g. Lucas",
    "nomCalendrierExemple": "e.g. Groceries, Work, Home…",
    "emailAutreParentOptionnel": "Other parent's email (optional)",
    "emailCoOrganisateurOptionnel": "Co-organizer's email (optional)",
    "aideRejoindre": "This person can join this calendar by entering your email ({email}).",
    "rejoindreCalendrier": "Join a calendar",
    "calendriersPartages": "Calendars shared with you",
    "aucuneInvitation": "No invitation found for {email}. Ask the creator to add your email, or search below.",
    "creePar": "Created by: {nom}",
    "rejoindreFleche": "Join →",
    "chercherParEmailCreateur": "Don't see it? Search by the creator's email",
    "aucunCalDispoEmail": "No calendar available for this email.",
    "resterConnecte": "Stay signed in on this device",
    "resterConnecteSous": "Disables auto sign-out on inactivity. This device only.",
    "votrePrenom": "Your first name",
    "emailConnexion": "Sign-in email",
    "fixe": "fixed",
    "emailContact": "Contact email",
    "autreEmailFacultatif": "Other email (optional)",
    "telephone": "Phone",
    "telephonePlaceholder": "e.g. 06 12 34 56 78",
    "ajouterDateNaissance": "Add my date of birth",
    "adresse": "Address",
    "adressePlaceholder": "Mailing address (optional)",
    "mesCalendriers": "My calendars",
    "aucunCalendrier": "No calendars",
    "aucunCalendrierAide": "Create a calendar or join another parent's",
    "reordonnerTitre": "Calendar order",
    "reordonnerAide": "Reorder how calendars are displayed. This setting is specific to this device. Tip: long-press a calendar to reorder.",
    "calMasquer": "Hide this calendar from the selectors",
    "calAfficher": "Show this calendar",
    "calendrierDefaut": "Calendar",
    "monter": "Move up",
    "descendre": "Move down",
    "monForfait": "My plan",
    "gratuit": "Free",
    "accesSansEcheance": "· access with no expiry",
    "jusquAu": "· until {date}",
    "sansPubBandeau": "No banner ads",
    "sansPubPleinEcran": "No full-screen ads",
    "demandeEnCours": "Request pending: switch to {plan}",
    "derniereDemandeRefusee": "Last request declined",
    "derniereDemandeRefuseeMotif": "Last request declined: {motif}",
    "voirForfaits": "View plans",
    "voirForfaitsSub": "Compare offers and request a change",
    "valideurIVV": "Validator (IVV)",
    "valideurIVVSub": "Technical facts, report, floating tools",
    "ivvRejoindre": "Join the IVV calendar",
    "ivvQuitter": "Leave the IVV calendar",
    "ivvCalSub": "Shared validators' calendar (messaging, versions). You choose whether to join.",
    "ivvQuitterTitre": "Leave the IVV calendar?",
    "ivvQuitterMsg": "You will no longer see the IVV calendar or its messaging. You can join it again later.",
    "ivvQuitterDernierMsg": "This is your only calendar: leaving it will take you back to the create / join calendar screen. You can join it again.",
    "ivvQuitterBtn": "Leave",
    "administration": "Administration",
    "administrationSub": "Users, security, settings",
    "nouveauMotDePasse": "New password",
    "nouveauMdpPlaceholder": "New password (6 chars min)",
    "confirmerMotDePasse": "Confirm password",
    "couleurAvatar": "Avatar color",
    "choisissezCouleurAvatar": "Choose a color for your avatar",
    "couleurParDefautRole": "Default color (role)",
    "nosForfaits": "Our plans",
    "forfaitActuelLabel": "Current plan:",
    "choisissezForfait": "Pick a plan to send a request to the administrator.",
    "featCalendriersPluriel": "{n} calendars",
    "featCalendriersSingulier": "{n} calendar",
    "featEvenementsIllimites": "Unlimited events",
    "featEvenementsParJour": "{n} events/day",
    "featExportPdf": "PDF export",
    "featSyncCalendrier": "System calendar sync",
    "featSansAucunePub": "No ads at all",
    "parMois": "/month",
    "forfaitActuel": "Current plan",
    "demandeEnCoursCourt": "Request pending…",
    "demandeDejaEnCours": "Request already pending",
    "demanderForfait": "Request this plan",
    "paiementsNonActifs": "Payments aren't active yet: access is granted manually by the administrator after approval.",
    "demandeEnvoyeeTitre": "Request sent",
    "demandeEnvoyeeMsg": "Your request has been sent to the administrator. You'll be notified of their decision.",
    "entrezPrenom": "Enter your first name",
    "emailContactInvalide": "Invalid contact email",
    "profilMaj": "Profile updated",
    "mdpTropCourt": "The password must be at least 6 characters.",
    "mdpNonIdentiques": "The two passwords don't match.",
    "entrezPrenomEnfant": "Enter the child's first name",
    "entrezNomCalendrier": "Enter the calendar name",
    "seDeconnecter": "Disconnect",
    "confirmDeconnexionCal": "Do you want to disconnect from the \"{nom}\" calendar?",
    "deconnecter": "Disconnect",
    "continuer": "Continue",
    "soutienTitre": "Support the developer ☕",
    "soutienSous": "Donate and remove ads",
    "rgpdTitre": "My data (GDPR)",
    "rgpdTexte": "Your data is stored securely on Firebase (Google Cloud). It is only used to run the app and is never sold or shared. You can request its deletion at any time.",
    "rgpdPolitique": "Read the privacy policy",
    "rgpdBouton": "Delete all my data",
    "rgpdNote": "Deletes your personal data and the calendars where you are the only member. Shared calendars are simply left (other members keep them). Your login account is kept. This cannot be undone.",
    "rgpdConfirm1Titre": "Delete all your data?",
    "rgpdConfirm1Msg": "This erases your personal data and the calendars where you are the only member. Shared calendars are left without being deleted for others. This is irreversible.",
    "rgpdConfirm2Titre": "Final confirmation",
    "rgpdConfirm2Msg": "Are you really sure? All your data will be permanently erased. Your login account will be kept.",
    "rgpdConfirmerFinal": "Delete everything",
    "rgpdFaitTitre": "Data deleted",
    "rgpdFaitMsg": "Your data has been erased. You will be signed out.",
    "supprimerCalTitre": "⚠️ Delete the calendar",
    "supprimerCalMsg": "Are you sure you want to permanently delete the \"{nom}\" calendar?\n\nAll events, settings and access will be removed. This action cannot be undone.",
    "supprimerDefinitivement": "Delete permanently",
    "emailInvalideTitre": "Invalid email",
    "emailInvalideMsg": "Please enter a valid email address (e.g. parent@email.com).",
    "entrezEmail": "Enter the email",
    "dejaAjouteTitre": "Already added",
    "dejaAjouteMsg": "This email is already in the list",
    "confirmSupprimerVisiteur": "Delete {nom}?",
    "modeGardeMaj": "The custody mode has been updated.",
    "supprimerPeriodeTitre": "Delete this period?",
    "supprimerPeriodeMsg": "The calendar will be recalculated for all remaining periods.",
    "repartitionAppliquee": "Holiday custody split applied to the calendar.",
    "supprimerSerie": "Delete the series",
    "supprimerSerieMsg": "Delete all recurring \"{titre}\" events?",
    "classePrecision": "Custom note (free text)",
    "classePrecisionPlaceholder": "e.g. school, teacher, specific level…",
    "supprEspaceTitre": "Delete space",
    "supprEspaceMsg": "“{nom}” will be deleted for all its members. The data attached to it will become inaccessible.",
    "changerCompte": "Switch account",
    "monCompte": "My account",
    "parametresCompte": "Account settings",
    "nomUtilisateur": "Username",
    "nomUtilisateurPlaceholder": "e.g. Cedric",
    "nomUtilisateurAide": "Shown everywhere in the suite. Must be unique.",
    "nomUtilisateurErreur": {
      "court": "Too short (2 characters minimum).",
      "long": "Too long (30 characters maximum).",
      "pris": "This username is already taken.",
      "inconnue": "Could not save, please try again."
    },
    "mesEspaces": "My spaces",
    "nEspacesSingulier": "{n} space",
    "nEspacesPluriel": "{n} spaces",
    "aucunEspacePossede": "No space owned",
    "nouvelEspace": "New space",
    "espacesAideAvant": "A space groups items (calendars, inventories, plans…) and the people who can access them. Only its",
    "proprietaireMot": "owner",
    "espacesAideApres": "sees and configures it; members access the items shared with them.",
    "aucunEspaceAide": "You don't own any space. Tap ➕ to create one.",
    "queFaireEspace": "What do you want to do with this space?",
    "nMembresSingulier": "{n} member",
    "nMembresPluriel": "{n} members",
    "actifMin": "active",
    "espacesAideMini": "Tap to activate · swipe right to edit, left to delete (long-press on web) · ➕ to create.",
    "membresEspace": "Space members",
    "nInviteSingulier": "{n} invited",
    "nInvitePluriel": "{n} invited",
    "moi": "(me)",
    "proprietaire": "Owner",
    "membre": "Member",
    "inviteEnAttente": "Invited · awaiting first sign-in to My Calendar",
    "emailAInviter": "email to invite",
    "membresAide": "The invited person joins the space on their first sign-in to My Calendar with this email. Set the access rights below.",
    "quiVoitQuoi": "Access management",
    "accesParMembre": "Access per resource",
    "quiVoitQuoiAide": "By default a resource is visible to its owner only. Grant access here, resource by resource: “Everyone in the space” or a specific person. You (the owner) always keep access.",
    "finance": "Finance",
    "budgetFinances": "Budget & finances",
    "budgetFinancesSous": "Coming soon — access already configurable",
    "fonctionsSous": "Enable / disable · tiers · add-ons",
    "aPropos": "About",
    "supprimerMonCompte": "Delete my account",
    "supprimerMonCompteTitre": "Delete my account",
    "supprimerMonCompteMsg": "Your account and data will be permanently deleted after a grace period. This is irreversible once that period ends. Confirm?",
    "versionMot": "version",
    "modulesComposant": "Modules making up this app:",
    "moduleLecture": "read only",
    "modifierEspace": "Edit space",
    "nomEspacePlaceholder": "e.g. Home, Studio, Shop…",
    "voirCalIvv": "Show IVV calendars",
    "voirCalIvvSous": "Adds the version-tracking calendars to your list (validators).",
    "gestionSpecifique": "App-specific settings",
    "gestionGenerique": "General settings",
    "gestionAutre": "Other settings",
    "surchargeFonctions": "Override features (IVV)",
    "surchargeFonctionsSous": "Overrides plan permissions for testing — validators only",
    "calIvvVisibles": "Visible calendars",
    "calIvvVisiblesSous": "Choose which IVV calendars appear in the list",
    "surchargeJetons": "Override my tokens (IVV)",
    "surchargeJetonsSous": "Force how many items you can manage, to test edge cases",
    "membres": "Members",
    "espace": "Space",
    "rendreActif": "Make active",
    "role_proprietaire": "Owner",
    "role_membre": "Member",
    "role_invite": "Guest",
    "sansLimiteJetons": "Disable the token limit (IVV)",
    "sansLimiteJetonsSous": "See and create without any quota, to compare with and without",
    "espacesCompteur": "{n}/{max} space(s) owned",
    "espacesMaxAtteint": "Space limit reached ({n}/{max}): delete a space to create another one.",
    "aproposVersion": "Version",
    "aproposCore": "Shared core",
    "aproposEtat": "Update",
    "aproposCanal": "Channel",
    "aproposBundle": "Bundle",
    "aproposEditeur": "Publisher",
    "aproposBase": "Backend"
  },
  "calendrier": {
    "semaineNum": "Wk {n}",
    "aujourdhui": "Today",
    "evenements": "Events",
    "maGardeUniquement": "My custody only",
    "assigneAMoi": "Assigned to me",
    "aucunEvenementPeriode": "No events in this period\nTap a day to add one",
    "horsGarde": "off custody",
    "aucunCalendrier": "No calendar",
    "aucunCalendrierAide": "Create a calendar from the Profile tab to get started.",
    "legendeVacances": "Holidays",
    "legendeJourFerie": "Public holiday",
    "legendeModifie": "Edited",
    "legendeDemEnvoyee": "Request sent",
    "legendeAApprouver": "To approve",
    "aucunEvenementJour": "No events on this day",
    "selectionnerPourModifier": "Select a calendar to edit",
    "demanderChangement": "Request a change",
    "modifierGarde": "Edit custody",
    "demandeEnvoyeeNote": "📬 A request will be sent to {prenom} for approval",
    "gardeActuel": "✓ current",
    "demander": "request ›",
    "revenirPlanning": "↩ Reset to schedule",
    "titre": "Calendar",
    "chargement": "Loading calendar…",
    "aucunAccessible": "No accessible calendar",
    "aucunAccessibleAide": "Ask a space owner to grant you access to a calendar, or create your own space in Profile.",
    "erreurLectureListe": "Your calendars could not be read — what follows may be inaccurate.",
    "erreurLectureDemandes": "Requests could not be read — the list may be incomplete.",
    "erreurLectureEvenements": "Events could not be read — the calendar may be incomplete.",
    "erreurLectureEdt": "The timetable could not be read — it may be incomplete.",
    "demandesCount": "Requests ({n})",
    "configuration": "Settings",
    "vacancesFeries": "Holidays",
    "gardesCoparentalite": "Custody (co-parenting)",
    "gardesDesactiveesTitre": "Custody disabled",
    "gardesDesactiveesMsg": "This calendar is of type “General”. Switch it to “Co-parenting” in Settings to manage custody.",
    "ouvrirConfiguration": "Open settings",
    "demandeGardeEnvoyeeMsg": "The custody change for {date} is awaiting {nom}'s approval.",
    "erreurAucunCalendrier": "No active space/calendar — cannot save.",
    "erreurEnregistrement": "Unable to save.",
    "supprEvtMsg": "“{titre}” will be deleted.",
    "evtTitreGuillemets": "“{titre}”",
    "ignorerCeJour": "Skip this day",
    "supprimerTouteSerie": "Delete the whole series",
    "vueSemCourt": "Wk",
    "ajouterEvenement": "Add an event",
    "filtres": "Filters",
    "voirSemaineA11y": "Double-tap: view the week",
    "legendeFerie": "Public holiday",
    "legendeEchange": "Swap (outline = scheduled custody)",
    "ferieLigne": "🎉 {nom} (holiday)",
    "demandesAAcquitter": "🧷 {n} custody request(s) to confirm",
    "journee": "Day",
    "aucunEvenementPoint": "No events.",
    "toucherPlusAjouter": " Tap ＋ to add one.",
    "gererRecurrence": "Manage recurrence",
    "touteLaJournee": "All day",
    "evtPlusieursJours": "Multi-day event",
    "lectureSeuleAide": "Read-only (write access required to edit).",
    "modifierEvenement": "Edit event",
    "nouvelEvenement": "New event",
    "phTitreEvt": "e.g. Dentist appointment",
    "categorieOptionnel": "Category (optional)",
    "aucuneCategorie": "No category",
    "dateDebut": "Start date",
    "memeJour": "same day",
    "jourEntier": "All day",
    "heureDebut": "Start time",
    "heureFin": "End time",
    "heureFinRequise": "End time is required (otherwise check “All day”).",
    "phNote": "Details…",
    "piecesJointesOptionnel": "Attachments (optional)",
    "repetition": "Repeat",
    "jours": "Days",
    "jusquauOptionnel": "Until (optional)",
    "repeterJusquau": "Repeat until",
    "sansFin": "no end",
    "aucuneRecurrence": "No recurrence yet. Create one via “Repeat” in a new event.",
    "supprimerRecurrence": "Delete recurrence",
    "supprRecurrenceMsg": "“{titre}” and all its occurrences.",
    "inactifSuffixe": " (inactive)",
    "desDate": "from {date}",
    "filtresIntro": "Uncheck to hide, on the displayed calendar. Shared across the Month / Week / Day views.",
    "nMasques": "{n} hidden",
    "toutAffiche": "All shown",
    "types": "Types",
    "allerAuJour": "Go to day",
    "allerALaSemaine": "Go to week",
    "repetQuotidien": "Every day",
    "repetHebdo": "Every week",
    "repetBimensuel": "Every 2 weeks",
    "repetMensuel": "Every month",
    "rechercherCalendrier": "Search for a calendar…",
    "switcherLegende": "★ ACTIVE (always shown) · 👁 SHOW ALSO",
    "switcherVide": "No calendar. Create one from the Calendar or Profile tab.",
    "definirActif": "Set as active",
    "sourceMopcal": "MoPCal (personal)",
    "sourceEspace": "Space",
    "actifSuffixe": " · active",
    "toujoursAffiche": "Always shown (active)",
    "masquer": "Hide",
    "afficher": "Show",
    "switcherPied": "Full management (create, rename, personal MoPCal) in Profile → “My calendars”.",
    "droitVoir": "View",
    "droitConfig": "Config",
    "configEnregistree": "Settings saved ✓",
    "configTitre": "Calendar settings",
    "sectionType": "Type & custody",
    "sousTitreCoparent": "Co-parenting · custody enabled",
    "sousTitreGeneral": "General · custody disabled",
    "introType": "A co-parenting calendar enables custody features (patterns, holiday split, per-parent colors). In \"General\", they are hidden.",
    "noteGardesGrisees": "\"Custody\" will be greyed out in the menu (long press) and custody displays hidden.",
    "phNomParent": "Parent {n}'s name",
    "personneAssociee": "Associated person (among access)",
    "aucune": "None",
    "demandesChangement": "Change requests",
    "demandesChangementSous": "A custody change creates a request to be acknowledged by the other parent (otherwise applied directly).",
    "demandesChangementA11y": "Custody change requests",
    "noteInviterMembres": "Invite members (Profile → \"Space members\") to associate an email with a parent.",
    "introAffichage": "Time grid for the Week and Day views.",
    "zoomCompact": "Compact",
    "zoomNormal": "Normal",
    "zoomLarge": "Large",
    "hauteurHeure": "Height of one hour (zoom)",
    "dureeDefaut": "Default event duration",
    "vueDemarrage": "Startup view",
    "vueMois": "Month",
    "vueSemaine": "Week",
    "vueJour": "Day",
    "sectionAcces": "Member access",
    "nMembres": "{n} member(s)",
    "nInvites": "{n} guest(s)",
    "introAcces": "Who can view this calendar, write events in it and configure it. By default, each member views and writes.",
    "pointerAcces1": "➕ To add a person, invite them in ",
    "pointerAccesFort": "Profile → \"Space members\"",
    "pointerAcces2": " (by email). They will appear here once they have joined the space.",
    "noteSeulToi": "This space only has you for now — invite members to share this calendar.",
    "aucunMembre": "No member in the space.",
    "proprietaireAccesTotal": "Owner · full access",
    "proprietaire": "Owner",
    "membre": "Member",
    "inviteEnAttente": "Guest · awaiting first sign-in to My Calendar",
    "noteInvitesDroits": "Pending guests will get their (adjustable) rights as soon as they first sign in to My Calendar (signing in to MoPCal is not enough). ",
    "noteAppStricte": "Setting saved on the calendar. Strict server-side enforcement will follow in a future version.",
    "modifierCal": "Edit calendar",
    "nouveauCal": "New calendar",
    "nomPlaceholder": "e.g. Personal, Work, Kids…",
    "typeCal_general": "General",
    "typeCal_coparentalite": "Co-parenting",
    "actif": "active",
    "aucunCal": "No calendar yet. Create a space (My spaces) or ask an owner for access.",
    "groupeMesEspaces": "From my spaces",
    "aideMesEspaces": "Calendars from your spaces (you own them). Tap to pick the ACTIVE one; swipe left to delete, right to edit; ➕ to create one.",
    "videMesEspaces": "No calendar in your spaces. Tap ➕ to create one.",
    "supprCalTitre": "Delete calendar",
    "supprCalMsg": "“{nom}” and its events will no longer be linked.",
    "groupePartages": "Shared with me",
    "aidePartages": "Calendars an owner has granted you access to. Tap to pick the ACTIVE one; management belongs to the owner.",
    "partageAvecToi": "Shared with you",
    "groupePerso": "My MoPCal calendars (personal)",
    "aidePerso": "Calendars you take part in. Showing them overlays them in YOUR view only — it exposes nothing to the other members of the space.",
    "afficheDansVue": "Shown in my view",
    "masque": "Hidden",
    "calendriersEspace": "Space calendars",
    "accesDansProfil": "Member access is now managed in Profile → \"Who sees what\" — like inventories and plans.",
    "horsPlageTitre": "Events outside the range",
    "horsPlageSous": "The grid extends to show events outside the displayed hours (tinted areas).",
    "ficheDate": "Date",
    "ficheHoraire": "Time",
    "ficheDuree": "Duration",
    "ficheCalendrier": "Calendar",
    "ficheNote": "Note",
    "badgeRecurrent": "🔁 Recurring",
    "badgePlage": "🗓️ Multi-day",
    "categories": "Categories",
    "ficheType": "Type",
    "aideQuinzaineSimple": "Every 14 days from the start date.",
    "aideQuinzaineJours": "Checked days, every other week from the start date's week.",
    "aideMensuelSimple": "Each month, on the same day of the month as the start date.",
    "aideMensuelJours": "Each month, the checked days of week {n} of the month.",
    "jusquau": "until",
    "reinitFiltres": "Reset filters",
    "reinitMsg": "Which filters should be reset? All items will be shown again (save with the disk icon).",
    "reinitOnglet": "{onglet} tab",
    "reinitTout": "All filters",
    "toutesLes": "Every",
    "tousLes": "Every",
    "suffSemaines": "week(s)",
    "suffMois": "month(s)",
    "aideSemainesJours": "Checked days, one week out of {n} from the first occurrence.",
    "aideTousLesNMois": "Applied every {n} months.",
    "repetNSemaines": "Every {n} weeks",
    "repetNMois": "Every {n} months",
    "suffJours": "day(s)",
    "repetNJours": "Every {n} days",
    "afficherGarde": "Show custody",
    "afficherVacances": "Show school holidays",
    "vueAnCourt": "Year",
    "repetJourCourt": "Day",
    "repetSemCourt": "Week",
    "repetMoisCourt": "Month",
    "joursIgnores": "Skipped days",
    "retablirAide": "Swipe a row left to restore that day in the series (a moved occurrence returns to its original date).",
    "deplacerOccurrence": "Move this event",
    "deplacerVersLe": "Move to…",
    "ficheDeplace": "Moved",
    "evtsDeplacesTitre": "Moved events out of range",
    "evtsDeplacesMsg": "These moved occurrences are no longer part of the new recurrence range. What should happen to the corresponding events?",
    "garderEvts": "Keep the events",
    "supprimerEvts": "Delete the events",
    "menuSources": "EVENT SOURCES",
    "menuConfiguration": "SETTINGS",
    "pasAffichage": "Display slots (Week/Day)",
    "rendreActif": "Make active",
    "ficheCalAide": "The ACTIVE calendar is the one opened by default. Swipe right to edit, left to delete.",
    "changerEspace": "Move to another space",
    "changerEspaceAide": "To a space you OWN: the calendar follows, you stay the owner. To someone else's space: you GIVE it away, ownership changes.",
    "deplacerSimple": "Your space — simple move",
    "donnerEtiquette": "Another member's space — you give the calendar away",
    "aucunAutreEspace": "No other space you belong to.",
    "donnerTitre": "Give this calendar away?",
    "donnerMsg": "The owner of « {espace} » becomes the calendar's owner. You lose control: you won't be able to grant it, nor take it back — only the new owner can. Your token grants on it will be removed.",
    "donnerConfirmer": "Give away"
  },
  "evenements": {
    "erreur": "Error",
    "calendrierIntrouvable": "Calendar not found",
    "supprimerEvenements": "Delete events",
    "supprimerNEvenements": "Delete {n} events?",
    "supprimerUnEvenement": "Delete 1 event?",
    "suppressionEchecN": "{n} event(s) could not be deleted.",
    "evenementRecurrentTitre": "🔁 Recurring event",
    "quoiSupprimer": "What would you like to delete?",
    "cetteOccurrence": "This occurrence",
    "cetteOccurrenceSeulement": "This occurrence only",
    "toutesLesOccurrences": "All occurrences",
    "supprimerEvenement": "Delete event",
    "supprimerConfirmation": "Delete \"{titre}\"?",
    "aucunCalendrier": "No calendar",
    "aucunCalendrierAide": "Add a child from the Profile tab.",
    "rechercherPlaceholder": "Search an event…",
    "periode": "Period",
    "sens": "Show",
    "sensAvenir": "Upcoming",
    "sensPasse": "Past",
    "sensTout": "All",
    "durantMaGarde": "During my custody only",
    "nSelectionnes": "{n} selected",
    "unSelectionne": "{n} selected",
    "aucunResultat": "No results for \"{recherche}\"",
    "aucunEvenementPeriode": "No events in this period\nTap a day on the calendar to add one",
    "horsGarde": "outside custody",
    "gardeLabel": "Custody: {nom}",
    "ouvrirDansMaps": "Open in Maps →",
    "ouvertureFichierImpossible": "Unable to open this attachment.",
    "evenementRecurrent": "Recurring event",
    "saisiManuellement": "Entered manually",
    "creePar": "✨ Created by ",
    "modifiePar": "✏️ Edited by ",
    "commentaires": "Comments",
    "quelquun": "Someone",
    "aucunCommentaire": "No comments yet",
    "commentairePlaceholder": "Write a comment…",
    "nPiecesJointes": "{n} attachments",
    "unePieceJointe": "{n} attachment",
    "recurrence": "Recurrence",
    "manuel": "Manual",
    "modifie": "edited",
    "visibilitePrive": "🔒 Private",
    "visibiliteParents": "👥 Parents",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "catSport": "Sport",
    "catSante": "Health",
    "catEcole": "School",
    "catAnniversaire": "Birthday",
    "catVacances": "Holidays",
    "catFamille": "Family",
    "catActivite": "Activity",
    "catRdv": "Appointment",
    "catRepas": "Meal",
    "catAutre": "Other",
    "filtreRecurrents": "Recurring",
    "filtrePonctuels": "One-off",
    "typeSimple": "One-off",
    "typeRecurrent": "Recurring",
    "typeRepas": "Meals",
    "typeEdt": "Timetable"
  },
  "demandes": {
    "titre": "Requests",
    "enAttenteResume": "{enAttente} response(s) pending out of {total}",
    "statutApprouve": "Approved",
    "statutRefuse": "Declined",
    "statutEnAttente": "Pending",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "toutValider": "Approve all",
    "tousLesCalendriers": "all calendars",
    "confirmToutValider": "Approve the {nb} pending request(s) on {portee}?",
    "validationIncomplete": "Incomplete approval",
    "validationIncompleteMsg": "{echecs} request(s) could not be approved.",
    "changementGarde": "Custody change",
    "ajoutEvenement": "New event",
    "refuserDemande": "Decline the request",
    "approuverDemande": "Approve the request",
    "demandePar": "Requested by {nom} · {date}",
    "traitePar": "Handled by {nom}",
    "info": "(info)",
    "annulerDemande": "Cancel request",
    "annulerDemandeMsg": "Do you want to withdraw this request?",
    "ouiAnnuler": "Yes, cancel",
    "erreur": "Error",
    "retirerMaDemande": "Withdraw my request",
    "ongletATraiter": "To review",
    "ongletMesDemandes": "My requests",
    "ongletHistorique": "History",
    "autoAcquittee": "Auto — single parent",
    "toutValiderDemandes": "Approve all requests",
    "videATraiter": "No requests to review",
    "videMesDemandes": "No pending requests",
    "videHistorique": "History is empty",
    "approuver": "Approve",
    "refuser": "Decline",
    "messageOptionnel": "Message (optional)",
    "ajouterCommentaire": "Add a comment...",
    "confirmer": "Confirm",
    "statutAppliquee": "Applied",
    "statutAcquittee": "Acknowledged ✓",
    "statutRefusee": "Declined ✕",
    "statutAttente": "Pending…",
    "proposePar": "Proposed by {nom}",
    "unParent": "a parent",
    "vousSuffixe": " (you)",
    "acquitter": "Acknowledge ✓",
    "changementRetireMsg": "The change on {date} will be removed.",
    "annulerMaDemande": "Cancel my request",
    "retirerLaDemande": "Withdraw the request",
    "retirerLaDemandeMsg": "The request from {date} will be removed.",
    "titreGarde": "Custody requests",
    "videGarde": "No request. Double-tap a day in the calendar to propose a custody change to the other parent.",
    "sectionEnAttente": "Pending ({n})",
    "rechercher": "Search (date, parent, message…)",
    "aucunResultat": "No request matches this search.",
    "historiqueTronque": "{n} of {total} requests — search a date to see the others.",
    "filtreStatutTitre": "Filter by status",
    "filtreToutes": "All",
    "triTitre": "Sort",
    "triRecent": "Newest first",
    "triAncien": "Oldest first"
  },
  "listes": {
    "titre": "Lists & shopping",
    "aucuneListe": "No lists",
    "erreurLectureListes": "Lists could not be read — the list below may be incomplete.",
    "erreurLectureItems": "Items could not be read — the list below may be incomplete.",
    "nouvelleListe": "New list",
    "quotaTitre": "Limit reached",
    "quotaMsg": "Your plan doesn't allow adding more lists. Upgrade to create more.",
    "renommer": "Rename list",
    "phNomListe": "List name…",
    "phAjouterItem": "Add an item…",
    "typeTaches": "Tasks",
    "typeCourses": "Shopping",
    "listeVide": "Empty list",
    "compteurSingulier": "{restants} left · {total} total",
    "compteurPluriel": "{restants} left · {total} total",
    "erreur": "Error",
    "supprListeTitre": "Delete list",
    "supprListeMsg": "Delete \"{titre}\" and all its items?",
    "supprItemsTitre": "Delete items",
    "supprItemsMsg": "Delete the {n} selected item(s)?",
    "nSelectionnes": "{n} selected",
    "icone_taches": "Tasks",
    "icone_courses": "Shopping",
    "icone_cadeaux": "Gifts",
    "icone_voyage": "Travel",
    "icone_repas": "Meals",
    "icone_ecole": "School",
    "droits": "Rights",
    "droitsTitre": "Rights — {titre}",
    "droitLire": "View",
    "droitModifier": "Edit",
    "droitCocher": "Check",
    "aucunMembre": "No member to configure",
    "cochePar": "✓ {nom} · {date}",
    "editerTache": "Edit task",
    "nom": "Name",
    "quantite": "Quantity",
    "unite": "Unit",
    "prix": "Price",
    "articlePrix": "Item (price)",
    "prixIngredient": "Ingredient price",
    "totalEstime": "Estimated total",
    "justificatif": "Receipt / invoice",
    "justifVide": "No receipt yet. Add a photo of the till receipt or invoice.",
    "phQuantite": "Qty",
    "phUnite": "u, kg, L…",
    "commentaire": "Comment",
    "phCommentaire": "Add a comment…",
    "photos": "Photos",
    "camera": "Camera",
    "ajouterPhoto": "Gallery",
    "aucunePhoto": "No photo",
    "supprPhotoTitre": "Remove photo",
    "supprPhotoMsg": "Remove this photo from the task?",
    "permissionTitre": "Permission",
    "permissionPhotos": "Allow photo access to add an image.",
    "catalogueTitre": "Product reference",
    "piocherTitre": "Pick an ingredient",
    "piocheVide": "Your reference is empty. Add products from the « Product reference » card.",
    "piocheRecherche": "Search an ingredient…",
    "piocheTous": "All",
    "piocheAucun": "No matching ingredient."
  },
  "plans": {
    "titre": "Plans & locations",
    "foyer": "Home",
    "aucunCalendrier": "Pick a calendar to see its locations.",
    "aucunEmplacement": "No location for this home yet. Add some from an inventory (locations structure).",
    "lieuVide": "This place has no sub-location yet.",
    "aidePlan": "Tap a place to enter it. The badge = total number of items stored (including sub-places).",
    "aideListe": "Tap a place to enter it. The badge = total number of items (including sub-places).",
    "recherchePlaceholder": "Search an item, an element or a place…",
    "aucunResultat": "No result.",
    "editerPlan": "Edit plan",
    "editerPlanDe": "Plan of {nom}",
    "aPlacer": "To place (tap one, then a plan cell · double-tap on the plan = remove)",
    "editerStructure": "Edit locations structure",
    "structureFoyer": "Home locations",
    "structureDe": "Sub-locations of {nom}",
    "structureVide": "No location here. Add one below.",
    "structureAide": "Swipe a row to edit or delete it. ➕ adds a sub-location; › goes inside.",
    "ajouterLieu": "Add a location",
    "ajouterSousLieu": "Add a sub-location",
    "aidePastille": "Tap a place to enter it, its badge to see its contents below, or the current place name (breadcrumb) for all its contents. Double-tap the badge = window + search.",
    "ouvrirContenu": "Open large",
    "faireInventaire": "Do this place's inventory",
    "lieuAucunObjet": "No item stored here.",
    "supprArticleMsg": "Delete “{nom}”?",
    "supprElementMsg": "Delete element “{nom}” and all its articles?",
    "nLieux": "{n} places selected",
    "suffixeCopie": "(copy)",
    "rechercheContenu": "Filter items…",
    "type_lieu": "Place",
    "type_element": "Element",
    "type_article": "Item",
    "creerEspaceMsg": "Create a space (Profile) to add a plan.",
    "configuration": "Configuration",
    "comptageEnregistre": "Count saved: {n} article(s) checked.",
    "qrLieuInexistant": "This QR points to a place that no longer exists in this space.",
    "objetRangeNullePart": "{nom} is in the inventory, but not stored anywhere.",
    "codeAucunObjet": "Code {code}: no matching item in this space.",
    "supprLieuTitre": "Delete place",
    "supprLieuMsg": "\"{nom}\" and its sub-places will be deleted. Items stored there will lose their location (they are not deleted).",
    "titrePlansEmplacements": "Plans & Locations",
    "choisisPlan": "Choose a plan",
    "aucunPlan": "No plan",
    "aidePlanCreer": "Create a plan (House, Garage, Cellar…) with \"＋ Plan\" above to organize your storage places.",
    "aidePlanPartage": "No plan shared with you yet. Ask an owner for access, or create a space in Profile.",
    "scannerAcc": "Scan a place QR or a barcode",
    "comptageEnCours": "Count in progress · {n} article(s) checked",
    "colonnesN": "Columns: {n}",
    "lignesN": "Rows: {n}",
    "aPlacerTitre": "To place",
    "aideMurs": "Tap a cell edge to add or remove the chosen divider.",
    "aidePlacement": "Choose a place \"to place\" then tap a cell. Double-tap a tile to remove it, long-press to rename it.",
    "lieuxEspace": "Places in the space",
    "contenuDe": "Contents of \"{nom}\"",
    "aucunLieuNiveau": "No place at this level",
    "aucunLieuNiveauAide": "Tap ＋ at the top right to create one.",
    "nObjets": "{n} item(s)",
    "nSousLieux": "{n} sub-place(s)",
    "aideSwipeLignes": "Swipe a row: ← delete, → edit / duplicate.",
    "masquerVidesAcc": "Hide empty locations",
    "videsMasques": "Empty locations hidden · 🌿 to show all.",
    "typeLieu": "Place",
    "aucunLieuIci": "No place here",
    "aucunLieuIciAideEdit": "Tap 🌳 at the top to create your storage places.",
    "rienAAfficher": "Nothing to show.",
    "aucunObjetIci": "No item here.",
    "aideTuiles": "Tapping a tile shows its contents, double-tapping enters it. Long-press = multiple selection.",
    "aucunContenuNiveau": "No contents at this level.",
    "motifNonTrouve": "\"{nom}\" not found",
    "motifAide": "Why? (lent, broken, thrown away, misplaced…) — optional.",
    "phMotif": "Reason",
    "passer": "Skip",
    "rangerDans": "Store in…",
    "rangerDansCourt": "Store in",
    "racineSuffixe": "(root)",
    "phNomLieu": "e.g. Kitchen, Top cupboard, Shelf B…",
    "arbreRangementPartage": "The shared storage tree",
    "nouveauPlan": "New plan",
    "modifierPlan": "Edit plan",
    "selecteurAide": "Tap a plan to open it · long-press = rename / delete.",
    "supprimerPlanTitre": "Delete plan",
    "supprimerPlanMsg": "\"{nom}\" and its location structure will be deleted (stored items will lose their location).",
    "nomPlan": "Plan name",
    "nomPlanPlaceholder": "e.g. House, Garage, Cellar…"
  },
  "inventaire": {
    "titre": "Inventory / stock",
    "erreur": "Error",
    "nouvelInventaire": "New inventory",
    "renommer": "Rename inventory",
    "aucunInventaire": "No inventory yet",
    "aucunCalendrier": "Pick a calendar to manage your stock.",
    "phNomInventaire": "Inventory name…",
    "partirDe": "Start from…",
    "modeleVide": "Empty",
    "modeleVideDesc": "Build it yourself",
    "nbCategories": "{n} categories",
    "modeleInfo": "The template will load categories and properties you can edit afterwards: {desc}.",
    "supprInvTitre": "Delete inventory",
    "supprInvMsg": "\"{titre}\" and all its items will be deleted.",
    "nom": "Name",
    "faireInventaire": "Take stock",
    "modeEdition": "Edit mode",
    "proprietes": "Properties",
    "categorieRacine": "New category",
    "nPieces": "{n} items",
    "dernierInventaire": "Last count:",
    "jamaisInventorie": "Never counted",
    "rechercher": "Search an item…",
    "hintEdition": "Edit mode (categories): tap an emoji to change it · swipe a category to edit/delete it · ➕ on a category's row to add a sub-category to it · 🏷️ for properties. Items are added with the ➕ button (outside this mode).",
    "ajouterSousCategorieIci": "add a sub-category here",
    "ajouterCategorieRacine": "add a category",
    "exporter": "Export",
    "exportChoix": "Choose what to export:",
    "exporterModele": "Export structure (template)",
    "exporterModeleDesc": "Categories and properties only ({n} categories). Great to reuse or share the layout.",
    "exporterComplet": "Export full inventory",
    "exporterCompletDesc": "Structure + all items ({n}). Great for a backup or transfer.",
    "exportInclurePhotos": "Include photos",
    "exportInclurePhotosDesc": "Applies to the full export: photos (items, articles, categories) are embedded in the file — it becomes larger, but self-contained and importable anywhere.",
    "exportEnCours": "Generating file… (photos are downloaded and embedded, this may take a moment).",
    "exportPdfTitre": "PDF (print / share)",
    "exportPdfDesc": "A readable document, grouped by category.",
    "pdfRecap": "PDF — summary",
    "pdfRecapDesc": "Current quantities shown. To share or archive.",
    "pdfComptage": "PDF — counting sheet",
    "pdfComptageDesc": "Blank « to count » column + checkbox. For paper inventory.",
    "pdfOptPhotos": "PDF: include photos",
    "pdfOptProps": "PDF: include properties",
    "pdfOptVides": "PDF: include empty categories",
    "exportPhotosNote": "Photos are not included in the export yet (coming soon).",
    "importerFichier": "Import a file…",
    "importerFichierDesc": "Loads an exported inventory (template or full .json).",
    "importInvalide": "Unrecognized file: this is not a valid MoPCal inventory export.",
    "importTitreDefaut": "Imported inventory",
    "importPartielTitre": "Partial import",
    "importPartielMsg": "{ajoutes} items imported. {ignores} could not be added (your plan's item limit was reached).",
    "hintAjout": "Add-items mode: tap « + add an item here » under a category. Tap ➕ at the top again to leave this mode.",
    "hintVidesMasquees": "Empty items and categories hidden · tap 🌿 again to show all.",
    "masquerCategoriesVides": "Hide empty categories",
    "afficherCategoriesVides": "Show empty categories",
    "ajouterElement": "Add an item",
    "aucunElement": "No item found.",
    "arbreVide": "This inventory is empty. Turn on edit mode ⚙️ to create categories.",
    "arbreVideEdit": "Tap « + add a category » below to create a first category.",
    "nonClasse": "Uncategorized",
    "ajouterElementIci": "add an item here",
    "compteLe": "counted",
    "jamaisCompte": "never counted",
    "dateInventaire": "Inventory date",
    "dateInventaireAide": "Pick the date the inventory was (or is) done. Defaults to today; you can set a past date.",
    "demarrer": "Start",
    "inventaireDu": "Inventory of {date}",
    "hintSession": "Tap an article's icon to mark it: ❔ undetermined → ✅ present → ❌ not found. The ⌖ icon moves it, 💬 notes a reason if not found. 💾 saves, ✕ cancels.",
    "pointer": "Mark article",
    "deplacer": "Move article",
    "raison": "Reason (not found)",
    "raisonTitre": "Why not found?",
    "raisonAide": "Explain why the article wasn't found (lent, lost, thrown away…). This note stays on the article and in its inventory history.",
    "raisonPlaceholder": "e.g. lent to Paul, lost, thrown away…",
    "indetermine": "Undetermined",
    "histInvTitre": "Inventory history",
    "historiqueInventaires": "Inventory history",
    "aucunHistorique": "No inventory recorded yet.",
    "nbArticlesPointes": "{n} article(s) checked",
    "rechercheHist": "Search an article or an element…",
    "aucunResultat": "No result",
    "achat": "Purchase",
    "prixPlaceholder": "Price (€)",
    "dateAchat": "Purchase date",
    "ticketFacture": "Receipt / invoice",
    "exporterPdf": "Export as PDF",
    "verifie": "Checked",
    "categorie": "Category",
    "nouvelleCategorie": "New category",
    "sousCategorie": "New subcategory",
    "modifierCategorie": "Edit category",
    "icone": "Icon",
    "iconeCategorie": "Category icon",
    "phNomCategorie": "e.g. Toys, Books…",
    "structure": "Structure",
    "ajouterSousCategorie": "Add a subcategory",
    "deplacerVers": "Move under another…",
    "deplacerTitre": "Move to…",
    "racine": "Root",
    "supprCatTitre": "Delete category",
    "supprCatMsgN": "{n} item(s) here (or in subcategories) will move back to « Uncategorized ».",
    "supprCatMsgVide": "Empty category.",
    "proprietesTitre": "List properties",
    "proprietesIntro": "Extra fields on each item (optional).",
    "aucunePropriete": "No property.",
    "ajouterPropriete": "add a property",
    "nouvellePropriete": "New property",
    "phNomPropriete": "e.g. Size, Brand, Purchase date",
    "type": "Type",
    "type_texte": "Text",
    "type_nombre": "Number",
    "type_date": "Date",
    "type_liste": "List",
    "options": "Options (comma-separated)",
    "phOptions": "Red, Blue, Green",
    "phDate": "YYYY-MM-DD",
    "fiche": "Item details",
    "element": "Item",
    "article": "Article",
    "seuil": "threshold",
    "seuilBas": "Low threshold (alert)",
    "seuilDesactive": "No low-stock alert for this item.",
    "seuilElement": "Detection threshold (item)",
    "seuilElementAide": "Alerts if the total quantity drops below a threshold. Each multiple article's threshold is set on the article.",
    "quantite": "Quantity",
    "nouvelElement": "New item",
    "modifierElement": "Edit item",
    "phNomElement": "e.g. Briefs size 6y",
    "detailleSomme": "Detailed item → quantity is the sum of its articles. Edit articles from the details view.",
    "detaillerParArticle": "Split into articles",
    "voirArticles": "Show / hide articles",
    "exemplaireUnique": "Single copy",
    "uniqueAide": "Unique item: present or absent (no quantity).",
    "multipleAide": "Item in multiple copies: counted quantity.",
    "present": "Present",
    "absent": "Absent",
    "articlesN": "Articles ({n}) — total {total}",
    "ajouterArticle": "add an article",
    "nouvelArticle": "New article",
    "modifierArticle": "Edit article",
    "nomArticle": "Article name",
    "elementParent": "Item (attachment)",
    "emplacement": "Location",
    "emplacements": "Locations",
    "emplacementsAide": "Structure mode: swipe a location to edit or delete it, ➕ to add a sub-location.",
    "emplacementsPlanAide": "Plan mode: tap 🗺 on a location to place its sub-locations on a 2D grid.",
    "emplacementsApercu": "Where items are stored (Home › Kitchen › Cupboard 1). Top right: ✏️ edit structure · 🗺 configure the plan.",
    "editerStructure": "Edit structure",
    "editerPlan": "Edit plan",
    "aucunEmplacement": "None",
    "aucunEmplacementDef": "No location defined yet. Add one to organize items by place.",
    "gererEmplacements": "Manage",
    "ajouterEmplacement": "add a location",
    "ajouterSousEmplacement": "+ sub-location",
    "modifierEmplacement": "Edit location",
    "nouvelEmplacement": "New location",
    "sousEmplacement": "Sub-location",
    "phNomEmplacement": "e.g. Cupboard 1, Garage, Paul's place…",
    "filtrerEmplacement": "Filter by location",
    "toutInventaire": "Whole inventory",
    "sansEmplacement": "No location",
    "emplacementVide": "Nothing stored here yet.",
    "consommable": "Consumable",
    "consommableAide": "An item you use up and rebuy (food, hygiene, paper…). Used by the 🛒 filter.",
    "filtrerConsommables": "Show consumables only",
    "aucunConsommable": "No consumable item yet.",
    "plan": "Map",
    "planAide": "Place the sub-locations on the grid: tap a tile to select it, then an empty cell to move it. Adjust size, number of columns and rows. Remember 💾 at the top right to save.",
    "planSelAide": "Tap a tile to select it, then a cell to move it.",
    "planMursAide": "Wall mode: pick thin wall, thick wall, door or window, then tap a border (including the outline) to place it. Tap the same spot again to remove it. Remember 💾 to save.",
    "planMursSelAide": "Tap a border (inside or on the outline) to add / remove the selected divider.",
    "planPlacer": "Place",
    "planMurs": "Walls",
    "planMurFin": "Thin",
    "planMurEpais": "Thick",
    "planPorte": "Door",
    "planFenetre": "Window",
    "planForme": "Free shape",
    "planFormeSelAide": "Free shape: tap a neighbouring cell to add it to the zone (or a zone cell to remove it). Allows L-shaped rooms.",
    "planVide": "Add sub-locations first to be able to position them.",
    "planViewAide": "Tap an area to go into the sub-location. The « ‹ » arrow at the top goes up one level.",
    "colonnes": "Columns",
    "lignes": "Rows",
    "taille": "Size",
    "ouEstCeRange": "Where is it stored?",
    "voirPlan": "View map",
    "emplacementParentLieu": "Parent location",
    "racineLieu": "Root (no parent)",
    "choisirEmplacement": "Choose a location",
    "choisirElement": "Attach to an item",
    "gererArbreLieux": "Manage the locations tree",
    "lieuCalendrier": "Calendar place (address)",
    "aucunLieuCal": "None",
    "rangerElement": "Location for the whole item",
    "rangerElementAide": "Pick a location: it will apply to ALL articles of \"{nom}\".",
    "lieuxMultiples": "multiple locations",
    "rangerIci": "Store here",
    "rangerIciVers": "Store in {emp}",
    "rangementEnCours": "Storing in progress",
    "rangementAide": "Scan products: they get stored here.",
    "terminer": "Done",
    "imprimerQr": "Print QR codes (to stick)",
    "qrAide": "Print one QR per location and stick it on the furniture. Then scan it (📷 button) to see everything stored inside.",
    "qrInconnuTitre": "QR from another inventory",
    "qrInconnuMsg": "This location QR does not belong to this inventory.",
    "supprEmpTitre": "Delete location",
    "supprEmpMsg": "Items stored here will lose their location (they are not deleted).",
    "elementParentDeplace": "The article will be moved to this item.",
    "scanner": "Scan a barcode",
    "scanRapide": "Quick scan",
    "dejaDans": "Already in « {cat} ».",
    "dejaUnique": "This is a single copy. Add another copy anyway?",
    "ouvrirObjet": "Open item",
    "creerQuandMeme": "Create a new item",
    "passerMultiple": "Switch to multiple (+1)",
    "creerNouveauDistinct": "Create a separate item",
    "scannerSuivant": "Scan next",
    "recherche": "Searching…",
    "rechercheProduit": "Looking up product…",
    "enregistrement": "Saving…",
    "codeBarres": "Barcode",
    "produitIntrouvableTitre": "Product not found",
    "produitIntrouvableMsg": "This barcode wasn't found in the public databases (books, food). The code is saved; fill in the details manually.",
    "produitReseau": "Couldn't reach the public databases. Check your connection.",
    "phNomArticle": "e.g. Red briefs",
    "supprimerArticle": "Delete this article",
    "photo": "Photo",
    "photos": "Photos",
    "camera": "Camera",
    "galerie": "Gallery",
    "permissionTitre": "Permission",
    "permissionPhotos": "Allow photo access to add an image.",
    "inventairesPlans": "Inventories & plans",
    "supprModeleTitre": "Delete template",
    "supprModeleMsg": "\"{nom}\" will be removed from your templates.",
    "titreDefaut": "Inventory",
    "titrePluriel": "Inventories",
    "aucunInvAideCreer": "Tap ＋ at the top right to create one, from a template or from scratch.",
    "aucunInvEspace": "No inventory in this space.",
    "aucunInvPartage": "No inventory shared with you. Create a space in Profile to add one, or ask an owner for access.",
    "nbCategoriesN": "{n} categor(ies)",
    "sansCategorie": "No category",
    "nProprietes": "{n} propert(ies)",
    "astuceAppuiLong": "Long-press an inventory to edit it.",
    "astuceSwipe": "Swipe a row: ← delete, → edit.",
    "modifierInventaire": "Edit inventory",
    "phTitreInventaire": "e.g. Kitchen cupboards",
    "partirModele": "Start from a template",
    "inventaireVide": "Empty inventory",
    "inventaireVideDesc": "I'll create my own categories",
    "mesModeles": "My templates",
    "structureEnregistree": "Saved structure",
    "modeleMeta": "{c} categor(ies) · {p} propert(ies)",
    "appuiLongSupprimer": "long-press to delete",
    "modelesPrets": "Ready-made templates",
    "modeleEnregistre": "Template \"{nom}\" saved — reusable when creating one.",
    "supprElementTitre": "Delete item",
    "elementSeraSupprime": "\"{nom}\" will be deleted.",
    "supprArticleTitre": "Delete article",
    "trouve": "Found: {nom}",
    "codeInconnu": "Code {code} unknown here — new item.",
    "supprCatMsgBase": "\"{nom}\" and its sub-categories will be deleted.",
    "supprCatMsgElements": " {n} item(s) will move to \"no category\".",
    "importe": "Imported: {n} item(s).",
    "nArticles": "{n} article(s)",
    "compter": "Count",
    "sousCategorieAcc": "Sub-category",
    "structureInventaire": "Inventory structure",
    "structureInventaireSous": "Categories, sub-categories and items (buttons + swipe)",
    "proprietesPersonnalisees": "Custom properties",
    "proprietesPersoSous": "Additional article fields (author, condition…)",
    "enregistrerModele": "Save as template",
    "enregistrerModeleSous": "Reuse this structure (categories + properties) on another inventory",
    "exporterTransferer": "Export / transfer",
    "exporterTransfererSous": "Share the inventory with another account (data included)",
    "reglagesDe": "Settings for \"{nom}\".",
    "cetInventaire": "the inventory",
    "scannerAcc": "Scan",
    "transfererAcc": "Transfer",
    "imprimerAcc": "Print",
    "configArbreBarre": "Tree setup · swipe ← delete / → edit",
    "nPiecesN": "{n} item(s)",
    "rechPlaceholder": "Name, article or barcode",
    "hintVides": "Empty categories hidden · 🌿 to show all.",
    "aucunElementVide": "No item",
    "aucunElementAide": "Tap ＋ to add one, or 📷 to scan a product.",
    "aucuneCategorie": "No category",
    "aucuneCategorieAide": "Tap ＋ to create one.",
    "modeleInfoDetail": "Only the structure is saved: {c} categor(ies) and {p} propert(ies). Articles are not included. Reusable when creating another inventory.",
    "nomModele": "Template name",
    "phNomModele": "e.g. Library by genre",
    "rangerDansTitre": "Move to…",
    "rangerDansLabel": "Move to",
    "phNomCategorieEx": "e.g. Canned goods, Tops…",
    "supprProprieteTitre": "Delete property",
    "supprProprieteMsg": "\"{nom}\" will be removed from the articles.",
    "modifierPropriete": "Edit property",
    "proprietesPersoTitre": "Custom properties",
    "phProprieteExemple": "e.g. Author, Publisher, Condition…",
    "optionsParLigne": "Options (one per line)",
    "phOptionsListe": "New\nGood condition\nUsed",
    "proprietesPersoIntro": "These fields are added to every article in the inventory.",
    "aucuneProprietePerso": "No properties yet.",
    "transfTitre": "Transfer & print",
    "transfTermine": "{libelle}: done.",
    "transfExportModele": "Template export",
    "transfExportComplet": "Full export",
    "transfExportPdf": "PDF export",
    "transfPlancheQr": "QR sheet",
    "transfImport": "Import",
    "transfAucunEmplacement": "No location: first create your places in the Plans tab.",
    "transfModeleTitre": "Template (structure only)",
    "transfModeleDesc": "Categories and properties, without the items — to recreate the same inventory elsewhere.",
    "transfCompletTitre": "Full backup",
    "transfCompletDesc": "Structure + items + locations, as JSON.",
    "transfEmbarquerPhotos": "Embed photos",
    "transfEmbarquerPhotosDesc": "Much larger file, but self-contained (photos in base64).",
    "imprimer": "Print",
    "transfPdfRecapTitre": "Summary PDF",
    "transfPdfRecapDesc": "Current quantities, to archive or share.",
    "transfPdfComptageTitre": "Count sheet",
    "transfPdfComptageDesc": "Known quantity in small print + a blank column to fill in on site.",
    "transfAvecPhotos": "With photos",
    "transfAvecProprietes": "With properties",
    "transfInclureCatsVides": "Include empty categories",
    "transfInclurePlans": "Include 2D plans",
    "transfPlancheQrTitre": "Sheet of location QR codes",
    "transfPlancheQrDesc": "One label per place, to cut out and stick on the furniture.",
    "importerTitre": "Import",
    "transfImportTitre": "Load a .json file",
    "transfImportDesc": "Template or full backup, produced by My Inventory or MoPCal.",
    "transfImportAide": "Importing CREATES a new inventory — it never replaces this one. Identifiers are regenerated, and category / location / property links are rebuilt.",
    "ficheQuantite": "Quantity: {n}",
    "detailsTitre": "Details",
    "auteur": "Author",
    "editeur": "Publisher",
    "parution": "Published",
    "pages": "Pages",
    "retirerArticleTitre": "Remove article",
    "retirerArticleMsg": "\"{nom}\" will be removed from the item.",
    "sansNom": "unnamed",
    "codeInvalideMsg": "This code doesn't look like a product barcode.",
    "codeInconnuMsg": "Code {c} saved, but unknown to the catalog — fill in the name manually.",
    "codeEnregistreMsg": "Code {c} saved.",
    "codeReseauMsg": "Network unavailable — the code is saved, the name still needs to be entered.",
    "sourceReferentiel": "Catalog",
    "sourcePublique": "Public database",
    "phNomElementEx": "e.g. Cans of tomatoes",
    "seuilAlerteElement": "Item alert threshold",
    "seuilAlerteAide": "Compared to the item's TOTAL quantity (all articles combined). 0 = no alert.",
    "articlesCount": "Articles ({n})",
    "articlesMultiAide": "Several articles = several variants of the same object (sizes, scents, batches), each with its own quantity, photo, barcode and location.",
    "articleN": "Article {n}",
    "commeElement": "Same as the item",
    "seuilArticle": "Article threshold",
    "phCodeBarres": "Enter or scan",
    "rangeDans": "Stored in",
    "nullePart": "Nowhere",
    "phAnnee": "YYYY",
    "prixAchat": "Purchase price (€)",
    "phDateJJMMAAAA": "DD/MM/YYYY",
    "exemplaireUniqueInline": "Single copy: present or absent (no quantity).",
    "consommableInline": "Consumable: gets used up and repurchased (used by the 🛒 filter).",
    "iconeElement": "Item icon",
    "planCloison": "Partition",
    "planMur": "Wall",
    "niveauSansSousEmplacement": "This level has no sub-location to display.",
    "niveauAucun": "None",
    "niveauLecteur": "Viewer",
    "niveauEditeur": "Editor",
    "responsableAccesComplet": "Owner: full access",
    "aucunMembreAutoriser": "No other member to authorize.",
    "aucunInventaireRegler": "No inventory to configure yet.",
    "supprPhotoTitre": "Delete photo",
    "supprPhotoMsg": "This photo will be removed from the item.",
    "photosAide": "Tap a photo to enlarge it · long-press to remove it.",
    "scannerMixte": "Scan a barcode or QR code",
    "viseMixte": "Aim at a barcode or QR code",
    "viseBarcode": "Aim at the product barcode",
    "scanIndispoNatif": "Camera scanning isn't available here. Enter the code manually.",
    "scanAutoriser": "Allow camera access to scan.",
    "scanPreparation": "Preparing the camera…",
    "scanAutoriserBouton": "Allow camera",
    "scanRefusWeb": "Camera access denied. Allow it in your browser settings, or enter the code manually.",
    "scanIndispoWeb": "Scanning isn't available here. Enter the code manually.",
    "scanErreurWeb": "Couldn't open the camera. Enter the code manually.",
    "saisirManuel": "Enter manually",
    "tplGardeRobe": "Wardrobe",
    "tplGardeRobeDesc": "Clothes, shoes and accessories by type",
    "tplPlacardsFrigo": "Cupboards & fridge",
    "tplPlacardsFrigoDesc": "Groceries, canned goods, fresh, frozen, drinks",
    "tplUstensilesCuisine": "Kitchen utensils",
    "tplUstensilesCuisineDesc": "Cookware, dishes, cutlery, appliances",
    "tplValiseVacances": "Suitcase / Holidays",
    "tplValiseVacancesDesc": "Packing checklist for travel",
    "tplOutilsBricolage": "Tools & DIY",
    "tplOutilsBricolageDesc": "Tools, hardware, paint, garden",
    "tplJouetsJeux": "Toys & games",
    "tplJouetsJeuxDesc": "Children's toys by type",
    "tplBibliotheque": "Library",
    "tplBibliothequeDesc": "Books by genre",
    "tplPharmacie": "Medicine cabinet",
    "tplPharmacieDesc": "Medicines and first-aid supplies",
    "tplCaveVin": "Wine cellar",
    "tplCaveVinDesc": "Bottles by color and region",
    "tplSalleDeBain": "Bathroom",
    "tplSalleDeBainDesc": "Hygiene, beauty, cleaning",
    "typeTexte": "Text",
    "typeNombre": "Number",
    "typeDate": "Date",
    "typeListe": "Choice list"
  },
  "budget": {
    "titre": "Budgets",
    "solde": "Balance",
    "equilibre": "Settled up",
    "doit": "{debiteur} owes {montant} to {crediteur}",
    "totalPartage": "Spent",
    "estime": "Estimated",
    "inclureEstime": "Include estimate (upcoming recurrences)",
    "aucunBudget": "No budgets",
    "nouveauBudget": "New budget",
    "modifierBudget": "Edit budget",
    "nomBudget": "Budget name",
    "emoji": "Emoji (optional)",
    "nomBudgetPlaceholder": "e.g. Holidays, School…",
    "membres": "Members",
    "membresAide": "Can add payments.",
    "observateurs": "Observers",
    "observateursAide": "Can only view.",
    "payeurs": "Payers (split)",
    "payeursAide": "Each person's share as a percentage. The total should be 100%.",
    "pctOk": "Total: {total}%",
    "pctWarn": "Total: {total}% (should be 100%)",
    "nMembres": "{n} member(s)",
    "nObservateurs": "{n} observer(s)",
    "aucunMembreDispo": "No participants on this calendar.",
    "supprBudgetTitre": "Delete budget",
    "supprBudgetMsg": "Delete \"{nom}\" and all its transactions?",
    "aucunPayeur": "No payers defined.",
    "payeDu": "Paid {paye} · owed {du}",
    "aucuneDepense": "No transactions",
    "depense": "Debit",
    "type": "Type",
    "sensDepense": "Expense",
    "sensRevenu": "Income",
    "revenus": "Credit",
    "resultat": "Result",
    "provision": "Provision",
    "synthese": "Summary (all budgets)",
    "sansBudget": "No budget",
    "rattacher": "Attach to a budget",
    "deplacerVers": "Move / reassign",
    "deplacerAide": "Pick the destination calendar, then the budget (a calendar you have rights on).",
    "deplacerAuSave": "The move applies when you save (✓ icon at the top).",
    "calendrierCible": "Calendar",
    "budgetCible": "Budget",
    "choisirBudget": "Choose a budget…",
    "aucunBudgetCible": "No budget available here",
    "deplacerSelTitre": "Move operations",
    "deplacerSelConfirm": "Move {n} operation(s)",
    "lierImport": "Link to an imported operation",
    "lierImportTitre": "Reconcile with an import",
    "lierImportAide": "Pick the matching statement operation (useful when the amount varies, e.g. utilities). It will be merged here and the app will learn the filing.",
    "lierImportVide": "No pending imported operation in this calendar.",
    "deplacer": "Move here",
    "autresPayeurs": "Others (off-split)",
    "trier": "Sort",
    "trierPar": "Sort by",
    "triAide": "Tap a criterion to sort; tap it again to reverse (↑ ascending / ↓ descending).",
    "tri_date": "Date",
    "tri_nom": "Label",
    "tri_montant": "Amount",
    "tri_categorie": "Category",
    "filtrer": "Filter",
    "filtreTout": "All",
    "filtreAide": "Pick categories to group the list. Type and status refine within. Close with ✕.",
    "grouperCategorie": "Group by category",
    "horsCalcul": "excluded",
    "affichage": "Display",
    "cashflow": "Running balance",
    "soldeFinal": "End-of-period running balance",
    "parMois": "By month",
    "parJour": "By day",
    "aLequilibre": "Settled up",
    "detteLigne": "{de} owes {a}",
    "rembourser": "Settle up",
    "remboursement": "Reimbursement",
    "creerRemboursement": "Record reimbursement",
    "rembDejaPaye": "Already paid (settled now)",
    "rembPayeAide": "The reimbursement counts immediately: the debt is settled.",
    "rembProvisionAide": "The reimbursement stays ⏳ pending: the debt is only settled once confirmed (manually or via bank import).",
    "quiDoitAQui": "Who owes whom",
    "detteLectureSeule": "To settle up, open the relevant budget.",
    "epargne": "Savings",
    "perteEpargne": "Savings loss",
    "exclure": "Exclude from totals",
    "reintegrer": "Include in totals",
    "regroupement": "Grouping",
    "grp_aucun": "None",
    "grp_budget": "By budget",
    "grp_categorie": "By category",
    "grp_calendrier": "By calendar",
    "grp_budget_cat": "Budget ▸ Category",
    "grp_cat_budget": "Category ▸ Budget",
    "grp_calendrier_budget": "Calendar ▸ Budget",
    "reinitFiltre": "Reset filter",
    "aucunResultatFiltre": "No entries for this filter.",
    "voirTotaux": "Show totals",
    "masquerTotaux": "Hide totals",
    "graphiques": "Charts",
    "graph_repartition": "By category",
    "graph_budget": "By budget",
    "graph_calendrier": "By calendar",
    "graph_jour": "By day",
    "graphAucun": "No spending to chart this month.",
    "graphMaxJour": "Highest day: {montant}",
    "depensesTotal": "Total spending",
    "statut": "Status",
    "statutPaye": "Paid",
    "statutProvision": "Provision (to pay)",
    "recurrentes": "Recurring",
    "aConfirmer": "To confirm",
    "confirmer": "Confirm",
    "nouvelleRecurrente": "New recurring item",
    "aucuneRecurrente": "No recurring item for this budget.",
    "frequence": "Frequency",
    "freq_mensuelle": "Monthly",
    "freq_trimestrielle": "Quarterly",
    "freq_semestrielle": "Half-yearly",
    "freq_annuelle": "Yearly",
    "freq_ponctuelle": "One-off",
    "jour": "day",
    "jourEcheance": "Day of month (1-28)",
    "ajouterRecurrente": "Add recurring item",
    "modifierRecurrente": "Edit recurring item",
    "filtreRecurrence": "Recurrence",
    "recurLiees": "Linked",
    "recurNonLiees": "Not linked",
    "passerEnRecurrent": "Make recurring",
    "rendrePonctuelle": "Make one-off (detach)",
    "rattacherExistante": "Attach to an existing recurrence",
    "rattacherAutre": "Attach to another recurrence",
    "detacherRattacherTitre": "Detach then attach?",
    "detacherRattacherMsg": "This operation is linked to « {libelle} ». Attaching it to another recurrence will first detach it from « {libelle} ». Continue?",
    "detacherRattacherOui": "Detach and choose",
    "recurrenteIntrouvableAide": "This operation is linked to a recurrence that no longer exists (deleted). You can attach it to another recurrence, or make it one-off.",
    "rattacheeA": "Attached to",
    "recurrenteInconnue": "recurrence not found",
    "operationARattacher": "Movement to attach",
    "rattachMasse": "Bulk attach",
    "rattachMasseSous": "For each recurrence, its unlinked movements with a close amount. Tap ✓ to attach, ✗ to skip.",
    "rattachMasseVide": "No movement to attach (all already linked, or no matching amount).",
    "rattachTout": "Attach all",
    "meilleurMatch": "Best match",
    "montantExact": "exact amount",
    "ecart": "diff",
    "rattacherSous": "The movement will take the recurrence's name and be bank-reconciled. Future imports of this label will also attach to it.",
    "rattacheTitre": "Movement attached",
    "rattacheMsg": "Attached to “{nom}”: name applied, bank-reconciled, import rule saved.",
    "recurrenceEtat": "Recurring operation",
    "recurrenteOuiAide": "This operation is linked to a recurring item. You can make it one-off (it detaches; the recurring item stays for other months).",
    "recurrenteNonAide": "Turn this operation into a recurring template (rent, subscription…) proposed at each due date.",
    "changerEchelle": "Change scale (month / year / all)",
    "recurrenteCreee": "Recurring item created",
    "recurrenteCreeeMsg": "Manage it (or delete it) via the budget's « Recurring » button.",
    "nouvelleDepense": "New transaction",
    "montant": "Amount",
    "libelle": "Label",
    "libellePlaceholder": "e.g. Cafeteria, doctor…",
    "payePar": "Paid by",
    "categorie": "Category",
    "date": "Date",
    "datePlaceholder": "YYYY-MM-DD",
    "dateReception": "Invoice date",
    "datePaiement": "Payment date",
    "datePaiementPlaceholder": "Pick a date (if paid)",
    "typePaiement": "Payment method",
    "pmt_cb": "Card",
    "pmt_virement": "Transfer",
    "pmt_cheque": "Cheque",
    "pmt_espece": "Cash",
    "enregistrement": "Saving…",
    "ajouterDepense": "Add transaction",
    "modifierDepense": "Edit transaction",
    "detailDepense": "Transaction details",
    "commentaire": "Comment",
    "commentairePlaceholder": "Note, detail…",
    "pieces": "Attachments",
    "photo": "Gallery",
    "camera": "Camera",
    "fichier": "File",
    "aucunePiece": "No attachment",
    "lectureSeule": "Only the transaction creator can edit it.",
    "permission": "Permission",
    "permCamera": "Allow camera access to take a photo.",
    "permPhotos": "Allow photo access to add one.",
    "erreur": "Error",
    "supprimerTitre": "Delete transaction",
    "supprimerConfirm": "Delete \"{libelle}\"?",
    "cat_scolaire": "School",
    "cat_sante": "Health",
    "cat_activites": "Activities",
    "cat_vetements": "Clothing",
    "cat_alimentation": "Food",
    "cat_salaire": "Salary",
    "cat_loyer": "Rent",
    "cat_charges": "Charges",
    "cat_energie": "Energy",
    "cat_travaux": "Works",
    "cat_assurance": "Insurance",
    "cat_credit": "Loan",
    "cat_taxeFonciere": "Taxes",
    "cat_transport": "Transport",
    "cat_abonnements": "Subscriptions",
    "cat_import": "Import",
    "cat_remboursement": "Reimbursement",
    "cat_autre": "Other",
    "importer": "Import a statement",
    "importTitre": "Import a statement (OFX / CSV)",
    "importCalendrier": "Destination calendar",
    "importChoisir": "Choose an OFX or CSV file",
    "importChoisirFichier": "Select a file…",
    "importWebSeul": "Statement import is available on the web app (myfinance.mopsuite.fr).",
    "importApercu": "{n} operation(s) read",
    "importVersBudget": "Into this calendar's « Import » budget",
    "importLancer": "Import {n} operation(s)",
    "importEnCours": "Importing…",
    "importResultat": "{crees} imported, {doublons} duplicate(s) skipped.",
    "importErreurFichier": "Unreadable file or unrecognized format.",
    "importAucune": "No operation found in this file.",
    "importNote": "Staging area: these operations are NOT counted until you assign them to a budget (Move / reassign).",
    "toutesPeriodes": "All periods",
    "importDoublonDeja": "Already imported",
    "importDoublonPossible": "Possible duplicate of:",
    "importSelection": "{n} selected of {total}",
    "importActionRapprocher": "Reconcile",
    "importActionImporter": "Import",
    "importActionIgnorer": "Ignore",
    "importAppris": "learned",
    "importRapprocheAvec": "Reconcile with:",
    "importPlusieurs": "{n} possible matches — choose carefully",
    "importResume": "{rap} to reconcile · {imp} to import · {dej} already present — of {total}",
    "importMasquerDeja": "Hide already imported ({n})",
    "importValider": "Confirm — {rap} reconciliation(s), {imp} import(s)",
    "importResultat2": "{rapproches} reconciled, {crees} imported.",
    "banqueRef": "Bank ref.",
    "banqueLibelle": "Bank label",
    "banqueDate": "Bank date",
    "banqueInfos": "Bank info",
    "importActionRattacher": "Link",
    "importPrevu": "planned",
    "importResultat3": "{rapproches} matched · {rattaches} linked · {crees} created",
    "sansBudgetAide": "to file into an envelope"
  },
  "messagerie": {
    "titre": "Messages",
    "discussionParDefaut": "Discussion",
    "nouvelleDiscussion": "New discussion",
    "membresDeLaDiscussion": "Discussion members",
    "sujet": "Topic",
    "sujetExemple": "e.g. Summer holidays",
    "visibleParTous": "Visible to everyone",
    "membresHint": "You are included automatically. Choose the others:",
    "aucunAutreMembre": "No other member on this calendar.",
    "creer": "Create",
    "aucunMessage": "No messages",
    "demarrezConversation": "Start the conversation",
    "quelquun": "Someone",
    "votreMessage": "Your message…",
    "photo": "Photo",
    "camera": "Camera",
    "document": "Document",
    "position": "Location",
    "positionPartagee": "Shared location",
    "partagerPosition": "Share my location",
    "adresse": "Address",
    "adressePlaceholder": "Address (edit if needed)",
    "envoyer": "Send",
    "lieu": "Saved place",
    "positionExacte": "Exact location",
    "actionsIndispo": "Attachments and location aren't included in your plan.",
    "choisirLieu": "Choose a calendar place",
    "aucunLieu": "No place saved in this calendar.",
    "voirSurCarte": "View on the map",
    "lieuSansCoord": "Address without precise location — view on the map",
    "ouvrirDansPlans": "Open in Maps / Google Maps",
    "discussionFermeeBanner": "Discussion closed — no new messages.",
    "fermer": "Close",
    "fermerDiscussionTitre": "Close discussion",
    "fermerDiscussionConfirm": "Close \"{titre}\"? No further messages can be posted.",
    "supprimerMessageTitre": "Delete message",
    "supprimerMessageConfirm": "Delete this message?",
    "supprimerDiscussionCloseConfirm": "Delete this closed discussion?",
    "erreur": "Error",
    "permission": "Permission",
    "permPhotosRefusee": "Photo access denied.",
    "permCameraRefusee": "Camera access denied.",
    "permLocalisationRefusee": "Location access denied.",
    "positionIndispo": "Location unavailable.",
    "ouvertureFichierImpossible": "Unable to open the file.",
    "repondre": "Reply",
    "repondreA": "Reply to {nom}",
    "enregistrer": "Save",
    "enregistrerImpossible": "Unable to save.",
    "ouvrir": "Open attachment",
    "fichierLabel": "File",
    "triTitre": "Sort conversations",
    "triRecent": "Latest message (newest first)",
    "triAncien": "Latest message (oldest first)",
    "triAZ": "Alphabetical (A → Z)",
    "triZA": "Alphabetical (Z → A)",
    "general": "General",
    "aucuneDiscussion": "No conversation yet.",
    "restreinte": "Visible to selected members",
    "fermee": "Closed",
    "discussionFermee": "Conversation closed: no new messages.",
    "fermerDiscussion": "Close conversation",
    "confirmFermer": "A closed conversation cannot be reopened. Start a new one to continue the topic. Proceed?",
    "confirmSupprimerDiscussion": "Delete this conversation and all its messages? This cannot be undone.",
    "actionsMessage": "This message",
    "signaler": "Report this message",
    "leverSignalement": "Dismiss report",
    "retirerPourTous": "Hide from others",
    "modererMasquer": "Moderate (hide from others)",
    "confirmSupprimer": "The content will be permanently erased. The message will remain shown as deleted. Proceed?",
    "confirmRetirer": "Others will no longer see your message, and you cannot bring it back. Proceed?",
    "confirmModerer": "This message will be hidden from others. Its author will be notified and may delete it. This cannot be undone. Proceed?",
    "messageSupprime": "Message deleted",
    "messageModereAuteur": "Message withdrawn by its author",
    "messageModereAdmin": "Message moderated",
    "mentionModereMoi": "Moderated: hidden from others. You may delete it.",
    "mentionModereAutres": "Hidden from other members.",
    "mentionSignale": "Reported: a decision is expected.",
    "piecesJointes": "Attach",
    "erreurLecture": "Discussions could not be read — the list below may be incomplete.",
    "sansCalendrier": "No active calendar: pick one to see its discussions."
  },
  "journal": {
    "titre": "Logbook",
    "nouvelleNote": "New note",
    "placeholderNote": "Write today's note…",
    "aucuneNote": "No notes",
    "supprimerTitre": "Delete note",
    "supprimerMsg": "This note will be permanently deleted.",
    "erreur": "Error",
    "erreurLecture": "The logbook could not be read — the list below may be incomplete.",
    "aucuneAide": "Jot down what matters as days go by: a health note, a word from school, an incident.",
    "modifierNote": "Edit note",
    "nature": "Kind",
    "natNote": "Note",
    "cat_humeur": "Mood",
    "cat_incident": "Incident",
    "valeur_note": "Category",
    "valeur_humeur": "Mood",
    "valeur_incident": "Kind of incident",
    "valeurLibre": "Other…",
    "phValeurLibre": "Describe the incident…",
    "aideValeurLibre": "This text applies to this note only. It is not added to any list.",
    "date": "Date",
    "texte": "Note",
    "auteur": "Written by",
    "hum_joyeux": "Happy",
    "hum_calme": "Calm",
    "hum_neutre": "Neutral",
    "hum_inquiet": "Worried",
    "hum_triste": "Sad",
    "hum_enerve": "Angry",
    "hum_fatigue": "Tired",
    "inc_blessure": "Injury",
    "inc_maladie": "Illness",
    "inc_dispute": "Argument",
    "inc_ecole": "School issue",
    "inc_retard": "Lateness",
    "inc_objet": "Lost or broken item",
    "inc_trajet": "Travel",
    "inc_autre": "Other",
    "voirJour": "Day by day view",
    "voirTout": "See all notes",
    "aujourdhui": "Today",
    "jourPrec": "Previous day",
    "jourSuiv": "Next day",
    "jourNotePrec": "Previous note",
    "jourNoteSuiv": "Next note",
    "heure": "Time",
    "heureAide": "Optional — defaults to the time of writing"
  },
  "contacts": {
    "titre": "Contacts",
    "vide": "No contacts",
    "nouveau": "New contact",
    "modifier": "Edit contact",
    "erreur": "Error",
    "supprimerTitre": "Delete contact",
    "supprimerConfirm": "Delete \"{nom}\"?",
    "appeler": "Call",
    "envoyerEmail": "Send an email",
    "phPrenom": "First name",
    "phNom": "Name *",
    "phTelephone": "Phone",
    "phEmail": "Email",
    "phAdresse": "Address",
    "phNote": "Note",
    "prenom": "First name",
    "nom": "Last name",
    "surnom": "Nickname",
    "phSurnom": "Nickname (optional)",
    "categorie": "Category",
    "telephone": "Phone",
    "telephones": "Phones",
    "emails": "Emails",
    "lieux": "Places",
    "ajouterTel": "Add a phone",
    "ajouterEmail": "Add an email",
    "ajouterLieu": "Add a place",
    "email": "Email",
    "adresse": "Address",
    "lieu": "Place",
    "choisirLieu": "Choose a place…",
    "erreurEnregistrer": "Could not save.",
    "note": "Note",
    "aucunAide": "Add useful contacts (doctor, school, emergencies…) to keep them at hand.",
    "ajouterChamp": "Add a field",
    "champsPerso": "Other information",
    "champPerso": "Custom",
    "champPersoIcone": "Field icon",
    "champPersoNom": "Field name (e.g. Floor, Code…)",
    "phValeur": "Value",
    "rechercher": "Search a contact",
    "aucunResultat": "No result",
    "tri_nom": "Name",
    "tri_categorie": "Category",
    "role_medecin": "Doctor",
    "role_ecole": "School",
    "role_famille": "Family",
    "role_garde": "Childcare",
    "role_urgence": "Emergency",
    "role_autre": "Other",
    "jour": "Day",
    "ajouterHoraire": "Add a time range",
    "horaire": "this time range",
    "modifierChamp": "Edit name and type",
    "erreurLecture": "The address book could not be read — the list may be incomplete."
  },
  "stats": {
    "titre": "Custody statistics",
    "aucunCalendrierEnfant": "No child calendar.",
    "statsEnfantSeulement": "Custody statistics only apply to child-type calendars.",
    "aucunJourPeriode": "No custody days recorded for this period.",
    "erreurLecture": "Custody could not be read — the statistics may be wrong.",
    "repartitionTemps": "Custody time breakdown",
    "parMois": "By month",
    "legende": "{nom} — {jours} d ({pct}%)",
    "jourRenseigne": "{n} day recorded",
    "joursRenseignes": "{n} days recorded",
    "nonRenseigne": " · {n} not recorded",
    "nonRenseignes": " · {n} not recorded",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "per_30j": "30 days",
    "per_3m": "3 months",
    "per_6m": "6 months",
    "per_12m": "1 year"
  },
  "edt": {
    "titre": "School timetable",
    "erreur": "Error",
    "datesRequises": "Please enter a start date and an end date.",
    "plageHoraire": "Time range",
    "dureeCellule": "Slot duration",
    "nbCreneaux": "Number of slots",
    "creneauDepart": "Start slot",
    "associer": "Merge with next",
    "dissocier": "Split",
    "collerFusionTitre": "Paste a merged block",
    "collerFusionMsg": "This block spans {n} slots and will overwrite {perdus} cell(s). Continue?",
    "collerNbSlots": "Number of slots to cover",
    "collerEcrasera": "{perdus} cell(s) will be overwritten",
    "collerAucunEcrase": "No cell will be overwritten",
    "collerConfirmer": "Paste",
    "plageInvalide": "End time must be after start time.",
    "caseCopiee": "Cell copied — tap a cell to paste · double-tap to finish",
    "aucunCalendrier": "No calendar.",
    "grille": "Grid",
    "aucuneGrille": "No timetable grid yet.",
    "nSelectionnees": "{n} selected",
    "supprGrillesTitre": "Delete timetables",
    "supprGrillesMsg": "Delete {n} timetable(s)?",
    "nom": "Name",
    "nomPlaceholder": "e.g. Term 1",
    "periodeActivite": "Active period",
    "du": "From {date}",
    "au": "To {date}",
    "chevauchement": "This period overlaps another one.",
    "categorieCours": "Class category (on calendar)",
    "appliquerCal": "Apply to calendar",
    "appliqueCal": "Applied to calendar",
    "retirerCal": "Remove",
    "application": "Applying…",
    "modifRetire": "Change saved. The timetable was removed from the calendar; re-apply it once you're done with your changes.",
    "appliquer": "Apply",
    "retirer": "Remove",
    "appliquerTitre": "Apply to calendar",
    "appliquerConfirm": "Generate the classes of « {nom} » as events on the calendar, from {debut} to {fin} (Monday → Friday)?",
    "appliqueOk": "Classes generated over {n} day(s). They now appear on the calendar (category « School »).",
    "retirerTitre": "Remove from calendar",
    "retirerConfirm": "Remove the generated classes of « {nom} » from the calendar?",
    "supprimerCetteGrille": "Delete this grid",
    "toucherCase": "Tap a cell to fill in a subject.",
    "matiereActivite": "Subject / activity",
    "matierePlaceholder": "e.g. Mathematics",
    "salleOptionnel": "Room (optional)",
    "sallePlaceholder": "e.g. B204",
    "lieuOptionnel": "Location (optional)",
    "couleur": "Color",
    "viderCase": "Clear cell",
    "supprimerGrilleTitre": "Delete grid",
    "supprimerGrilleMsg": "Delete “{nom}” and all its slots?",
    "nouvelleGrille": "New grid",
    "creer": "Create",
    "choisirDate": "Pick a date",
    "datePrecise": "Edit a specific date",
    "exceptionDe": "Exception for {date}",
    "reinitialiser": "Reset",
    "termine": "Done",
    "reinitJourTitre": "Reset this day?",
    "reinitJourMsg": "The timetable for {date} will revert to the normal grid.",
    "exceptionsTitre": "Exceptions ({n})",
    "exHorsPeriode": "out of range",
    "exHorsGrille": "removed slot",
    "exSupprTitre": "Delete the exception?",
    "exSupprMsg": "{date} will revert to the normal timetable.",
    "exPurgeTitre": "Stale exceptions",
    "exPurgeMsg": "{n} exception(s) no longer match the grid (date out of range or removed slot). Remove them?",
    "exGarder": "Keep",
    "exRetirer": "Remove",
    "parametres": "Settings",
    "nomGrille": "Grid name",
    "phNomGrille": "Year 2026-2027, semester 1…",
    "remapAide": "Existing slots will be remapped onto the new schedule.",
    "caseTitre": "Slot",
    "matiere": "Subject",
    "phMatiere": "Maths, French, Sports…",
    "phSalle": "B204…",
    "finCours": "Class end",
    "creneau": "Slot",
    "aucuneGrilleAide": "Create a grid with ＋: its classes will automatically appear in the calendar (timetable type) over its period.",
    "listeAide": "Tap a grid to fill it · swipe to edit settings or delete · the toggle enables/disables the grid.",
    "grilleInactive": "Grid disabled — its classes are not shown in the calendar.",
    "grilleAide": "Tap an empty slot to add a class, a filled one to edit it (merge via the number of slots).",
    "active": "Active",
    "copier": "Copy",
    "collerBarre": "“{matiere}” copied — tap an empty slot to paste (long-press a class = copy)",
    "actionCreneau": "What should happen to this class?",
    "deplacer": "Move",
    "deplacerBarre": "“{matiere}” — tap an empty slot to move it",
    "conflitTitre": "Classes already there",
    "conflitMsg": "{n} classes already occupy these hours. What should happen?",
    "conflitSupprimer": "Delete the existing class(es)",
    "conflitReduire": "Shorten the pasted class",
    "basculeNoms": "Show / hide names (icons only)",
    "renommer": "Edit name / room",
    "nomCreneau": "Name",
    "phNomCreneau": "E.g. School, Math class, Training...",
    "emplacement": "Location",
    "matiereOptionnel": "Subject (optional)",
    "periodicite": "Periodicity (weeks)",
    "periodiciteAide": "2+: the grid rotates W1/W2/… — each week is set up in its own tab.",
    "semaineCourte": "W{n}",
    "vacApplique": "Apply during holidays",
    "vacAide": "Global setting — adjustable for each period below.",
    "vacListe": "Holidays in the period"
  },
  "export": {
    "titre": "Export / Import",
    "perso": "Custom",
    "depart": "From {d}",
    "semVersFin": "{n} wk → {d}",
    "du": "From {d}",
    "au": "To {d}",
    "envSemaine": "≈ {n} week",
    "envSemaines": "≈ {n} weeks",
    "exporterIcs": "Export .ics",
    "imprimerPdf": "Print / PDF",
    "rapport": "Printable report",
    "note": "After clicking, choose what to export by category. The report adds a weekly schedule (week number, custody, timetable, holidays).",
    "importerFichierIcs": "Import an .ics file",
    "resumeEvt": "{n} event",
    "resumeEvts": "{n} events",
    "resumeGarde": " · {n} custody",
    "resumeGardes": " · {n} custodies",
    "resumeDemande": " · {n} request",
    "resumeDemandes": " · {n} requests",
    "resumeDepense": " · {n} transaction",
    "resumeDepenses": " · {n} transactions",
    "surLaPeriode": " over the period.",
    "documentInformatif": "Informational document — not certified for legal use.",
    "queExporter": "What do you want to export?",
    "coches": "{n}/{total} selected",
    "toutCocher": "Select all",
    "toutDecocher": "Deselect all",
    "sansTitre": "(untitled)",
    "alternancesGarde": "Custody alternations",
    "gardeDe": "{nom} custody",
    "demandesGroupe": "Requests (approvals / refusals)",
    "refuse": "Refused",
    "approuve": "Approved",
    "demPar": "req. {nom}",
    "rienAExporter": "Nothing to export for this period.",
    "genererIcs": "Generate .ics ({n})",
    "genererRapport": "Generate report",
    "aucunEvtTitre": "No event",
    "aucunEvtMsg": "Select at least one event.",
    "aucunEvtLisible": "This file contains no readable event.",
    "erreur": "Error",
    "lectureImpossible": "Unable to read the file.",
    "bloqueTitre": "Blocked",
    "bloqueMsg": "Allow pop-up windows to generate the PDF.",
    "importTermineTitre": "Import complete",
    "importTermineMsg": "{n} event(s) added to \"{nom}\"",
    "importEchecs": " · {e} failure(s)",
    "importIcsTitre": ".ics import",
    "importWebSeulement": ".ics file import is currently available on the web version only.",
    "confirmImport": "Import {n} event(s) into \"{nom}\"?",
    "aide": "Export the active calendar's events. No native module: works on the web and over-the-air too.",
    "p1s": "1 wk",
    "p2s": "2 wks",
    "p1m": "1 month",
    "p3m": "3 months",
    "nEvenements": "{n} event(s) in range",
    "ics": ".ics file",
    "icsSous": "Import into Google Calendar, Apple Calendar, Outlook",
    "rapportSous": "Web: print → PDF. Mobile: share.",
    "telecharge": "File downloaded.",
    "partage": "Share sheet opened.",
    "rapportPret": "Report generated.",
    "rien": "Nothing to export",
    "rienAide": "No event in the selected range — try a longer one.",
    "pdf": "PDF",
    "pdfSous": "Savable or shareable file",
    "pdfPret": "PDF generated.",
    "impressionOuverte": "Print dialog opened: choose “Save as PDF”.",
    "popupBloquee": "The browser blocked the window: allow pop-ups for this site.",
    "inclureGardes": "Include custody",
    "nSegmentsGarde": "{n} custody period(s)",
    "inclureEdt": "Include timetable",
    "calendrier": "Calendar to export",
    "filtres": "Filters",
    "filtresAide": "Nothing selected = everything is exported. Tap to narrow down.",
    "importGroupe": "Import",
    "importer": "Import an .ics file",
    "importerSous": "Adds the file events to this calendar",
    "icsIllisible": "No readable event in this file.",
    "importTitre": "Import events",
    "importMsg": "{n} event(s) will be added to “{nom}”. This writes to the calendar.",
    "importOk": "{n} event(s) imported.",
    "importPartiel": "{n} imported, {e} failed.",
    "paysage": "Landscape PDF"
  },
  "vacances": {
    "titre": "Holidays & public holidays",
    "aucunCalendrier": "No calendar.",
    "note": "Public holidays are shown automatically on the calendar. Load the official school holidays here",
    "notePour": " for \"{nom}\"",
    "zoneScolaire": "School zone",
    "anneeScolaire": "School year",
    "chargerVacances": "Load holidays",
    "periodes": "Periods ({actives}/{total} shown)",
    "chevauchementGlobal": "Some periods overlap (cards in red).",
    "infoSchema": "Custody allocation (½ 1 / ½ 2 and even/odd alternation) is set in Profile → \"Custody settings\". It is shown here per period.",
    "chevauchementCarte": "Overlaps with another period",
    "edtPendantVacances": "Schedule during these holidays",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "dejaChargeesTitre": "Already loaded",
    "dejaChargeesMsg": "These periods are already in the list.",
    "ajouteTitre": "✓ Added",
    "ajouteMsg": "{n} period(s) added. Remember to save.",
    "erreurTitre": "Error",
    "chargementImpossible": "Loading failed.",
    "supprimerTitre": "Delete period",
    "supprimerMsg": "Delete \"{nom}\"?",
    "enregistreTitre": "✓ Saved",
    "enregistreGardeMsg": "Holidays shown and custody applied to the calendar.",
    "enregistreMsg": "Holidays are shown on the calendar.",
    "enregistrementImpossible": "Saving failed.",
    "aucuneNouvellePeriode": "No new period (already present).",
    "periodesAjoutees": "{n} period(s) added.",
    "periodeRetireeMsg": "\"{nom}\" will be removed.",
    "aucunNouveauFerie": "No new {annee} public holiday (already present).",
    "feriesAjoutes": "{n} {annee} public holiday(s) added.",
    "ferieExisteDeja": "A public holiday already exists on this date.",
    "supprimerFerieTitre": "Delete public holiday",
    "ferieRetireMsg": "\"{nom}\" will be removed.",
    "enregistreOk": "Saved ✓",
    "sectionScolaires": "School holidays",
    "nPeriodes": "{n} period(s)",
    "introScolaires": "Choose your zone and year, then tap ⬇️ to add the periods (no duplicates). Custody during holidays is set in \"Custody\".",
    "zone": "Zone",
    "ajouterVacancesDe": "⬇️  Add {zone} holidays · {annee}",
    "aideSwipePeriode": "Swipe to delete · tap a period to view/edit it.",
    "sectionFeries": "Public holidays",
    "nJours": "{n} day(s)",
    "introFeries": "Import French public holidays for a year, or add a custom one (e.g. a bridge day, first day of school).",
    "ajouterFeries": "⬇️  Add {annee} public holidays",
    "ajouterFerie": "Add a public holiday",
    "phNomFerie": "Name (e.g. Ascension bridge day)",
    "choisirDate": "Choose the date…",
    "aideSwipe": "Swipe to delete.",
    "dateFerieTitre": "Public holiday date",
    "modifierPeriode": "Edit period",
    "fichePeriode": "Holiday period",
    "du": "From",
    "au": "To",
    "repartitionMoities": "Split (½1 / ½2)",
    "moitie1Ligne": "½1: {debut} → {fin} · {n}d",
    "moitie2Ligne": "½2: {debut} → {fin} · {n}d",
    "gardeMoitiesNote": "The custody of each half is set in \"Custody\".",
    "phNomPeriode": "e.g. All Saints' holidays",
    "erreurNomDates": "Enter a name and valid dates (start ≤ end)."
  },
  "lieux": {
    "titre": "Places",
    "choisir": "Pick a place",
    "aucun": "None",
    "aucunListe": "No places",
    "aucunAide": "Add places (Family tab → Directories → Places) to offer them here.",
    "ajouter": "Add a place",
    "modifier": "Edit place",
    "nom": "Name",
    "adresse": "Address",
    "phNom": "E.g. School, Home, Gym…",
    "phAdresse": "Address or description",
    "rechercheAdresse": "Search an address or place…",
    "recherche": "Searching…",
    "aucunResultat": "No results",
    "maPosition": "My location",
    "localisation": "Locating…",
    "itineraire": "Directions",
    "supprimerTitre": "Delete this place?",
    "supprimerMsg": "“{nom}” will be removed from the places list.",
    "sansAdresse": "No address saved for this place."
  },
  "apparence": {
    "titre": "App settings",
    "theme": "Theme",
    "auto": "System",
    "clair": "Light",
    "sombre": "Dark",
    "icones": "Icons",
    "emoji": "Emoji",
    "fines": "Line icons",
    "hint": "\"System\" follows your phone's light/dark theme. The new look (theme + icons) applies to the Places page first, then gradually to the rest.",
    "calendrier": "Calendar",
    "boutonsVue": "View buttons at the top of the calendar",
    "boutonsVueHint": "Hidden by default: tapping the Calendar tab already opens the view menu, and double-tapping switches to the next view.",
    "boutonsVueOn": "view buttons at top",
    "boutonsVueOff": "no view buttons at top",
    "section": "Appearance"
  },
  "parametres": {
    "profil": "Profile",
    "deconnexion": "Log out"
  },
  "premierCal": {
    "bienvenue": "Welcome",
    "sousTitre": "Your space “{nom}” doesn't have a calendar yet. Create your first calendar to get started.",
    "inviteTitre": "You've been invited",
    "inviteSous": "Tap \"Join\" to access a calendar shared with you.",
    "rejoindre": "Join",
    "deParent": " · from {prenom}",
    "roleParent2": "Parent 2",
    "roleCoOrganisateur": "Co-organizer",
    "roleVisiteur": "Guest",
    "ouSepare": "— or create your own —",
    "labelNom": "Calendar name *",
    "placeholderNom": "E.g. Emma, Family calendar…",
    "placeholderEnfant": "E.g. Emma, Lucas…",
    "connecteEnTant": "Signed in as {email}",
    "roleIVV": "Validation (IVV)",
    "noteProfil": "You can join a shared calendar or create a new one at any time from the Profile tab.",
    "labelIcone": "Icon",
    "labelCouleur": "Color",
    "creerBtn": "Create my calendar →",
    "erreurNomVide": "Please give the calendar a name.",
    "erreurLimite": "Calendar limit reached.",
    "nomPlaceholder": "e.g. General, Personal, Work…",
    "creer": "Create calendar",
    "note": "You can create more calendars later in Profile → “My calendars”.",
    "errNom": "Give your calendar a name.",
    "errEspace": "No active space.",
    "errCreation": "Couldn't create it."
  },
  "ft": {
    "titre": "Technical reports",
    "choisir": "Choose…",
    "brouillons": "Drafts ({n})",
    "brouillonSansTitre": "Untitled draft",
    "contextePrefix": "Context: {c}",
    "nbCaptures": "{n} screenshot(s)",
    "continuer": "Continue ›",
    "supprimerBrouillonConfirm": "Delete this draft?",
    "aFaire": "To do ({n})",
    "groupeACompleter": "To complete",
    "groupeAValider": "To validate",
    "groupeAClore": "To close",
    "actionCompleter": "Complete ›",
    "actionValider": "Validate ›",
    "actionClore": "Close ›",
    "vueEnsemble": "Overview",
    "lesMiens": "Mine",
    "tous": "All",
    "total": "Total: {n}",
    "astuceFiltre": "Tap a status to filter the list below.",
    "mesFaits": "My technical reports ({n})",
    "reinitFiltre": "Reset filter",
    "vide": "None yet. Tap + to create one.",
    "cloreTitre": "Close the report",
    "cloreConfirm": "Mark this report as resolved and close it?",
    "clore": "Close",
    "supprimerFaitConfirm": "Delete report FT {n}?",
    "complementDemande": "Additional info requested",
    "votreReponse": "Your reply to the request",
    "placeholderReponse": "Reply to the request above here…",
    "labelTitre": "Title",
    "labelType": "Type",
    "labelGravite": "Severity",
    "labelCategorie": "Category",
    "labelPage": "Page / tab",
    "labelFonctionnalite": "Feature",
    "labelPreciser": "Specify",
    "placeholderPreciser": "What is it about?",
    "labelPlateforme": "Platform",
    "labelVersion": "App version",
    "labelContexte": "Context",
    "labelEtapes": "Steps",
    "labelComportement": "Expected behavior",
    "labelConfiance": "Confidence level",
    "labelCaptures": "Screenshots",
    "hintRenvoyer": "Tap ✈️ at the top to resubmit (completed).",
    "hintEnregistrer": "Tap ✈️ at the top to save.",
    "phaseSoumis": "Submitted",
    "gravitePrefix": "Severity: {g}",
    "attenduPrefix": "Expected: {a}",
    "confianceSuffix": " (confidence: {c})",
    "etapesPrefix": "Steps: {e}",
    "soumisPar": "Submitted by {nom}",
    "phaseAnalyse": "Analysis",
    "cause": "Cause",
    "correctionPrevue": "Planned fix",
    "phaseRealisation": "Implementation",
    "corrigeEn": "Fixed in v{v}",
    "majAvantValider": "Update the app, then check before validating.",
    "rejete": "Rejected",
    "cloreCeFt": "Close this report",
    "historique": "History",
    "histCause": "Cause: ",
    "histCorrection": "Fix: ",
    "histEchec": "Failure: ",
    "histVersion": "Version: ",
    "histPriorite": "Priority: ",
    "echec": "Failed",
    "labelCommentaire": "Comment (optional)",
    "placeholderValidation": "A note about the validation…",
    "confirmerValidation": "Confirm validation",
    "labelMotifEchec": "Failure reason",
    "labelDetailObligatoire": "Details (required)",
    "placeholderDetailEchec": "Describe what's wrong…",
    "labelCapturesOptionnel": "Screenshots (optional)",
    "renvoyerEchec": "Resubmit (failed)",
    "metaVersion": "Version {v} · {p}",
    "aideTitre": "Help — Technical reports",
    "aideEtats": "Statuses",
    "aideChamps": "Fields",
    "aideBrouillons": "Drafts",
    "permissionTitre": "Permission",
    "permissionPhotos": "Photo access denied.",
    "erreurTitre": "Error",
    "reponseComplementPrefix": "Reply to request: {r}",
    "nouveau": "New technical report",
    "actionNouveau": "New",
    "labelModule": "Module concerned",
    "phTitreEx": "E.g. The button doesn't respond",
    "phContexte": "Where, when, what you expected…",
    "envoiEnCours": "Sending…",
    "envoyerRemontee": "Submit report",
    "depuisLabel": "From",
    "mesRemonteesSur": "My reports on {app}",
    "aucuneRemontee": "No reports from {app} yet.",
    "ivvFaitsTechniques": "IVV — Technical reports"
  },
  "valideur": {
    "titre": "Validator (IVV)",
    "erreur": "Error",
    "faitsTechniques": "Technical facts",
    "faitsTechniquesSub": "Report, track and validate issues",
    "fichesTest": "Test sheets",
    "fichesTestSub": "Replayable verification scenarios, step by step",
    "outilsFlottants": "Floating tools",
    "fabLabel": "Floating button to add a TF",
    "fabSub": "Shows a draggable \"+\" on every page.",
    "testLabel": "Floating test badge",
    "testSub": "Minimize a sheet test to go do the action in the app, then resume it via the badge.",
    "draftLabel": "Floating draft badge",
    "draftSub": "Keeps a TF draft accessible as a floating badge while navigating.",
    "questionnaires": "Surveys",
    "questionnairesSub": "Give feedback on proposed changes",
    "calIvv": "Versions calendar",
    "calIvvSub": "Delivered TFs, grouped by version",
    "compteValideur": "IVV validator account",
    "compteStandard": "Standard account — you can still report an issue"
  },
  "calIvv": {
    "titre": "Versions calendar",
    "intro": "Each delivered version groups the technical facts (TFs) implemented.",
    "aucune": "No delivered version yet.",
    "nFts": "{n} TF"
  },
  "quest": {
    "titre": "Surveys",
    "titreDetail": "Survey",
    "nouveau": "New survey",
    "lever": "Raise survey",
    "aucun": "No surveys yet",
    "creeLe": "Created on",
    "cloLe": "closed on",
    "ouvert": "Open",
    "ferme": "Closed",
    "accepte": "Accepted",
    "rejete": "Rejected",
    "aujourdhui": "Today",
    "demain": "Planned change",
    "decision": "Decision",
    "sansDecision": "Closed without decision",
    "ftLie": "Linked implementation TF: #{n}",
    "implementeEn": "Implemented in {v}",
    "votreAvis": "Your feedback",
    "utilite": "Usefulness (1 = useless, 5 = very useful)",
    "phCommentaire": "Your comment (optional)…",
    "envoyer": "Submit my feedback",
    "mettreAJour": "Update my feedback",
    "retirer": "Remove",
    "retirerTitre": "Remove your feedback",
    "retirerMsg": "Delete your response to this survey?",
    "fermeInfo": "Survey closed — responses are no longer possible.",
    "rapport": "Feedback report",
    "aucuneReponse": "No responses yet.",
    "nReponses": "{n} response(s)",
    "commentaires": "Comments",
    "anonyme": "Anonymous",
    "participation": "Participation",
    "ontRepondu": "Responded ({n})",
    "enAttente": "Pending ({n})",
    "tousRepondu": "All validators have responded 🎉",
    "aucunValideur": "No IVV validator registered.",
    "relancer": "Email reminder ({n})",
    "relanceTitre": "Reminder",
    "relanceAucunMail": "No email address for the pending validators.",
    "relanceErr": "Unable to open the email app.",
    "relanceSujet": "Reminder — IVV Questionnaire #{n}",
    "relanceCorps": "Hello,\n\nYour feedback is awaited on the change \"{titre}\" in MoPCal: Profile → Validator (IVV) → Questionnaires.\n\nThank you!",
    "admin": "Administration",
    "fermer": "Close survey",
    "cloturerTitre": "Close survey",
    "cloturerSub": "Choose to accept (an implementation TF will be created) or reject the change.",
    "phDecisionNote": "Decision note (optional)…",
    "accepter": "Accept",
    "rejeter": "Reject",
    "rouvrir": "Reopen",
    "rouvrirTitre": "Reopen survey",
    "rouvrirMsg": "Reopen this survey to allow responses again?",
    "versionImpl": "Implementation version",
    "supprTitre": "Delete survey",
    "supprMsg": "Permanently delete this survey and all its feedback?",
    "champTitre": "Title",
    "phTitre": "Change title",
    "phActuel": "What the user can do today…",
    "phEvolution": "What the user will / should be able to do…",
    "erreur": "Error"
  },
  "fiches": {
    "titre": "Test sheets",
    "titreModifier": "Edit TS-{n}",
    "titreNouvelle": "New sheet",
    "titreTest": "Test TS-{n}",
    "aide": "Help",
    "aideTitre": "Help — Test sheets",
    "nouvelle": "New test sheet",
    "vide": "No test sheets yet. Tap + to create one.",
    "nbEtape": "{n} step",
    "nbEtapes": "{n} steps",
    "lancer": "Run",
    "editer": "Edit sheet",
    "nomRequisTitre": "Name required",
    "nomRequisMsg": "Give the sheet a name.",
    "etapesRequisesTitre": "Steps required",
    "etapesRequisesMsg": "Add at least one step.",
    "erreur": "Error",
    "supprimerTitre": "Delete sheet",
    "supprimerConfirm": "Permanently delete \"{nom}\"?",
    "labelNom": "Name *",
    "phNom": "E.g. Deleting a calendar",
    "labelDesc": "Problem description",
    "phDesc": "Context, why this check…",
    "labelFt": "Linked TF (number, optional)",
    "phFt": "E.g. 50",
    "labelEtapes": "Steps",
    "etapeNum": "Step {n}",
    "labelAction": "Action to perform",
    "phAction": "What the tester should do",
    "labelAttendu": "Expected result",
    "phAttendu": "What should be seen",
    "ajouterEtape": "Add a step",
    "enregistrerModifs": "Save changes",
    "creerFiche": "Create sheet",
    "supprimerFiche": "Delete sheet",
    "indisponibleTitre": "Unavailable",
    "indisponibleMsg": "Creating a TF is not available here.",
    "ftObserve": "\nObserved: {note}",
    "ftTitre": "Test failure: {nom}",
    "ftContexte": "Sheet TS-{numero} — {nom}",
    "ftEtapes": "Action: {action}\nExpected: {attendu}{obs}",
    "brouillonTitre": "TF draft created",
    "brouillonMsg": "A TF draft has been pre-filled. Complete it (category + screenshot) then submit it.",
    "plusTard": "Later",
    "ouvrirFt": "Open TFs",
    "incompletTitre": "Incomplete steps",
    "incompletMsg": "Set a result (OK / KO / N/A) for each step before saving.",
    "abandonTestTitre": "Abandon this test?",
    "abandonTestMsg": "The answers you entered will be lost.",
    "abandonner": "Abandon",
    "vueEnsemble": "Tests overview",
    "couverture": "{passees} / {total} run · coverage {pct} %",
    "nonPasse": "Not run",
    "ficheLbl": "sheet",
    "fichesLbl": "sheets",
    "reinitFiltre": "Reset filter",
    "resultatTitre": "Result saved",
    "resultatMsg": "Test {statut}.",
    "progressSingulier": "{faites}/{total} step done",
    "progressPluriel": "{faites}/{total} steps done",
    "attendu": "Expected",
    "phObserve": "What did you observe?",
    "creerFtAnomalie": "Create a TF for this issue",
    "labelCommentaire": "Overall comment (optional)",
    "phCommentaire": "Test run summary…",
    "enregistrerResultat": "Save result"
  },
  "rapportFT": {
    "titre": "TF report",
    "bientot": "Coming soon",
    "description": "This report / technical facts summary page will be completed later (statistics, exports, filters…)."
  },
  "admin": {
    "titre": "Administration",
    "bonjour": "👋 Hello, administrator",
    "bientot": "Soon",
    "masque": "Hidden",
    "erreur": "Error",
    "envoyer": "Send",
    "creer": "Create",
    "restaurer": "Restore account",
    "approuver": "Approve",
    "refuser": "Decline",
    "retirer": "Remove",
    "chargerPlus": "Load more",
    "reinitialiser": "Reset",
    "reinitTitre": "Reset",
    "reinitDefauts": "Reset to default values",
    "enregistre": "✓ Saved",
    "sauvegarde": "✓ Saved!",
    "sauvegardeEnCours": "Saving…",
    "grpUtilisateursAcces": "Users & access",
    "grpConfigApp": "App configuration",
    "grpSuivi": "Monitoring",
    "menuUtilisateurs": "Users",
    "menuUtilisateursDesc": "Add · IVV · plans · passwords",
    "menuEmails": "Registration",
    "menuEmailsDesc": "Allowed · pending · blocked",
    "menuAdmins": "Administrators",
    "menuAdminsDesc": "Manage admin accounts",
    "menuFonctionnalites": "Features",
    "menuFonctionnalitesDesc": "Enable/disable globally",
    "menuSecurite": "Security & timeout",
    "menuSecuriteDesc": "Auto logout ({n} min)",
    "menuPub": "Ads & plans",
    "menuPubDesc": "Ad-free · premium plans",
    "menuPlans": "Plans & subscriptions",
    "menuPlansDesc": "Limits and options per plan",
    "menuTelechargements": "Downloads",
    "menuTelechargementsDesc": "Web & store links (production)",
    "menuTraductions": "Translations",
    "menuTraductionsDesc": "Interface texts by language",
    "menuFaits": "Technical reports",
    "menuFaitsDesc": "Validator reports (FT)",
    "menuForfaits": "Plan requests",
    "menuForfaitsDesc": "Accept / reject changes",
    "menuConnexions": "Sign-ins",
    "menuConnexionsDesc": "User history",
    "menuCalendriers": "Calendars",
    "menuCalendriersDesc": "All calendars · delete",
    "utilisateursTitre": "👥 Users",
    "ajouterUser": "Add a user",
    "aucunUser": "No users",
    "roleMaman": "🔴 Mom",
    "rolePapa": "🔵 Dad",
    "roleEnfant": "👦 Child",
    "creeParAdmin": " · created by admin",
    "supprimeLe": "Deleted on {date}",
    "inscritLe": "Registered on {date}",
    "enLigne": "Online",
    "enLigneDepuis": "Online · since {date} at {heure}",
    "vuLe": "Seen on {date} at {heure}",
    "connexionNonEnregistree": "Sign-in not yet recorded",
    "resetMdpTitre": "Reset password",
    "forfaitFonctions": "Plan",
    "plusActions": "More actions",
    "groupeValideurs": "Validator group",
    "reinitMdpAction": "Reset password",
    "refuserAcces": "Block access",
    "supprimer": "Delete",
    "resetMdpMsg": "Send a reset email to \"{email}\"?",
    "emailEnvoyeTitre": "✓ Email sent",
    "emailEnvoyeMsg": "A reset link has been sent to {email}.",
    "suppUserTitre": "Delete user",
    "suppUserMsg": "Disable the account of \"{nom}\"?\n\nThey will no longer be able to sign in. You can restore them from the Deleted tab.",
    "errPrenom": "Enter a first name.",
    "errRole": "Choose a role.",
    "errEmail": "Invalid email address.",
    "errMdp": "Password: 6 characters minimum.",
    "userCreeTitre": "✓ User created",
    "userCreeMsg": "The account for \"{nom}\" was created successfully.",
    "errEmailExiste": "This email address is already in use.",
    "errEmailInvalide": "Invalid email address.",
    "nouvelUserTitre": "➕ New user",
    "nouvelUserDesc": "The account will be created directly with the Active status.",
    "placeholderPrenom": "First name",
    "placeholderEmail": "Email address",
    "placeholderMdp": "Password (6 char. min)",
    "foncTitre": "🔧 Features",
    "foncWarning": "⚠️  This user does not have access to the app. Features are visible but disabled.",
    "desactiveGlobalement": "🌍 Disabled globally",
    "planSimulation": "Plan (simulation)",
    "planSimulationDesc": "Force a plan to simulate the premium experience.",
    "planGratuit": "Free",
    "planFamille": "Family",
    "planFamillePlus": "Family+",
    "sansPub": "No ads",
    "sansPubDesc": "Disable all ads for this user",
    "validateurIvv": "Validator (IVV)",
    "validateurIvvDesc": "Access to the \"Technical reports\" page to report issues",
    "reinitUserMsg": "Reset this user's features, plan (free) and ad-free setting to their default values?",
    "fonctGlobalesTitre": "🌍 Global features",
    "fonctGlobalesNote1a": "These settings apply to ",
    "fonctGlobalesNote1b": "all users",
    "fonctGlobalesNote1c": " without exception.",
    "fonctGlobalesNote2a": "A feature disabled here ",
    "fonctGlobalesNote2b": "disappears completely",
    "fonctGlobalesNote2c": " from the app, regardless of individual settings.",
    "connexionsTitre": "📋 Sign-in history",
    "aucuneConnexion": "No sign-ins",
    "aucuneConnexionDesc": "Sign-ins will appear here from the next session.",
    "connexionsChargeesSingulier": "{n} sign-in loaded",
    "connexionsChargeesPluriel": "{n} sign-ins loaded",
    "calendriersTitre": "📅 All calendars",
    "calBaseTitre": "Calendars in the database",
    "calBaseDesc": "Paginated list (25 per page) — built for thousands of entries with no performance loss. The search filters already loaded calendars.",
    "rechercheCalPlaceholder": "Search (name or creator email)…",
    "suppCalTitre": "Delete this calendar",
    "suppCalMsg": "Permanently delete \"{nom}\" and ALL its data (events, schedule, recurring)? This cannot be undone.",
    "calChargesSingulier": "{n} loaded",
    "calChargesPluriel": "{n} loaded",
    "suffixeTout": " (all)",
    "suffixeGeneral": " · general",
    "suffixeParticipants": " · {n} part.",
    "adminsTitre": "🛡️ Administrators",
    "comptesAdminTitre": "Administrator accounts",
    "comptesAdminDesc": "Administrators have access to this panel. For an email to work, the person must create an account in the app with that address (they will get the rights directly).\nSafeguards: you cannot remove yourself, nor delete the last administrator.",
    "errAdminExiste": "This email is already an administrator.",
    "actionImpossible": "Action not allowed",
    "retraitSoiMeme": "You cannot remove yourself.",
    "retraitDernierAdmin": "At least one administrator must remain.",
    "retirerAdminTitre": "Remove this administrator",
    "retirerAdminMsg": "Remove \"{email}\" from administrators?",
    "adminEmailPlaceholder": "admin@mopsuite.fr",
    "btnAjouter": "+ Add",
    "adminsCompteSingulier": "{n} administrator",
    "adminsComptePluriel": "{n} administrators",
    "suffixeVous": "  (you)",
    "emailsTitre": "📝 Registration",
    "modeInscrTitre": "Sign-up mode",
    "modeAutoDesc": "Automatic access as soon as the email is verified (no approval).",
    "modeManuelDesc": "Verified email + manual approval required.",
    "tabAutorises": "Allowed",
    "tabAttente": "Pending",
    "tabInterdits": "Blocked",
    "aucuneAttente": "No pending requests.",
    "aucunInterdit": "No blocked emails.",
    "autoriser": "Allow",
    "interdire": "Block",
    "interdireTitre": "Block this email",
    "interdireMsg": "Permanently block \"{email}\"? The request will be refused and the address added to the blocklist.",
    "debloquer": "Unblock",
    "interditLe": "Blocked on {date}",
    "attMin": "waiting for {n} min",
    "attHeures": "waiting for {n} h",
    "attJours": "waiting for {n} d",
    "listeBlancheTitre": "Sign-up allowlist",
    "listeBlancheDesc": "If the list is empty, any email address can sign up.\nIf it contains entries, only active addresses can create an account.",
    "errEmailDejaListe": "This email is already in the list",
    "lienManquantTitre": "Missing link",
    "lienManquantMsg": "First set the Expo link in \"Update & Invitations\".",
    "invitationEnvoyeeTitre": "✅ Sent",
    "invitationEnvoyeeMsg": "Invitation sent to {email}",
    "retirerEmailMsg": "Remove \"{email}\" from the list?",
    "emailPlaceholder": "new@address.com",
    "aucunEmail": "No allowed address",
    "aucunEmailDesc": "Any address can sign up right now",
    "adressesSingulier": "{n} address",
    "adressesPluriel": "{n} addresses",
    "activesSingulier": "{n} active",
    "activesPluriel": "{n} active",
    "ajouteLe": "Added on {date}",
    "telechargementsTitre": "📲 Downloads",
    "majAutoTitre": "Automatic updates",
    "majAutoDesc": "No need to send a link anymore: on the web just reload the page, and on mobile the app updates itself on launch (a prompt offers it). This page is used to prepare the download links for production release (App Store / Google Play).",
    "liensAccesTitre": "Access links",
    "lienWebLabel": "Web app (access link / invitations)",
    "lienIosLabel": "App Store (iOS) — production",
    "lienAndroidLabel": "Google Play (Android) — production",
    "securiteTitre": "⏱ Security & Timeout",
    "deconnexionAutoTitre": "Automatic logout",
    "deconnexionAutoDesc": "Users are automatically logged out after the inactivity period set below.\n\nThe administrator is not subject to this rule.",
    "dureeInactivite": "Inactivity duration before logout",
    "minutes": "minutes",
    "minAbbr": "{n} min",
    "errTimeout": "Value between 1 and 480 minutes",
    "securiteNote": "ℹ️  The check runs every 30 seconds. If the user returns to the app after inactivity, they are logged out immediately when it comes back to the foreground.",
    "pubTitre": "📢 Advertising",
    "pubNote1a": "These settings control ",
    "pubNote1b": "when and where",
    "pubNote1c": " the ",
    "pubNote1d": "fullscreen ad (event)",
    "pubNote1e": " is shown.",
    "pubNote2a": "Two ad types, configurable per plan in \"Plans & subscriptions\": ",
    "pubNote2b": "banner (fixed)",
    "pubNote2c": " and ",
    "pubNote2d": "fullscreen (event)",
    "pubNote2e": ".",
    "pubNote3a": "By default — ",
    "pubNote3b": ": banner + fullscreen · ",
    "pubNote3c": ": banner only · ",
    "pubNote3d": ": none.",
    "pubNote4a": "\"Ad-free\" (user card 🔧) disables ",
    "pubNote4b": "both",
    "pubNote4c": " for this account.",
    "pubPleinEcran": "Fullscreen advertising",
    "pubActivee": "Enabled",
    "pubActiveeDesc": "Show fullscreen ads in the app",
    "conditionsDeclenchement": "Trigger conditions (OR)",
    "apresNOuvertures": "After N app openings",
    "memeSession": "Within the same session",
    "apresNMinutes": "After N minutes of use",
    "dureeCumulee": "Cumulative time in the session",
    "limitesAffichage": "Display limits",
    "delaiEntreAffichages": "Delay between two displays",
    "delaiEntreAffichagesDesc": "Minimum minutes between two ads",
    "maxParJour": "Maximum per day",
    "maxParJourDesc": "Max number of displays per user per day",
    "pagesAutorisees": "Allowed pages",
    "pagesAutoriseesDesc": "Screens where the ad can trigger",
    "plansTitre": "🏷️ Plans & subscriptions",
    "plansNote1a": "Adjust the ",
    "plansNote1b": "limits",
    "plansNote1c": " and ",
    "plansNote1d": "options",
    "plansNote1e": " of each plan. Changes apply ",
    "plansNote1f": "in real time",
    "plansNote1g": " to all affected users.",
    "plansAstuce": "Tip: \"∞\" = unlimited.",
    "activeAffichees": "(enabled = shown)",
    "prixMensuel": "Monthly price (€)",
    "prixAnnuel": "Annual price (€)",
    "enregistrerPlans": "Save plans",
    "plansEnregistresTitre": "Saved",
    "plansEnregistresMsg": "Plans have been updated for all users.",
    "reinitPlansMsg": "Revert all plans to their default values?",
    "forfaitsTitre": "💳 Plan requests",
    "adminParDefaut": "Admin",
    "aucuneDemande": "No requests.",
    "utilisateurParDefaut": "User",
    "demandeLe": "Requested on {date}",
    "accesSansEcheance": "Access with no expiry",
    "jusquAu": "Until {date}",
    "parTraitePar": " · by {nom}",
    "motifLabel": "Reason: {motif}",
    "accepter": "Approve",
    "refuserCourt": "Reject",
    "accepterDemandeTitre": "Accept the request",
    "passerAuPlanA": "Move {nom} to the plan",
    "cetUtilisateur": "this user",
    "echeance30j": "30 days (renewable)",
    "sansEcheance": "No expiry",
    "refuserDemandeTitre": "Reject the request",
    "motifOptionnel": "Reason (optional)",
    "confirmerRefus": "Confirm rejection",
    "comptes": "Accounts",
    "forfaits": "Plans",
    "compte": "Account",
    "rechercheCompte": "Email, first name…",
    "tous": "All",
    "aucunCompte": "No account",
    "aucunCompteAide": "No account matches this search.",
    "nComptes": "{n} account(s)",
    "forfait": "Plan",
    "statut": "Status",
    "statut_actif": "Active",
    "statut_en_attente": "Pending",
    "statut_suspendu": "Suspended",
    "roles": "Roles",
    "role_admin": "Administrator",
    "role_commerce": "Sales",
    "role_ivv": "IVV validator",
    "rolesAide": "Roles only take effect once the token (custom claim) is updated server-side.",
    "plansPaliers": "What each plan includes",
    "palierInclusAide": "Tier included in this plan.",
    "fonctions": "Features",
    "nFonctions": "{n} feature(s)",
    "autresFonctions": "Other",
    "forfaitsAide": "The switch disables the feature for EVERYONE (kill switch). The tier sets which plan includes it; beyond that it stays purchasable à la carte.",
    "accesRefuse": "Restricted access",
    "accesRefuseAide": "This app is reserved for administration and sales.",
    "demandeForfait": "Plan request: {plan}",
    "nDemandes": "{n} plan request(s) pending",
    "acces": "Access",
    "prenom": "First name",
    "phPrenom": "Display name",
    "nouveauCompte": "New account",
    "mdpProvisoire": "Temporary password",
    "phMdp": "6 characters minimum",
    "nouveauCompteAide": "The account is created active. Then send the password link so the person can set their own.",
    "options": "Options",
    "accesIllimite": "Unlimited access (all features)",
    "actions": "Actions",
    "envoyerLienMdp": "Send a password link",
    "envoyerLienMdpMsg": "Send a reset link to {email}?",
    "lienEnvoye": "Link sent",
    "supprimerCompte": "Delete account",
    "supprimerCompteMsg": "Account {email} will be marked deleted (restorable).",
    "supprimerDefinitif": "Delete permanently",
    "supprimerDefinitifMsg": "Account {email}: PERMANENT and IRREVERSIBLE deletion (Firebase identity + all data). Continue?",
    "compteSupprimeDefinitivement": "Account permanently deleted",
    "queFaireCompte": "What do you want to do with this account?",
    "creeLe": "Created on",
    "derniereConnexion": "Last sign-in",
    "compteSupprime": "Account deleted",
    "compteRestaure": "Account restored",
    "suppressionAide": "Deletion is soft: the account stays restorable and history is kept.",
    "inscriptionEnAttente": "Sign-up awaiting approval",
    "rejeter": "Reject",
    "compteApprouve": "Account approved",
    "compteRejete": "Account rejected",
    "forfaitApplique": "Plan applied",
    "groupeIVV": "IVV group",
    "aucunGroupe": "None",
    "nomGroupe": "Group name",
    "phNomGroupe": "E.g. Martin family",
    "groupeIVVAide": "Accounts sharing this name form a single validator identity: same technical reports and questionnaire answers.",
    "emailsAutorises": "Allowed e-mails",
    "nEmails": "{n} e-mail(s)",
    "emailsAutorisesAide": "Only these addresses can create an account. The switch suspends an address without deleting it; swipe to remove.",
    "administrateurs": "Administrators & sales",
    "nAdmins": "{n} admin(s) - {c} sales",
    "nAttente": "{n} pending",
    "nInterdits": "{n} blocked",
    "administrateursAide": "These lists drive the real roles (security token). A change recomputes rights automatically.",
    "aucunCommerce": "No sales user",
    "retirerAdmin": "Remove administrator",
    "retirerCommerce": "Remove sales user",
    "retirerRoleMsg": "Remove this role from {email}?",
    "rolesDepuisComptes": "To GRANT a role, open the account in the Accounts tab.",
    "filtreStatut": "Status",
    "avecDemande": "With request",
    "statut_supprime": "Deleted",
    "aTraiter": "To handle",
    "sansDemande": "No request",
    "fonctionsParApp": "Features by app",
    "moduleAVenir": "Module coming soon",
    "moduleAVenirAide": "This app has not declared its features yet.",
    "rechercheEmail": "Search an address",
    "choisirCompte": "Pick an account",
    "autoriserCompte": "Allow an account",
    "swipeRetirer": "Swipe a row (or long-press on web) to remove the role.",
    "appuiLongSupprimer": "Long-press to remove",
    "ivv": "IVV",
    "sansIVV": "Not IVV",
    "nonInscrit": "Not registered yet",
    "sansNom": "Registered — no name set",
    "avecIVV": "IVV account",
    "jetonsGestion": "Manageable items",
    "jetonsVue": "Viewable items",
    "jetonsAide": "How many items (calendar, inventory...) this plan allows. A ⚙️ token grants editing and can be given away; a 👁 token only grants viewing.",
    "maxEspaces": "Spaces",
    "maxEspacesAide": "How many spaces an account on this plan may own (1 minimum). A space does not consume a token.",
    "modifierForfait": "Edit plan",
    "nomAffiche": "Display name",
    "prixMensuel": "Monthly price (€)",
    "prixAnnuel": "Yearly price (€)",
    "piecesJointesMax": "Attachments per month",
    "demandesMoisMax": "Requests per month",
    "historiqueJours": "History (days)",
    "pubFixe": "Banner ad",
    "pubEvenement": "Full-screen ad",
    "exportPdf": "PDF export",
    "syncCalendrier": "External calendar sync",
    "tarifsAide": "Every app reads these values (the “My plan” screen) as soon as you save — nothing to publish.",
    "limitesParType": "Per-item limits",
    "limitesParTypeAide": "Caps the count of each element type, independent of the tokens above. Not enforced by the other apps yet: settable now, to be read later.",
    "typeCalendriers": "Calendars",
    "typeInventaires": "Inventories & plans",
    "typeRepas": "Meals & menus",
    "typeComptes": "Budgets & accounts",
    "poidsFonction": "Weight (points)",
    "pointsInclus": "Points included",
    "pointsInclusAide": "Point budget offered for à la carte purchases, on top of what the plan already includes.",
    "baremePoints": "À la carte price bands",
    "baremePointsAide": "Monthly price by how many points are taken BEYOND the plan's included budget — not a price per function.",
    "baremeJusqua": "Up to {n} pts",
    "baremeAuDela": "Beyond that",
    "jusqua": "Up to",
    "pts": "pts",
    "ajouterPalier": "Add a band",
    "demandeAchats": "À la carte purchase request",
    "demandeAchatsResume": "{n} point(s) requested",
    "achatsAppliques": "Applied purchases"
  },
  "adminFT": {
    "choisir": "Choose…",
    "permission": "Permission",
    "permissionPhotos": "Photo access denied.",
    "champsRequis": "Required fields",
    "champsRequisMsg": "Title and category (+ details) are required.",
    "cree": "✓ Created",
    "creeMsg": "FT {n} created.",
    "erreur": "Error",
    "titre": "Technical facts",
    "historique": "History",
    "historiqueVide": "No closed technical fact",
    "rechercheHist": "Search (FT number, keywords…)",
    "rechercheAucun": "No technical fact matches your search",
    "versionNonRenseignee": "Version not set",
    "aTraiter": "To process ({n})",
    "parEtat": "By status",
    "total": "Total: {n}",
    "anomaliesParVersion": "Issues by version",
    "corrigeesTotal": "fixed / total",
    "afficherVersions100": "Show 100% versions ({n})",
    "masquerVersions100": "Hide 100% versions ({n})",
    "toutesCorrigees": "All versions are 100% fixed.",
    "totalCorrigees": "Total: {res}/{tot} fixed",
    "reinitFiltres": "Reset filters",
    "soumisClotures30j": "Submitted / closed (30 days)",
    "soumis": "Submitted",
    "clotures": "Closed",
    "implementes": "Implemented",
    "totalSoumisClotures": "Total: {soumis} submitted · {clotures} closed",
    "totalSoumisCloturesImpl": "Total: {soumis} submitted · {impl} implemented · {clotures} closed",
    "filtre": "Filter: {liste}",
    "aucun": "No technical facts",
    "ligneTypeCategorie": "Type: {type} · Category: {categorie}",
    "autoAnalyseDemandee": "Automatic analysis requested",
    "autoImplementationDemandee": "Automatic implementation requested",
    "routineProchainCycle": "The routine will process this FT on the next cycle.",
    "echecTraitementAuto": "Automatic processing failed",
    "lignePageFonc": "Page: {page} · Feature: {fonctionnalite}",
    "ligneAttendu": "Expected: {attendu}",
    "ligneConfiance": " (confidence: {confiance})",
    "ligneContexte": "Context: {contexte}",
    "ligneEtapes": "Steps: {etapes}",
    "analyseCause": "Analysis — cause",
    "correctionPrevue": "Planned fix",
    "implementeEnVersion": "Implemented in v{version}",
    "suivi": "History",
    "labelPageOnglet": "Page / tab (to review)",
    "labelFonctionnalite": "Feature (to review)",
    "labelCause": "Cause of the problem",
    "phRaison": "Reason…",
    "labelCorrection": "Possible fix",
    "phCorrection": "Explanation of the fix…",
    "validerAnalyse": "Confirm analysis → Analysed",
    "labelInfoManquante": "Missing information",
    "phInfoManquante": "What should the validator clarify?",
    "demanderComplementNeedInfo": "Request details → Need-info",
    "labelVersionImpl": "Implementation version",
    "phVersionImpl": "e.g. 3.4.0.0",
    "marquerImplemente": "Mark as Implemented",
    "labelRaisonRejet": "Rejection reason",
    "labelPiecesJointes": "Attachments (optional)",
    "rejeter": "Reject",
    "labelRaisonReport": "Postponement reason",
    "phRaisonReport": "Why postpone (not in an immediate version)?",
    "reporterVersReporte": "Postpone → Postponed",
    "analyseDemandee": "⏳ Analysis requested…",
    "analyserAuto": "⚡ Analyse automatically",
    "analyserManuellement": "Analyse manually",
    "demanderComplement": "Request details",
    "affecterPriorite": "Assign a priority (CCB)",
    "reporter": "Postpone",
    "implementationDemandee": "⏳ Implementation requested…",
    "implementerAuto": "⚡ Implement automatically",
    "marquerImplementeManuel": "Mark as Implemented manually…",
    "reanalyserSolution": "Re-analyse (review the solution)",
    "cloturer": "Close",
    "attenteValidation": "Awaiting validation by the validator.",
    "reporteAReprendre": "Postponed — to resume when scheduled.",
    "reanalyser": "Re-analyse",
    "aideTitre": "Help — Technical facts",
    "aideLesEtats": "Statuses",
    "aideLesChamps": "Fields"
  },
  "layout": {
    "moi": "Me",
    "infoFiltreAstuce": "Tap the filter to turn it on or off.",
    "aideMoi": "Show only the events you created.",
    "aideCategorie": "Hide or show events in the « {nom} » category.",
    "aideRecurrent": "Hide or show recurring events (that repeat automatically).",
    "aideRepas": "Hide or show planned meals (menu planner).",
    "aideEdt": "Hide or show timetable slots.",
    "aideAutre": "Hide or show other events (not recurring, meals, or timetable)."
  },
  "membres": {
    "titre": "Who can see this event?",
    "groupes": "Groups",
    "personnes": "People",
    "aucun": "No one to suggest."
  },
  "formJour": {
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "baisserClavier": "Dismiss keyboard",
    "spectateurs": "Viewers",
    "ajouterSpectateurs": "Add",
    "erreur": "Error",
    "moi": "Me",
    "inconnu": "Unknown",
    "heureInvalide": "Invalid time",
    "heureFinApres": "The end time must be after the start time.",
    "heuresDeuxRequises": "Enter both the start AND end time, or leave both empty.",
    "permissionRefusee": "Permission denied",
    "autoriserPhotos": "Please allow access to photos.",
    "autoriserCamera": "Please allow access to the camera.",
    "fichierImpossible": "Unable to open the file: {msg}",
    "ouvertureFichierImpossible": "Unable to open this attachment.",
    "locServicesDesactives": "📵 Location services are off. Turn them on in Settings → Privacy → Location Services.",
    "locNonAutorisee": "⚠️ Location not allowed. Enable it in Settings → MoPCal.",
    "adresseIntrouvable": "Location found but no matching address.",
    "gpsLent": "⏱ GPS is too slow. Try again outside or search manually.",
    "positionImpossible": "Unable to get your location.",
    "dateFinApres": "The end date must be after the start date.",
    "evtRecurrentTitre": "🔁 Recurring event",
    "quoiSupprimer": "What would you like to delete?",
    "cetteOccurrence": "This occurrence only",
    "toutesOccurrences": "All occurrences",
    "supprimerEvt": "Delete event",
    "supprimerConfirm": "Delete \"{titre}\"?",
    "envoyer": "📬 Send",
    "garde": "Custody: {label}",
    "changementGarde": "Custody change → {label}",
    "evenementLabel": "Event: {titre}",
    "sansTitre": "(untitled)",
    "demandeAValider": "📬 Request to approve",
    "demandePar": "Requested by {nom}",
    "refuser": "Decline",
    "approuver": "Approve",
    "aucunEvenement": "No events on this day",
    "modifie": "· edited",
    "recurrent": "Recurring",
    "exportIcs": "Exported to calendar",
    "nonExporte": "Not exported to calendar",
    "piecesJointes": "Attachments",
    "visPrive": "🔒 Private",
    "visParents": "👥 Parents",
    "heureDebut": "⏰ Start time",
    "heureFin": "⏰ End time",
    "proposerEvenement": "📬 Suggest an event",
    "ajouterEvenement": "+ Add an event",
    "choisirLieu": "📍 Choose a location",
    "localisation": "Locating…",
    "utiliserPosition": "🎯  Use my current location",
    "ouRechercher": "or search",
    "lieuPlaceholder": "School, doctor, park…",
    "resultatSingulier": "{n} result",
    "resultatsPluriel": "{n} results",
    "defiler": "↕ scroll",
    "aucunResultat": "No results — try different words",
    "visTous": "Everyone",
    "visParentsCourt": "Parents",
    "visPriveCourt": "Private",
    "visDescTous": "Visible to both parents and guests",
    "visDescParents": "Visible to both parents only",
    "visDescPrive": "Visible to you only",
    "recBanner": "🔁 Recurring event — use the 🗑️ button to delete this occurrence or the whole series.",
    "titrePlaceholder": "Title *",
    "deplace": "moved",
    "transfertVersAutre": "Move / copy to another calendar",
    "transfertChoisirCal": "To which calendar?",
    "transfertTitre": "Move or copy",
    "transfertVers": "To « {nom} »: move (remove from here) or copy?",
    "deplacer": "Move",
    "copier": "Copy",
    "calendrier": "Calendar",
    "debut": "Start",
    "fin": "End",
    "lieuOptionnel": "Location (optional)",
    "notePlaceholder": "Note (optional)",
    "categorie": "📂 Category",
    "visiblePar": "👁 Visible to:",
    "inclureExport": "📤 Include in export by default",
    "responsable": "In charge",
    "modeGarde": "🔄 Custody mode",
    "demanderApprobation": "📬 Request approval",
    "demandeApprobationDesc": "The other parent will need to approve before publishing",
    "messagePlaceholder": "Message for the other parent (optional)...",
    "plageDates": "📅 Date range",
    "duAu": "From {debut} to {fin}",
    "finLabel": "End:",
    "choisirDate": "Choose a date…",
    "repetition": "🔁 Repeat",
    "recHebdo": "Every week — {jours}",
    "recBimensuel": "Every 2 weeks",
    "recMensuel": "Every month",
    "recJusquau": " until {date}",
    "recSansFin": " — no end date",
    "typeHebdo": "Every week",
    "typeBimensuel": "2 weeks",
    "typeMensuel": "Monthly",
    "sansFin": "No end date",
    "enAttenteEnvoi": "Pending upload",
    "galerie": "🖼️ Gallery",
    "camera": "📸 Camera",
    "fichier": "📎 File",
    "envoiFichiers": "📤 Uploading files…"
  },
  "brouillon": {
    "choisir": "Choose…",
    "permissionTitre": "Permission",
    "permissionPhotos": "Photo access denied.",
    "enregistreOk": "🔖 Draft saved",
    "erreur": "Error",
    "champsRequisTitre": "Required fields",
    "champsRequisMsg": "Title, category (+ details) and at least one screenshot.",
    "envoyeOk": "✓ Sent",
    "ftCree": "TF {n} created.",
    "fermerTitre": "Close",
    "fermerMsg": "Keep this draft?",
    "abandonner": "Discard",
    "titre": "Draft",
    "labelTitre": "Title *",
    "phResumeCourt": "Short summary",
    "labelType": "Type",
    "labelGravite": "Severity",
    "labelCategorie": "Category *",
    "labelPage": "Page / tab affected *",
    "labelFonctionnalite": "Feature *",
    "labelPreciser": "Specify *",
    "phPreciser": "What is it about?",
    "labelPlateforme": "Platform",
    "labelVersion": "App version",
    "labelContexte": "Context",
    "phContexte": "What happened…",
    "labelEtapes": "Steps to reproduce",
    "phEtapes": "1. … 2. …",
    "labelComportement": "Expected behavior",
    "phComportement": "What should happen…",
    "labelNiveauConfiance": "Confidence level",
    "labelCaptures": "Screenshots *",
    "hint": "Required: title, category (+ details) and at least one screenshot. 🔖 saves, ✈️ submits."
  },
  "erreur": {
    "titre": "Oops, a display problem",
    "message": "The app ran into an error on this screen, but it isn't lost. Tap “Retry” to go back.",
    "reessayer": "Retry",
    "detailLabel": "Details (to send to support):",
    "inattendue": "Unexpected error"
  },
  "horsLigne": {
    "message": "Unstable connection — the app stays usable; your changes will sync when the network is back."
  },
  "pub": {
    "simulation": "SIMULATION",
    "titre": "Full-screen ad",
    "sousTitre": "This space will be filled by a real ad.",
    "dimensions": "Interstitial · 320 × 480 px",
    "accessibilite": "Advertisement (simulation)",
    "annonce": "Ad",
    "titreBanniere": "Your ad here",
    "sousBanniere": "Banner placement · simulation"
  },
  "selecteurLieu": {
    "placeholder": "Choose a place…",
    "titre": "Calendar places",
    "vide": "No place saved.",
    "videAjout": "Add some in Family → Places.",
    "aucun": "None"
  },
  "forfait": {
    "lim_calendriers": "Calendars",
    "lim_evenementsParJour": "Events / day",
    "lim_piecesJointes": "Attachments / event",
    "lim_demandesParMois": "Requests / month",
    "lim_historiqueDays": "History (days)",
    "opt_exportPdf": "PDF export",
    "opt_syncCalendrier": "Calendar sync",
    "groupeCore": "Core — shared across the suite",
    "groupeApp": "App — {nom}",
    "cetteApp": "this app",
    "aLaCarte": "add-on",
    "indisponible": "unavailable",
    "fonctionsActivation": "Features & activation",
    "intro": "Turn features on or off to prepare the plans. The required tier and add-on options are shown. Plan configuration stays managed by the administrator.",
    "aucuneFonction": "No feature declared.",
    "monForfait": "My plan",
    "monForfaitAide": "Your plan determines which features are available. Tap another plan to request it.",
    "plan_essentiel": "Essential",
    "plan_pro": "Pro",
    "actuel": "Current",
    "nFonctions": "{n} feature(s) included",
    "contenuNonConfigure": "Contents to be defined",
    "demander": "Request",
    "demanderTitre": "Request a plan",
    "demanderMsg": "Send a request for the “{plan}” plan? It will be reviewed by the team.",
    "demandeEnCours": "Pending request: {plan}",
    "validationAide": "A free plan changes after review by the team. A paid plan activates right away after payment, no review needed.",
    "payer": "Pay {prix} €/month",
    "passerGratuit": "Switch to free",
    "passerGratuitTitre": "Switch to free",
    "passerGratuitMsg": "Your subscription is cancelled immediately and your plan switches back to free. Confirm?",
    "erreurPaiement": "Couldn't open the payment page. Try again in a moment.",
    "featJetons": "{g} manageable item(s) + {v} view-only",
    "featFonctions": "{n} feature(s) included",
    "featPieces": "{n} attachment(s) per month",
    "featHistorique": "History: {n} days",
    "featExportPdf": "PDF export",
    "featSync": "Calendar sync",
    "featSansPub": "No ads",
    "featSansPubPleinEcran": "No full-screen ads",
    "parMois": "/month",
    "demandeEnvoyee": "Request sent",
    "desactivee": "turned off by you",
    "toujoursIncluse": "always included",
    "sansEffet": "turned off, but with no effect",
    "surchargeRequise": "These switches only apply when « Override features (IVV) » is on in your profile. Without it, the plan alone decides.",
    "indispensable": "essential",
    "demandeAchatsEnCours": "À la carte request pending",
    "demandeAchatsAide": "Awaiting the team's approval. No payment is charged during the test phase.",
    "aLaCarteIntro": "Your plan includes {n} point(s) to spend freely below, on top of what it already gives you.",
    "aLaCarteAucune": "Nothing extra to add — everything purchasable is already included in your plan.",
    "aLaCarteQuotasIntro": "Caps (calendars, elements, spaces…)",
    "aLaCartePoints": "{n} point(s) total ({inclus} included by the plan)",
    "envoyerDemande": "Send request",
    "aLaCarte": "À la carte",
    "aLaCarteSous": "Functions and caps on top of the plan"
  },
  "apprentissage": {
    "titre": "Tutorial & Practice",
    "intro": "Learn to use each feature: read the tutorial, then put it into practice. A practice collapses so you can go do the action in the app, then come back and tick it off.",
    "progression": "Your progress",
    "tutoriels": "Tutorials",
    "misesEnPratique": "Practice",
    "vus": "Seen",
    "aVoir": "To see",
    "faites": "Done",
    "aFaire": "To do",
    "voir": "View",
    "revoir": "Review",
    "faire": "Do",
    "refaire": "Redo",
    "mepAVenir": "Practice coming soon.",
    "mepCompteur": "Practice · {n}/{tot}",
    "termine": " · done ✓",
    "grp_general": "General & account",
    "grp_calendrier": "Calendar & events",
    "grp_echanger": "Share as a family",
    "grp_organiser": "Organise time",
    "grp_maison": "Everyday home",
    "grp_memoire": "Memory & tracking",
    "etapeFaite": "Done",
    "indice": "Hint",
    "sExercer": "Practice",
    "enCours": "in progress"
  },
  "version": {
    "enAttente": "pending…",
    "aJour": "up to date",
    "mettreAJour": "update"
  },
  "comptes": {
    "titre": "My accounts",
    "sessionExpiree": "Session expired for this account. Add it again.",
    "basculeImpossible": "Unable to switch.",
    "retraitImpossible": "Unable to remove.",
    "identifiantsRequis": "Email and password required.",
    "connexionImpossible": "Unable to sign in.",
    "retirerCompte": "Remove this account",
    "email": "Email",
    "motDePasse": "Password",
    "masquerMdp": "Hide password",
    "afficherMdp": "Show password",
    "ajouterCompte": "Add an account",
    "note": "Your sessions stay on this device. Switching works without re-entering your password."
  },
  "ferie": {
    "jourAn": "New Year's Day",
    "lundiPaques": "Easter Monday",
    "feteTravail": "Labour Day",
    "victoire1945": "Victory in Europe Day",
    "ascension": "Ascension Day",
    "lundiPentecote": "Whit Monday",
    "feteNationale": "Bastille Day",
    "assomption": "Assumption Day",
    "toussaint": "All Saints' Day",
    "armistice1918": "Armistice Day",
    "noel": "Christmas Day"
  },
  "acces": {
    "titre": "Access",
    "sousTitre": "One member per item, one level each",
    "intro": "By default, an item is only visible to you. Add a member to its list, then choose their level. The owner always keeps full access.",
    "proprietaireComplet": "Owner: me · full access",
    "personneDautre": "No one else yet.",
    "ajouterAcces": "Add access",
    "toutEspace": "Everyone in the space",
    "niveauLecteur": "Viewer",
    "niveauLecteurDesc": "Views, changes nothing",
    "niveauContributeur": "Contributor",
    "niveauContributeurDesc": "Adds and edits content (events, articles, storage)",
    "niveauGestionnaire": "Manager",
    "niveauGestionnaireDesc": "Content, configuration and access management",
    "ajoutTitre": "Add access",
    "modifierTitre": "Edit access",
    "qui": "Who",
    "niveau": "Level",
    "retirerAcces": "Remove access",
    "retirerAccesMsg": "{nom} will no longer have access to \"{titre}\".",
    "aucunMembreDispo": "Every member already has access.",
    "moi": "Me",
    "aucunMembreEspace": "No member in the space. Invite some in \"Space members\".",
    "niveauAucun": "No access",
    "niveauAucunDesc": "No longer sees this resource (removes access on save)"
  },
  "aideCal": {
    "titreCal": "The calendar",
    "introCal": "Three views: Month (round day chips), Week and Day (time grid). Long-press the Calendar tab to open the related features (Requests, Settings, Recurring, Holidays, Custody).",
    "s1t": "Multiple calendars",
    "s1x": "The ACTIVE calendar shows on the right of the filter bar — tap it (or double-tap the Calendar tab) to open the picker: ★ sets the active one, 👁 overlays other calendars. Full management lives in Profile → “My calendars”, and access rights in Profile → “Who sees what”.",
    "s2t": "Day gestures (Month view)",
    "s2x": "Tap selects the day. Double-tap switches custody to the other parent (co-parenting — may create a request to confirm). Long-press opens the day's event list.",
    "s3t": "Week and Day views",
    "s3x": "Long-press a day header: the day's event list. Long-press a time slot: a pre-filled new event. Pinch: grid zoom. Tapping the active view again toggles icon ↔ name display.",
    "s4t": "Multi-day events",
    "s4x": "Month view: a continuous bar in the event's color above the covered days. Week/Day: a covering block side by side with other events (Outlook style), start and end always shown (DD/MM date when on another day).",
    "s5t": "Filters and outside the range",
    "s5x": "Two filters on top: Categories and Types (one-off, recurring — meals and timetable coming). Events outside the configured hours extend the grid (adjustable in Settings → Display).",
    "tutoT": "First tour of the calendar",
    "tutoE1": "Pick the Month, Week or Day view at the top.",
    "tutoE2": "Tap a day then ＋ to add an event (end time required, or “All day”).",
    "tutoE3": "Long-press the Calendar tab → Settings for the hour range, zoom and calendar type.",
    "titreVac": "School holidays",
    "introVac": "The list of holiday periods and public holidays, independent from custody. Choose your zone and year, then tap ⬇️ to add the official periods (no duplicates).",
    "vac1t": "View / edit",
    "vac1x": "Tap a period to open its sheet (dates, length, halves). Swipe to delete; ✏️ to change name and dates.",
    "vac2t": "Holiday custody",
    "vac2x": "The ½1 / ½2 split between parents is set in “Custody” (holiday custody periods), not here.",
    "titreGardes": "Custody",
    "introGardes": "Two timelines: the schedule OUTSIDE holidays (alternating week, 2-2-3, custom patterns…) and HOLIDAY custody (who gets the 1st half depending on even/odd year). Custody is computed on display — only your manual swaps are stored.",
    "g1t": "“From … to …” periods",
    "g1x": "Each schedule or holiday custody covers a period (start → end, or “no end”). ➕ to add one, swipe to edit/delete, and the “✓ Apply” chip enables or suspends it.",
    "g2t": "Exceptions",
    "g2x": "Days whose custody differs from the computed schedule appear as “exceptions” under each period: days per parent, year/month filter, and “Reset all”.",
    "titreDem": "Custody requests",
    "introDem": "When two parents are declared, changing a day's custody (double-tap in Month view) creates a request the other parent must confirm.",
    "d1t": "Propose",
    "d1x": "Double-tap a day in Month view → a request is sent to the other parent. You can cancel yours while it's pending.",
    "d2t": "Confirm",
    "d2x": "Open “Requests” (long-press the tab): Confirm ✓ applies the change, Decline cancels it."
  },
  "mep": {
    "calPremEvtT": "Create a first event",
    "calPremEvtS": "With a start and end time",
    "calPremEvt1": "Open the Calendar and tap a day to select it.",
    "calPremEvt2": "Tap ＋ at the top right: give the event a title.",
    "calPremEvt3": "Pick the start time then the end time (required, unless “All day”).",
    "calPremEvt4": "Save 💾 then find your event: a dot under the day (Month), a block in the grid (Week/Day).",
    "calVuesT": "Navigate between views",
    "calVuesS": "Month, Week, Day",
    "calVues1": "Switch to the Week view with the selector at the top.",
    "calVues2": "Double-tap a day in the header: you switch to the Day view.",
    "calVues3": "Long-press a day header: its event list opens.",
    "calVues4": "Go back to Month and long-press a day: same list. Done!",
    "calFiltT": "Filter the calendar",
    "calFiltS": "Categories and types",
    "calFilt1": "Tap “Categories” above the calendar and uncheck a category: its events disappear.",
    "calFilt2": "The chip shows how many are hidden. Check again to show everything.",
    "calFilt3": "Do the same with “Types” (one-off / recurring).",
    "calGardeT": "Swap a custody day",
    "calGardeS": "Co-parenting calendar",
    "calGarde1": "On a co-parenting calendar, go to the Month view.",
    "calGarde2": "Double-tap a day: custody switches to the other parent (or creates a request to confirm).",
    "calGarde3": "The day outline takes the original custody color: it's an exception. Double-tap again to return to the schedule.",
    "invPremT": "Create a first inventory",
    "invPremS": "From a template",
    "invPrem1": "Open Inventories and tap ＋ at the top right.",
    "invPrem2": "Pick a ready-made template (e.g. Cupboards & fridge) or “Empty inventory”, give it a title.",
    "invPrem3": "Save: your inventory appears with its categories.",
    "invElemT": "Add and count an item",
    "invElemS": "Quantity and threshold",
    "invElem1": "Open your inventory and tap ＋ to create an item in a category.",
    "invElem2": "Set its quantity with − / ＋, and an alert threshold if needed.",
    "invElem3": "Back to the list: the category counter reflects your additions.",
    "invScanT": "Scan a product",
    "invScanS": "Barcode → pre-filled sheet",
    "invScan1": "In an inventory, tap 📷 (scan).",
    "invScan2": "Aim at a product barcode: if known, the name fills in automatically.",
    "invScan3": "Confirm: the article is created with its code. Done!"
  },
  "erreurs": {
    "heureFinAvantDebut": "End time must be after start time.",
    "dateFinAvantDebut": "End date must be after start date."
  },
  "avenir": {
    "bientot": "{nom} is coming soon.",
    "bientotCourt": "soon",
    "migration": "Screen ready — feature being migrated from MoPCal.",
    "destination": "Destination",
    "perimetre": "Planned scope",
    "dest": {
      "core": "Core (all apps)",
      "mycalendar": "My Calendar",
      "meals": "My Meals",
      "finance": "My Finance",
      "transverse": "Cross-app"
    },
    "f": {
      "messagerie": [
        "Space and per-calendar conversations",
        "Photos, files and camera",
        "Notifications",
        "Plan-based sub-features"
      ],
      "journal": [
        "Dated entries per calendar",
        "Daily photos and notes",
        "Timeline",
        "Search and filters"
      ],
      "statistiques": [
        "Custody split (days, nights, holidays)",
        "Event counters by category and type",
        "Period comparison",
        "Figures export"
      ],
      "historique": [
        "Space activity log",
        "Filters by feature and member",
        "Per-item view"
      ],
      "listes": [
        "Shared task lists",
        "Quantities, units, photos and comments",
        "Per-person rights",
        "Done / total counter"
      ],
      "repas": [
        "Weekly menu in read-only in My Calendar",
        "Planned meals = meal-type events",
        "Full editing (recipes, composition, slots) in My Meals"
      ],
      "courses": [
        "List generated from the weekly menu",
        "In-store check-off from My Calendar",
        "Prices, totals and aisles in My Meals"
      ],
      "contacts": [
        "Space contact cards",
        "Address with map and directions",
        "Custom fields (predefined + personal)"
      ],
      "lieux": [
        "Saved places of the space",
        "Map and directions",
        "Linking to events"
      ],
      "finances": [
        "Budget lines per calendar",
        "Expenses, income and recurring items",
        "Split between parents and who owes whom",
        "Repayments",
        "Upcoming months projection",
        "Summaries and exports"
      ],
      "exports": [
        "Weekly menu PDF (recipes + groceries)",
        "Grocery list export",
        "Calendar export (iCal)",
        "Data export (JSON)"
      ],
      "edt": [
        "Weekly template grid (A/B weeks)",
        "Slots per child / calendar",
        "Timetable events in the calendar",
        "Exceptions and special days"
      ],
      "appmeals": [
        "Recipes and composition (ingredients, extras)",
        "Recipe categories",
        "Weekly menus and meal slots",
        "Grocery list generation",
        "Product catalog, prices and scan",
        "Meals visible in My Calendar",
        "Menu PDF export"
      ],
      "appfinance": [
        "Budget lines per calendar and per space",
        "Expenses, income, recurring operations",
        "Split between parents, who owes whom",
        "Repayments",
        "Projection and monthly summaries",
        "Exports"
      ]
    }
  },
  "filtres": {
    "titre": "Filters",
    "reinitialiser": "Reset",
    "aide": "Check what you want to see. Filters apply when you save; the arrow resets everything.",
    "toutCocher": "Check all",
    "toutDecocher": "Uncheck all"
  },
  "jetons": {
    "titre": "Visible items selection",
    "sousTitre": "{n} item(s) selected",
    "aide": "Tap ⚙️ to MANAGE an item, 👁 to VIEW it only (tapping the active mode drops it), 🎁 to grant it to someone. Above, the QUEUE: one line per token spent, ordered with ▲ — if tokens go away, the bottom drops.",
    "mensuelAide": "Adding an item is allowed once a month. Removing, reordering or taking back a granted token stays free.",
    "donsEnCours": "{n} token(s) granted to someone: they still count against yours.",
    "aucunElement": "No item of this kind",
    "enGestion": "Managed (editable)",
    "enConsultation": "View only",
    "nonRetenu": "Not selected",
    "retrograde": "downgraded to view-only",
    "confieParAutre": "Granted by its owner (free for you)",
    "joursRestants": "{n} d before it closes",
    "confierA": "Grant to",
    "confierAide": "The token stays counted against yours until you take it back. The person will manage this item without spending their own.",
    "aucunMembre": "No other member in this space",
    "offrir": "Grant",
    "offrirQuoi": "Which item?",
    "offrirQuoiDroit": "What are you granting?",
    "offrirGestion": "Management (costs a ⚙️ token)",
    "offrirVue": "View only (costs a 👁 token)",
    "offertA": "Granted ({nature}): the token still counts against yours",
    "file": "My token queue (by priority)",
    "pourMoi": "For me",
    "pourQui": "Granted to {qui}",
    "ecarte": "dropped, no token left",
    "aussiOffert": "also granted ({nature})",
    "donProprietaireSeul": "Only the owner of this item can grant it.",
    "donHorsForfait": "« Grant an item » is not included in your plan.",
    "accesLecture": "read-only (granted right)",
    "lectureSeuleAcces": "The owner granted you READ access only on this item: even with a ⚙️ token it would stay view-only.",
    "accesAide": "A ⚙️ token does not grant editing: the owner must also have given you write access. Selection never overrides rights — the effective right is the stricter of the two.",
    "espaceDe": "Space",
    "espaceInconnu": "(unknown space)",
    "proprietaire": "Owner",
    "moi": "Me",
    "autreMembre": "Another member",
    "monRole": "My role",
    "contenu": "Contents",
    "nElements": "{n} item(s)",
    "espaceVide": "This space has no item yet.",
    "creationBloquee": "Item limit reached ({n}/{max}): delete an item to create another one. Removing it from the visible list is not enough.",
    "compteurElements": "{n}/{max} items owned",
    "comptageIncomplet": "count incomplete, creation paused",
    "modeConfiguration": "Configure (editable)",
    "modeVisualisation": "View only",
    "donSansJeton": "No free token left: take one back or release an item before gifting."
  },
  "suppr": {
    "emporte": "This also deletes {n} item(s):",
    "f_evenements": "event(s)",
    "f_garde": "custody day(s)",
    "f_edt": "timetable item(s)",
    "f_listes": "list(s) and tasks",
    "f_finances": "finance item(s)",
    "f_journal": "journal note(s)",
    "f_contacts": "contact(s)",
    "f_messagerie": "message(s) and chat(s)",
    "f_demandes": "request(s)",
    "f_repas": "meal item(s)",
    "f_historique": "history entr(y/ies)"
  }
}
